/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as errorRouteRouteImport } from './routes/(error)/route'
import { Route as meetRouteRouteImport } from './routes/(meet)/route'
import { Route as memberRouteRouteImport } from './routes/(member)/route'
import { Route as payRouteRouteImport } from './routes/(pay)/route'
import { Route as AdminRouteRouteImport } from './routes/admin/route'
import { Route as BirdieRouteRouteImport } from './routes/birdie/route'
import { Route as DocumentRouteRouteImport } from './routes/document/route'
import { Route as OfficeRouteRouteImport } from './routes/office/route'
import { Route as authActivateRouteImport } from './routes/(auth)/activate'
import { Route as authAutoSignInRouteImport } from './routes/(auth)/auto-sign-in'
import { Route as authForgotPasswordRouteImport } from './routes/(auth)/forgot-password'
import { Route as authForgotPasswordOtpRouteImport } from './routes/(auth)/forgot-password-otp'
import { Route as authResetPasswordRouteImport } from './routes/(auth)/reset-password'
import { Route as authResetPasswordInvalidRouteImport } from './routes/(auth)/reset-password-invalid'
import { Route as authResetPasswordSuccessRouteImport } from './routes/(auth)/reset-password-success'
import { Route as authSignInRouteImport } from './routes/(auth)/sign-in'
import { Route as authSignInImRouteImport } from './routes/(auth)/sign-in-im'
import { Route as authSignInOtpRouteImport } from './routes/(auth)/sign-in-otp'
import { Route as authSignInPasswordRouteImport } from './routes/(auth)/sign-in-password'
import { Route as devMediaV3UploadRouteImport } from './routes/(dev)/media-v3-upload'
import { Route as errorPageForbiddenRouteImport } from './routes/(error)/page-forbidden'
import { Route as errorPageNotFoundRouteImport } from './routes/(error)/page-not-found'
import { Route as memberprotectedRouteRouteImport } from './routes/(member)/(protected)/route'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminGlobalBirdieChatRouteImport } from './routes/admin/global-birdie-chat'
import { Route as AdminLocationsRouteImport } from './routes/admin/locations'
import { Route as AdminServiceAreasRouteImport } from './routes/admin/service-areas'
import { Route as BirdieIndexRouteImport } from './routes/birdie/index'
import { Route as CustomAppMigateToQuoteRouteImport } from './routes/custom-app/migate-to-quote'
import { Route as CustomAppMigrateToQuoteRouteImport } from './routes/custom-app/migrate-to-quote'
import { Route as DocumentIndexRouteImport } from './routes/document/index'
import { Route as DocumentSlugRouteImport } from './routes/document/$slug'
import { Route as HomecareProposalProposalIdRouteImport } from './routes/homecare-proposal.$proposalId'
import { Route as OfficeIndexRouteImport } from './routes/office/index'
import { Route as OfficeConnectGgCalendarRouteImport } from './routes/office/connect-gg-calendar'
import { Route as OfficeGlobalBirdieChatRouteImport } from './routes/office/global-birdie-chat'
import { Route as OfficeGlobalSearchRouteImport } from './routes/office/global-search'
import { Route as OfficeInboxRouteImport } from './routes/office/inbox'
import { Route as OfficeManageAccountRouteImport } from './routes/office/manage-account'
import { Route as OfficeQuotesRouteImport } from './routes/office/quotes'
import { Route as OfficeSearchRouteImport } from './routes/office/search'
import { Route as VLinkCodeRouteImport } from './routes/v.$linkCode'
import { Route as devThemesIndexRouteImport } from './routes/(dev)/themes/index'
import { Route as meetMeetRoomNameRouteImport } from './routes/(meet)/meet.$roomName'
import { Route as memberprotectedMyRouteImport } from './routes/(member)/(protected)/my'
import { Route as memberpublicJoinRouteImport } from './routes/(member)/(public)/join'
import { Route as payPayTokenRouteImport } from './routes/(pay)/pay.$token'
import { Route as AdminAccountsIndexRouteImport } from './routes/admin/accounts.index'
import { Route as AdminAuthorizationIndexRouteImport } from './routes/admin/authorization.index'
import { Route as AdminAuthorizationRoleKeyRouteImport } from './routes/admin/authorization.$roleKey'
import { Route as AdminAuthorizationCreateRouteImport } from './routes/admin/authorization.create'
import { Route as AdminCampaignsIndexRouteImport } from './routes/admin/campaigns.index'
import { Route as AdminCampaignsCampaignIdRouteImport } from './routes/admin/campaigns.$campaignId'
import { Route as AdminCampaignsCreateRouteImport } from './routes/admin/campaigns.create'
import { Route as AdminCheckoutLinksIndexRouteImport } from './routes/admin/checkout-links.index'
import { Route as AdminCheckoutLinksCreateRouteImport } from './routes/admin/checkout-links.create'
import { Route as AdminCustomersIndexRouteImport } from './routes/admin/customers.index'
import { Route as AdminCustomersCustomerIdRouteImport } from './routes/admin/customers.$customerId'
import { Route as AdminCustomersCreateRouteImport } from './routes/admin/customers.create'
import { Route as AdminHomecarePlanProposalsIndexRouteImport } from './routes/admin/homecare-plan-proposals.index'
import { Route as AdminLocationsCreateRouteImport } from './routes/admin/locations.create'
import { Route as AdminPurchaseIntentsIndexRouteImport } from './routes/admin/purchase-intents.index'
import { Route as AdminSubscriptionsIndexRouteImport } from './routes/admin/subscriptions.index'
import { Route as AdminSubscriptionsCreateRouteImport } from './routes/admin/subscriptions.create'
import { Route as AdminTagsIndexRouteImport } from './routes/admin/tags.index'
import { Route as AdminUsersIndexRouteImport } from './routes/admin/users.index'
import { Route as AdminUsersCreateRouteImport } from './routes/admin/users.create'
import { Route as AdminUsersManagersRouteImport } from './routes/admin/users.managers'
import { Route as AdminUsersMembersRouteImport } from './routes/admin/users.members'
import { Route as AdminUsersTechniciansRouteImport } from './routes/admin/users.technicians'
import { Route as AdminVisitsIndexRouteImport } from './routes/admin/visits.index'
import { Route as AdminVisitsAvailableTimeSlotsRouteImport } from './routes/admin/visits.available-time-slots'
import { Route as BirdieSessionsIndexRouteImport } from './routes/birdie/sessions.index'
import { Route as BirdieSessionsSessionIdRouteImport } from './routes/birdie/sessions.$sessionId'
import { Route as OfficeBillingTodoRouteImport } from './routes/office/billing.todo'
import { Route as OfficeCatalogNewIndexRouteImport } from './routes/office/catalog-new.index'
import { Route as OfficeCatalogNewCatalogItemIdRouteImport } from './routes/office/catalog-new.$catalogItemId'
import { Route as OfficeNotificationsIndexRouteImport } from './routes/office/notifications.index'
import { Route as OfficeOrdersIndexRouteImport } from './routes/office/orders.index'
import { Route as OfficeOrdersOrderIdRouteImport } from './routes/office/orders.$orderId'
import { Route as OfficeOrdersActiveRouteImport } from './routes/office/orders.active'
import { Route as OfficeOrdersAllRouteImport } from './routes/office/orders.all'
import { Route as OfficeOrdersCreateRouteImport } from './routes/office/orders.create'
import { Route as OfficeOrdersFutureRouteImport } from './routes/office/orders.future'
import { Route as OfficeOrdersWorkflowRouteImport } from './routes/office/orders.workflow'
import { Route as OfficePlacesIndexRouteImport } from './routes/office/places.index'
import { Route as OfficePlacesPlaceIdRouteImport } from './routes/office/places.$placeId'
import { Route as OfficePlacesActiveRouteImport } from './routes/office/places.active'
import { Route as OfficePlacesAllRouteImport } from './routes/office/places.all'
import { Route as OfficePlacesCreateRouteImport } from './routes/office/places.create'
import { Route as OfficeReportsIndexRouteImport } from './routes/office/reports.index'
import { Route as OfficeReportsAiFeedbackRouteImport } from './routes/office/reports.ai-feedback'
import { Route as OfficeReportsConfirmedChurnRouteImport } from './routes/office/reports.confirmed-churn'
import { Route as OfficeReportsHomecareRenewalsRouteImport } from './routes/office/reports.homecare-renewals'
import { Route as OfficeReportsMemberActivationRouteImport } from './routes/office/reports.member-activation'
import { Route as OfficeReportsOneOffRevenueRouteImport } from './routes/office/reports.one-off-revenue'
import { Route as OfficeReportsOrderOverviewRouteImport } from './routes/office/reports.order-overview'
import { Route as OfficeReportsRevenueRouteImport } from './routes/office/reports.revenue'
import { Route as OfficeReportsVendorScorecardRouteImport } from './routes/office/reports.vendor-scorecard'
import { Route as OfficeScheduleIndexRouteImport } from './routes/office/schedule.index'
import { Route as OfficeSmartActionsIndexRouteImport } from './routes/office/smart-actions.index'
import { Route as OfficeSmartActionsAccuracyRouteImport } from './routes/office/smart-actions.accuracy'
import { Route as OfficeSmartActionsBoardRouteImport } from './routes/office/smart-actions.board'
import { Route as OfficeSmartActionsForecastRouteImport } from './routes/office/smart-actions.forecast'
import { Route as OfficeSmartActionsLostCostsRouteImport } from './routes/office/smart-actions.lost-costs'
import { Route as OfficeTasksIndexRouteImport } from './routes/office/tasks.index'
import { Route as OfficeTasksCreateRouteImport } from './routes/office/tasks.create'
import { Route as OfficeVendorsIndexRouteImport } from './routes/office/vendors.index'
import { Route as OfficeVendorsCreateRouteImport } from './routes/office/vendors.create'
import { Route as OfficeVendorsVisitsRouteImport } from './routes/office/vendors.visits'
import { Route as VendorsOnboardingV1RouteRouteImport } from './routes/vendors/onboarding/v1/route'
import { Route as meetMeetJoinRoomNameRouteImport } from './routes/(meet)/meet.join.$roomName'
import { Route as memberprotectedMyIndexRouteImport } from './routes/(member)/(protected)/my.index'
import { Route as memberprotectedMyBirdieRouteImport } from './routes/(member)/(protected)/my.birdie'
import { Route as memberprotectedMyCartRouteImport } from './routes/(member)/(protected)/my.cart'
import { Route as memberprotectedMyChatsRouteImport } from './routes/(member)/(protected)/my.chats'
import { Route as memberprotectedMyDownloadRouteImport } from './routes/(member)/(protected)/my.download'
import { Route as memberprotectedMyDownloadAppRouteImport } from './routes/(member)/(protected)/my.download-app'
import { Route as memberprotectedMyFeedbackRouteImport } from './routes/(member)/(protected)/my.feedback'
import { Route as memberprotectedMyGlobalSearchRouteImport } from './routes/(member)/(protected)/my.global-search'
import { Route as memberprotectedMyHelpRouteImport } from './routes/(member)/(protected)/my.help'
import { Route as memberprotectedMyHomeRouteImport } from './routes/(member)/(protected)/my.home'
import { Route as memberprotectedMyOnboardingRouteImport } from './routes/(member)/(protected)/my.onboarding'
import { Route as memberprotectedMyRecordsRouteImport } from './routes/(member)/(protected)/my.records'
import { Route as memberprotectedMySettingsRouteImport } from './routes/(member)/(protected)/my.settings'
import { Route as memberprotectedMyVerifyPhoneRouteImport } from './routes/(member)/(protected)/my.verify-phone'
import { Route as memberpublicInviteTokenRouteImport } from './routes/(member)/(public)/invite.$token'
import { Route as memberpublicJoinIndexRouteImport } from './routes/(member)/(public)/join.index'
import { Route as memberpublicJoinSignUpRouteImport } from './routes/(member)/(public)/join.sign-up'
import { Route as memberpublicJoinVerifyRouteImport } from './routes/(member)/(public)/join.verify'
import { Route as memberpublicPresaleSplatRouteImport } from './routes/(member)/(public)/presale.$'
import { Route as AdminUsersManagersCreateRouteImport } from './routes/admin/users.managers.create'
import { Route as AdminUsersMembersCreateRouteImport } from './routes/admin/users.members.create'
import { Route as AdminUsersTechniciansCreateRouteImport } from './routes/admin/users.technicians.create'
import { Route as OfficeBillingInvoicesIndexRouteImport } from './routes/office/billing.invoices.index'
import { Route as OfficePlacesOnboardingIndexRouteImport } from './routes/office/places.onboarding.index'
import { Route as VendorsOnboardingV1Step0WelcomeRouteImport } from './routes/vendors/onboarding/v1/step-0-welcome'
import { Route as VendorsOnboardingV1Step1BusinessInfoRouteImport } from './routes/vendors/onboarding/v1/step-1-business-info'
import { Route as VendorsOnboardingV1Step2LegalComplianceRouteImport } from './routes/vendors/onboarding/v1/step-2-legal-compliance'
import { Route as VendorsOnboardingV1Step3ServiceTermRouteImport } from './routes/vendors/onboarding/v1/step-3-service-term'
import { Route as VendorsOnboardingV1Step4AddTechnicianRouteImport } from './routes/vendors/onboarding/v1/step-4-add-technician'
import { Route as VendorsOnboardingV1Step5ReviewInformationRouteImport } from './routes/vendors/onboarding/v1/step-5-review-information'
import { Route as VendorsOnboardingV1StepFinalSubmitRouteImport } from './routes/vendors/onboarding/v1/step-final-submit'
import { Route as memberprotectedMyCampaignsCampaignSlugRouteImport } from './routes/(member)/(protected)/my.campaigns.$campaignSlug'
import { Route as memberprotectedMyCheckoutIndexRouteImport } from './routes/(member)/(protected)/my.checkout.index'
import { Route as memberprotectedMyCheckoutCheckoutIdRouteImport } from './routes/(member)/(protected)/my.checkout.$checkoutId'
import { Route as memberprotectedMyCheckoutSuccessRouteImport } from './routes/(member)/(protected)/my.checkout.success'
import { Route as memberprotectedMyFeedbackIndexRouteImport } from './routes/(member)/(protected)/my.feedback.index'
import { Route as memberprotectedMyFeedbackFeedbackIdRouteImport } from './routes/(member)/(protected)/my.feedback.$feedbackId'
import { Route as memberprotectedMyListIndexRouteImport } from './routes/(member)/(protected)/my.list.index'
import { Route as memberprotectedMyListArchivedRouteImport } from './routes/(member)/(protected)/my.list.archived'
import { Route as memberprotectedMyOrdersOrderIdRouteImport } from './routes/(member)/(protected)/my.orders.$orderId'
import { Route as memberprotectedMyOrdersCreateRouteImport } from './routes/(member)/(protected)/my.orders.create'
import { Route as memberprotectedMyPlacesIndexRouteImport } from './routes/(member)/(protected)/my.places.index'
import { Route as memberprotectedMyPlacesAddRouteImport } from './routes/(member)/(protected)/my.places.add'
import { Route as memberprotectedMyPlacesExistRouteImport } from './routes/(member)/(protected)/my.places.exist'
import { Route as memberprotectedMyQuotesQuoteIdRouteImport } from './routes/(member)/(protected)/my.quotes.$quoteId'
import { Route as memberprotectedMyRequestsSubmitRouteImport } from './routes/(member)/(protected)/my.requests.submit'
import { Route as memberprotectedMySettingsIndexRouteImport } from './routes/(member)/(protected)/my.settings.index'
import { Route as memberpublicInviteTokenIndexRouteImport } from './routes/(member)/(public)/invite.$token.index'
import { Route as memberpublicInviteTokenSignUpRouteImport } from './routes/(member)/(public)/invite.$token.sign-up'
import { Route as memberpublicInviteTokenSuccessRouteImport } from './routes/(member)/(public)/invite.$token.success'
import { Route as memberpublicInviteTokenVerifyRouteImport } from './routes/(member)/(public)/invite.$token.verify'
import { Route as memberpublicPublicOrdersOrderIdRouteImport } from './routes/(member)/(public)/public.orders.$orderId'
import { Route as OfficeBillingAccountsAccountIdWalletRouteImport } from './routes/office/billing.accounts.$accountId.wallet'
import { Route as OfficeBillingInvoicesInvoiceIdEditRouteImport } from './routes/office/billing.invoices.$invoiceId.edit'
import { Route as memberprotectedMySettingsAccountBillingRouteImport } from './routes/(member)/(protected)/my.settings.account.billing'
import { Route as memberprotectedMySettingsAccountNotificationsRouteImport } from './routes/(member)/(protected)/my.settings.account.notifications'
import { Route as memberprotectedMySettingsAccountProfileRouteImport } from './routes/(member)/(protected)/my.settings.account.profile'
import { Route as memberprotectedMySettingsAccountSecurityRouteImport } from './routes/(member)/(protected)/my.settings.account.security'
import { Route as memberprotectedMySettingsHouseholdMembersRouteImport } from './routes/(member)/(protected)/my.settings.household.members'
import { Route as memberprotectedMySettingsHouseholdMembershipRouteImport } from './routes/(member)/(protected)/my.settings.household.membership'
import { Route as memberprotectedMySettingsAccountBillingIndexRouteImport } from './routes/(member)/(protected)/my.settings.account.billing.index'
import { Route as memberprotectedMySettingsAccountBillingPaymentsRouteImport } from './routes/(member)/(protected)/my.settings.account.billing.payments'
import { Route as memberprotectedMySettingsAccountBillingWalletRouteImport } from './routes/(member)/(protected)/my.settings.account.billing.wallet'
import { Route as memberprotectedMySettingsAccountInvoicesIndexRouteImport } from './routes/(member)/(protected)/my.settings.account.invoices.index'
import { Route as memberprotectedMySettingsAccountInvoicesInvoiceIdRouteImport } from './routes/(member)/(protected)/my.settings.account.invoices.$invoiceId'
import { Route as memberprotectedMySettingsAccountBillingPaymentsIndexRouteImport } from './routes/(member)/(protected)/my.settings.account.billing.payments.index'
import { Route as memberprotectedMySettingsAccountBillingPaymentsPaymentMethodIdRouteImport } from './routes/(member)/(protected)/my.settings.account.billing.payments.$paymentMethodId'
import { Route as memberprotectedMySettingsAccountBillingPaymentsHistoryRouteImport } from './routes/(member)/(protected)/my.settings.account.billing.payments.history'
import { Route as memberprotectedMySettingsAccountBillingWalletIndexRouteImport } from './routes/(member)/(protected)/my.settings.account.billing.wallet.index'
import { Route as memberprotectedMySettingsAccountBillingWalletHistoryRouteImport } from './routes/(member)/(protected)/my.settings.account.billing.wallet.history'
import { Route as memberprotectedMySettingsAccountBillingPaymentsHistoryTransactionIdRouteImport } from './routes/(member)/(protected)/my.settings.account.billing.payments.history_.$transactionId'
import { Route as memberprotectedMySettingsAccountBillingWalletHistoryWalletItemIdRouteImport } from './routes/(member)/(protected)/my.settings.account.billing.wallet.history_.$walletItemId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const errorRouteRoute = errorRouteRouteImport.update({
  id: '/(error)',
  getParentRoute: () => rootRouteImport,
} as any)
const meetRouteRoute = meetRouteRouteImport.update({
  id: '/(meet)',
  getParentRoute: () => rootRouteImport,
} as any)
const memberRouteRoute = memberRouteRouteImport.update({
  id: '/(member)',
  getParentRoute: () => rootRouteImport,
} as any)
const payRouteRoute = payRouteRouteImport.update({
  id: '/(pay)',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRouteRoute = AdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const BirdieRouteRoute = BirdieRouteRouteImport.update({
  id: '/birdie',
  path: '/birdie',
  getParentRoute: () => rootRouteImport,
} as any)
const DocumentRouteRoute = DocumentRouteRouteImport.update({
  id: '/document',
  path: '/document',
  getParentRoute: () => rootRouteImport,
} as any)
const OfficeRouteRoute = OfficeRouteRouteImport.update({
  id: '/office',
  path: '/office',
  getParentRoute: () => rootRouteImport,
} as any)
const authActivateRoute = authActivateRouteImport.update({
  id: '/(auth)/activate',
  path: '/activate',
  getParentRoute: () => rootRouteImport,
} as any)
const authAutoSignInRoute = authAutoSignInRouteImport.update({
  id: '/(auth)/auto-sign-in',
  path: '/auto-sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const authForgotPasswordRoute = authForgotPasswordRouteImport.update({
  id: '/(auth)/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const authForgotPasswordOtpRoute = authForgotPasswordOtpRouteImport.update({
  id: '/(auth)/forgot-password-otp',
  path: '/forgot-password-otp',
  getParentRoute: () => rootRouteImport,
} as any)
const authResetPasswordRoute = authResetPasswordRouteImport.update({
  id: '/(auth)/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const authResetPasswordInvalidRoute =
  authResetPasswordInvalidRouteImport.update({
    id: '/(auth)/reset-password-invalid',
    path: '/reset-password-invalid',
    getParentRoute: () => rootRouteImport,
  } as any)
const authResetPasswordSuccessRoute =
  authResetPasswordSuccessRouteImport.update({
    id: '/(auth)/reset-password-success',
    path: '/reset-password-success',
    getParentRoute: () => rootRouteImport,
  } as any)
const authSignInRoute = authSignInRouteImport.update({
  id: '/(auth)/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const authSignInImRoute = authSignInImRouteImport.update({
  id: '/(auth)/sign-in-im',
  path: '/sign-in-im',
  getParentRoute: () => rootRouteImport,
} as any)
const authSignInOtpRoute = authSignInOtpRouteImport.update({
  id: '/(auth)/sign-in-otp',
  path: '/sign-in-otp',
  getParentRoute: () => rootRouteImport,
} as any)
const authSignInPasswordRoute = authSignInPasswordRouteImport.update({
  id: '/(auth)/sign-in-password',
  path: '/sign-in-password',
  getParentRoute: () => rootRouteImport,
} as any)
const devMediaV3UploadRoute = devMediaV3UploadRouteImport.update({
  id: '/(dev)/media-v3-upload',
  path: '/media-v3-upload',
  getParentRoute: () => rootRouteImport,
} as any)
const errorPageForbiddenRoute = errorPageForbiddenRouteImport.update({
  id: '/page-forbidden',
  path: '/page-forbidden',
  getParentRoute: () => errorRouteRoute,
} as any)
const errorPageNotFoundRoute = errorPageNotFoundRouteImport.update({
  id: '/page-not-found',
  path: '/page-not-found',
  getParentRoute: () => errorRouteRoute,
} as any)
const memberprotectedRouteRoute = memberprotectedRouteRouteImport.update({
  id: '/(protected)',
  getParentRoute: () => memberRouteRoute,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminGlobalBirdieChatRoute = AdminGlobalBirdieChatRouteImport.update({
  id: '/global-birdie-chat',
  path: '/global-birdie-chat',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminLocationsRoute = AdminLocationsRouteImport.update({
  id: '/locations',
  path: '/locations',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminServiceAreasRoute = AdminServiceAreasRouteImport.update({
  id: '/service-areas',
  path: '/service-areas',
  getParentRoute: () => AdminRouteRoute,
} as any)
const BirdieIndexRoute = BirdieIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => BirdieRouteRoute,
} as any)
const CustomAppMigateToQuoteRoute = CustomAppMigateToQuoteRouteImport.update({
  id: '/custom-app/migate-to-quote',
  path: '/custom-app/migate-to-quote',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomAppMigrateToQuoteRoute = CustomAppMigrateToQuoteRouteImport.update({
  id: '/custom-app/migrate-to-quote',
  path: '/custom-app/migrate-to-quote',
  getParentRoute: () => rootRouteImport,
} as any)
const DocumentIndexRoute = DocumentIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DocumentRouteRoute,
} as any)
const DocumentSlugRoute = DocumentSlugRouteImport.update({
  id: '/$slug',
  path: '/$slug',
  getParentRoute: () => DocumentRouteRoute,
} as any)
const HomecareProposalProposalIdRoute =
  HomecareProposalProposalIdRouteImport.update({
    id: '/homecare-proposal/$proposalId',
    path: '/homecare-proposal/$proposalId',
    getParentRoute: () => rootRouteImport,
  } as any)
const OfficeIndexRoute = OfficeIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OfficeRouteRoute,
} as any)
const OfficeConnectGgCalendarRoute = OfficeConnectGgCalendarRouteImport.update({
  id: '/connect-gg-calendar',
  path: '/connect-gg-calendar',
  getParentRoute: () => OfficeRouteRoute,
} as any)
const OfficeGlobalBirdieChatRoute = OfficeGlobalBirdieChatRouteImport.update({
  id: '/global-birdie-chat',
  path: '/global-birdie-chat',
  getParentRoute: () => OfficeRouteRoute,
} as any)
const OfficeGlobalSearchRoute = OfficeGlobalSearchRouteImport.update({
  id: '/global-search',
  path: '/global-search',
  getParentRoute: () => OfficeRouteRoute,
} as any)
const OfficeInboxRoute = OfficeInboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => OfficeRouteRoute,
} as any)
const OfficeManageAccountRoute = OfficeManageAccountRouteImport.update({
  id: '/manage-account',
  path: '/manage-account',
  getParentRoute: () => OfficeRouteRoute,
} as any)
const OfficeQuotesRoute = OfficeQuotesRouteImport.update({
  id: '/quotes',
  path: '/quotes',
  getParentRoute: () => OfficeRouteRoute,
} as any)
const OfficeSearchRoute = OfficeSearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => OfficeRouteRoute,
} as any)
const VLinkCodeRoute = VLinkCodeRouteImport.update({
  id: '/v/$linkCode',
  path: '/v/$linkCode',
  getParentRoute: () => rootRouteImport,
} as any)
const devThemesIndexRoute = devThemesIndexRouteImport.update({
  id: '/(dev)/themes/',
  path: '/themes/',
  getParentRoute: () => rootRouteImport,
} as any)
const meetMeetRoomNameRoute = meetMeetRoomNameRouteImport.update({
  id: '/meet/$roomName',
  path: '/meet/$roomName',
  getParentRoute: () => meetRouteRoute,
} as any)
const memberprotectedMyRoute = memberprotectedMyRouteImport.update({
  id: '/my',
  path: '/my',
  getParentRoute: () => memberprotectedRouteRoute,
} as any)
const memberpublicJoinRoute = memberpublicJoinRouteImport.update({
  id: '/(public)/join',
  path: '/join',
  getParentRoute: () => memberRouteRoute,
} as any)
const payPayTokenRoute = payPayTokenRouteImport.update({
  id: '/pay/$token',
  path: '/pay/$token',
  getParentRoute: () => payRouteRoute,
} as any)
const AdminAccountsIndexRoute = AdminAccountsIndexRouteImport.update({
  id: '/accounts/',
  path: '/accounts/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminAuthorizationIndexRoute = AdminAuthorizationIndexRouteImport.update({
  id: '/authorization/',
  path: '/authorization/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminAuthorizationRoleKeyRoute =
  AdminAuthorizationRoleKeyRouteImport.update({
    id: '/authorization/$roleKey',
    path: '/authorization/$roleKey',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminAuthorizationCreateRoute =
  AdminAuthorizationCreateRouteImport.update({
    id: '/authorization/create',
    path: '/authorization/create',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminCampaignsIndexRoute = AdminCampaignsIndexRouteImport.update({
  id: '/campaigns/',
  path: '/campaigns/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminCampaignsCampaignIdRoute =
  AdminCampaignsCampaignIdRouteImport.update({
    id: '/campaigns/$campaignId',
    path: '/campaigns/$campaignId',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminCampaignsCreateRoute = AdminCampaignsCreateRouteImport.update({
  id: '/campaigns/create',
  path: '/campaigns/create',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminCheckoutLinksIndexRoute = AdminCheckoutLinksIndexRouteImport.update({
  id: '/checkout-links/',
  path: '/checkout-links/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminCheckoutLinksCreateRoute =
  AdminCheckoutLinksCreateRouteImport.update({
    id: '/checkout-links/create',
    path: '/checkout-links/create',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminCustomersIndexRoute = AdminCustomersIndexRouteImport.update({
  id: '/customers/',
  path: '/customers/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminCustomersCustomerIdRoute =
  AdminCustomersCustomerIdRouteImport.update({
    id: '/customers/$customerId',
    path: '/customers/$customerId',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminCustomersCreateRoute = AdminCustomersCreateRouteImport.update({
  id: '/customers/create',
  path: '/customers/create',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminHomecarePlanProposalsIndexRoute =
  AdminHomecarePlanProposalsIndexRouteImport.update({
    id: '/homecare-plan-proposals/',
    path: '/homecare-plan-proposals/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminLocationsCreateRoute = AdminLocationsCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => AdminLocationsRoute,
} as any)
const AdminPurchaseIntentsIndexRoute =
  AdminPurchaseIntentsIndexRouteImport.update({
    id: '/purchase-intents/',
    path: '/purchase-intents/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminSubscriptionsIndexRoute = AdminSubscriptionsIndexRouteImport.update({
  id: '/subscriptions/',
  path: '/subscriptions/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminSubscriptionsCreateRoute =
  AdminSubscriptionsCreateRouteImport.update({
    id: '/subscriptions/create',
    path: '/subscriptions/create',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminTagsIndexRoute = AdminTagsIndexRouteImport.update({
  id: '/tags/',
  path: '/tags/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminUsersIndexRoute = AdminUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminUsersCreateRoute = AdminUsersCreateRouteImport.update({
  id: '/users/create',
  path: '/users/create',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminUsersManagersRoute = AdminUsersManagersRouteImport.update({
  id: '/users/managers',
  path: '/users/managers',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminUsersMembersRoute = AdminUsersMembersRouteImport.update({
  id: '/users/members',
  path: '/users/members',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminUsersTechniciansRoute = AdminUsersTechniciansRouteImport.update({
  id: '/users/technicians',
  path: '/users/technicians',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminVisitsIndexRoute = AdminVisitsIndexRouteImport.update({
  id: '/visits/',
  path: '/visits/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminVisitsAvailableTimeSlotsRoute =
  AdminVisitsAvailableTimeSlotsRouteImport.update({
    id: '/visits/available-time-slots',
    path: '/visits/available-time-slots',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const BirdieSessionsIndexRoute = BirdieSessionsIndexRouteImport.update({
  id: '/sessions/',
  path: '/sessions/',
  getParentRoute: () => BirdieRouteRoute,
} as any)
const BirdieSessionsSessionIdRoute = BirdieSessionsSessionIdRouteImport.update({
  id: '/sessions/$sessionId',
  path: '/sessions/$sessionId',
  getParentRoute: () => BirdieRouteRoute,
} as any)
const OfficeBillingTodoRoute = OfficeBillingTodoRouteImport.update({
  id: '/billing/todo',
  path: '/billing/todo',
  getParentRoute: () => OfficeRouteRoute,
} as any)
const OfficeCatalogNewIndexRoute = OfficeCatalogNewIndexRouteImport.update({
  id: '/catalog-new/',
  path: '/catalog-new/',
  getParentRoute: () => OfficeRouteRoute,
} as any)
const OfficeCatalogNewCatalogItemIdRoute =
  OfficeCatalogNewCatalogItemIdRouteImport.update({
    id: '/catalog-new/$catalogItemId',
    path: '/catalog-new/$catalogItemId',
    getParentRoute: () => OfficeRouteRoute,
  } as any)
const OfficeNotificationsIndexRoute =
  OfficeNotificationsIndexRouteImport.update({
    id: '/notifications/',
    path: '/notifications/',
    getParentRoute: () => OfficeRouteRoute,
  } as any)
const OfficeOrdersIndexRoute = OfficeOrdersIndexRouteImport.update({
  id: '/orders/',
  path: '/orders/',
  getParentRoute: () => OfficeRouteRoute,
} as any)
const OfficeOrdersOrderIdRoute = OfficeOrdersOrderIdRouteImport.update({
  id: '/orders/$orderId',
  path: '/orders/$orderId',
  getParentRoute: () => OfficeRouteRoute,
} as any)
const OfficeOrdersActiveRoute = OfficeOrdersActiveRouteImport.update({
  id: '/orders/active',
  path: '/orders/active',
  getParentRoute: () => OfficeRouteRoute,
} as any)
const OfficeOrdersAllRoute = OfficeOrdersAllRouteImport.update({
  id: '/orders/all',
  path: '/orders/all',
  getParentRoute: () => OfficeRouteRoute,
} as any)
const OfficeOrdersCreateRoute = OfficeOrdersCreateRouteImport.update({
  id: '/orders/create',
  path: '/orders/create',
  getParentRoute: () => OfficeRouteRoute,
} as any)
const OfficeOrdersFutureRoute = OfficeOrdersFutureRouteImport.update({
  id: '/orders/future',
  path: '/orders/future',
  getParentRoute: () => OfficeRouteRoute,
} as any)
const OfficeOrdersWorkflowRoute = OfficeOrdersWorkflowRouteImport.update({
  id: '/orders/workflow',
  path: '/orders/workflow',
  getParentRoute: () => OfficeRouteRoute,
} as any)
const OfficePlacesIndexRoute = OfficePlacesIndexRouteImport.update({
  id: '/places/',
  path: '/places/',
  getParentRoute: () => OfficeRouteRoute,
} as any)
const OfficePlacesPlaceIdRoute = OfficePlacesPlaceIdRouteImport.update({
  id: '/places/$placeId',
  path: '/places/$placeId',
  getParentRoute: () => OfficeRouteRoute,
} as any)
const OfficePlacesActiveRoute = OfficePlacesActiveRouteImport.update({
  id: '/places/active',
  path: '/places/active',
  getParentRoute: () => OfficeRouteRoute,
} as any)
const OfficePlacesAllRoute = OfficePlacesAllRouteImport.update({
  id: '/places/all',
  path: '/places/all',
  getParentRoute: () => OfficeRouteRoute,
} as any)
const OfficePlacesCreateRoute = OfficePlacesCreateRouteImport.update({
  id: '/places/create',
  path: '/places/create',
  getParentRoute: () => OfficeRouteRoute,
} as any)
const OfficeReportsIndexRoute = OfficeReportsIndexRouteImport.update({
  id: '/reports/',
  path: '/reports/',
  getParentRoute: () => OfficeRouteRoute,
} as any)
const OfficeReportsAiFeedbackRoute = OfficeReportsAiFeedbackRouteImport.update({
  id: '/reports/ai-feedback',
  path: '/reports/ai-feedback',
  getParentRoute: () => OfficeRouteRoute,
} as any)
const OfficeReportsConfirmedChurnRoute =
  OfficeReportsConfirmedChurnRouteImport.update({
    id: '/reports/confirmed-churn',
    path: '/reports/confirmed-churn',
    getParentRoute: () => OfficeRouteRoute,
  } as any)
const OfficeReportsHomecareRenewalsRoute =
  OfficeReportsHomecareRenewalsRouteImport.update({
    id: '/reports/homecare-renewals',
    path: '/reports/homecare-renewals',
    getParentRoute: () => OfficeRouteRoute,
  } as any)
const OfficeReportsMemberActivationRoute =
  OfficeReportsMemberActivationRouteImport.update({
    id: '/reports/member-activation',
    path: '/reports/member-activation',
    getParentRoute: () => OfficeRouteRoute,
  } as any)
const OfficeReportsOneOffRevenueRoute =
  OfficeReportsOneOffRevenueRouteImport.update({
    id: '/reports/one-off-revenue',
    path: '/reports/one-off-revenue',
    getParentRoute: () => OfficeRouteRoute,
  } as any)
const OfficeReportsOrderOverviewRoute =
  OfficeReportsOrderOverviewRouteImport.update({
    id: '/reports/order-overview',
    path: '/reports/order-overview',
    getParentRoute: () => OfficeRouteRoute,
  } as any)
const OfficeReportsRevenueRoute = OfficeReportsRevenueRouteImport.update({
  id: '/reports/revenue',
  path: '/reports/revenue',
  getParentRoute: () => OfficeRouteRoute,
} as any)
const OfficeReportsVendorScorecardRoute =
  OfficeReportsVendorScorecardRouteImport.update({
    id: '/reports/vendor-scorecard',
    path: '/reports/vendor-scorecard',
    getParentRoute: () => OfficeRouteRoute,
  } as any)
const OfficeScheduleIndexRoute = OfficeScheduleIndexRouteImport.update({
  id: '/schedule/',
  path: '/schedule/',
  getParentRoute: () => OfficeRouteRoute,
} as any)
const OfficeSmartActionsIndexRoute = OfficeSmartActionsIndexRouteImport.update({
  id: '/smart-actions/',
  path: '/smart-actions/',
  getParentRoute: () => OfficeRouteRoute,
} as any)
const OfficeSmartActionsAccuracyRoute =
  OfficeSmartActionsAccuracyRouteImport.update({
    id: '/smart-actions/accuracy',
    path: '/smart-actions/accuracy',
    getParentRoute: () => OfficeRouteRoute,
  } as any)
const OfficeSmartActionsBoardRoute = OfficeSmartActionsBoardRouteImport.update({
  id: '/smart-actions/board',
  path: '/smart-actions/board',
  getParentRoute: () => OfficeRouteRoute,
} as any)
const OfficeSmartActionsForecastRoute =
  OfficeSmartActionsForecastRouteImport.update({
    id: '/smart-actions/forecast',
    path: '/smart-actions/forecast',
    getParentRoute: () => OfficeRouteRoute,
  } as any)
const OfficeSmartActionsLostCostsRoute =
  OfficeSmartActionsLostCostsRouteImport.update({
    id: '/smart-actions/lost-costs',
    path: '/smart-actions/lost-costs',
    getParentRoute: () => OfficeRouteRoute,
  } as any)
const OfficeTasksIndexRoute = OfficeTasksIndexRouteImport.update({
  id: '/tasks/',
  path: '/tasks/',
  getParentRoute: () => OfficeRouteRoute,
} as any)
const OfficeTasksCreateRoute = OfficeTasksCreateRouteImport.update({
  id: '/tasks/create',
  path: '/tasks/create',
  getParentRoute: () => OfficeRouteRoute,
} as any)
const OfficeVendorsIndexRoute = OfficeVendorsIndexRouteImport.update({
  id: '/vendors/',
  path: '/vendors/',
  getParentRoute: () => OfficeRouteRoute,
} as any)
const OfficeVendorsCreateRoute = OfficeVendorsCreateRouteImport.update({
  id: '/vendors/create',
  path: '/vendors/create',
  getParentRoute: () => OfficeRouteRoute,
} as any)
const OfficeVendorsVisitsRoute = OfficeVendorsVisitsRouteImport.update({
  id: '/vendors/visits',
  path: '/vendors/visits',
  getParentRoute: () => OfficeRouteRoute,
} as any)
const VendorsOnboardingV1RouteRoute =
  VendorsOnboardingV1RouteRouteImport.update({
    id: '/vendors/onboarding/v1',
    path: '/vendors/onboarding/v1',
    getParentRoute: () => rootRouteImport,
  } as any)
const meetMeetJoinRoomNameRoute = meetMeetJoinRoomNameRouteImport.update({
  id: '/meet/join/$roomName',
  path: '/meet/join/$roomName',
  getParentRoute: () => meetRouteRoute,
} as any)
const memberprotectedMyIndexRoute = memberprotectedMyIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => memberprotectedMyRoute,
} as any)
const memberprotectedMyBirdieRoute = memberprotectedMyBirdieRouteImport.update({
  id: '/birdie',
  path: '/birdie',
  getParentRoute: () => memberprotectedMyRoute,
} as any)
const memberprotectedMyCartRoute = memberprotectedMyCartRouteImport.update({
  id: '/cart',
  path: '/cart',
  getParentRoute: () => memberprotectedMyRoute,
} as any)
const memberprotectedMyChatsRoute = memberprotectedMyChatsRouteImport.update({
  id: '/chats',
  path: '/chats',
  getParentRoute: () => memberprotectedMyRoute,
} as any)
const memberprotectedMyDownloadRoute =
  memberprotectedMyDownloadRouteImport.update({
    id: '/download',
    path: '/download',
    getParentRoute: () => memberprotectedMyRoute,
  } as any)
const memberprotectedMyDownloadAppRoute =
  memberprotectedMyDownloadAppRouteImport.update({
    id: '/download-app',
    path: '/download-app',
    getParentRoute: () => memberprotectedMyRoute,
  } as any)
const memberprotectedMyFeedbackRoute =
  memberprotectedMyFeedbackRouteImport.update({
    id: '/feedback',
    path: '/feedback',
    getParentRoute: () => memberprotectedMyRoute,
  } as any)
const memberprotectedMyGlobalSearchRoute =
  memberprotectedMyGlobalSearchRouteImport.update({
    id: '/global-search',
    path: '/global-search',
    getParentRoute: () => memberprotectedMyRoute,
  } as any)
const memberprotectedMyHelpRoute = memberprotectedMyHelpRouteImport.update({
  id: '/help',
  path: '/help',
  getParentRoute: () => memberprotectedMyRoute,
} as any)
const memberprotectedMyHomeRoute = memberprotectedMyHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => memberprotectedMyRoute,
} as any)
const memberprotectedMyOnboardingRoute =
  memberprotectedMyOnboardingRouteImport.update({
    id: '/onboarding',
    path: '/onboarding',
    getParentRoute: () => memberprotectedMyRoute,
  } as any)
const memberprotectedMyRecordsRoute =
  memberprotectedMyRecordsRouteImport.update({
    id: '/records',
    path: '/records',
    getParentRoute: () => memberprotectedMyRoute,
  } as any)
const memberprotectedMySettingsRoute =
  memberprotectedMySettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => memberprotectedMyRoute,
  } as any)
const memberprotectedMyVerifyPhoneRoute =
  memberprotectedMyVerifyPhoneRouteImport.update({
    id: '/verify-phone',
    path: '/verify-phone',
    getParentRoute: () => memberprotectedMyRoute,
  } as any)
const memberpublicInviteTokenRoute = memberpublicInviteTokenRouteImport.update({
  id: '/(public)/invite/$token',
  path: '/invite/$token',
  getParentRoute: () => memberRouteRoute,
} as any)
const memberpublicJoinIndexRoute = memberpublicJoinIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => memberpublicJoinRoute,
} as any)
const memberpublicJoinSignUpRoute = memberpublicJoinSignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => memberpublicJoinRoute,
} as any)
const memberpublicJoinVerifyRoute = memberpublicJoinVerifyRouteImport.update({
  id: '/verify',
  path: '/verify',
  getParentRoute: () => memberpublicJoinRoute,
} as any)
const memberpublicPresaleSplatRoute =
  memberpublicPresaleSplatRouteImport.update({
    id: '/(public)/presale/$',
    path: '/presale/$',
    getParentRoute: () => memberRouteRoute,
  } as any)
const AdminUsersManagersCreateRoute =
  AdminUsersManagersCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AdminUsersManagersRoute,
  } as any)
const AdminUsersMembersCreateRoute = AdminUsersMembersCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => AdminUsersMembersRoute,
} as any)
const AdminUsersTechniciansCreateRoute =
  AdminUsersTechniciansCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AdminUsersTechniciansRoute,
  } as any)
const OfficeBillingInvoicesIndexRoute =
  OfficeBillingInvoicesIndexRouteImport.update({
    id: '/billing/invoices/',
    path: '/billing/invoices/',
    getParentRoute: () => OfficeRouteRoute,
  } as any)
const OfficePlacesOnboardingIndexRoute =
  OfficePlacesOnboardingIndexRouteImport.update({
    id: '/places/onboarding/',
    path: '/places/onboarding/',
    getParentRoute: () => OfficeRouteRoute,
  } as any)
const VendorsOnboardingV1Step0WelcomeRoute =
  VendorsOnboardingV1Step0WelcomeRouteImport.update({
    id: '/step-0-welcome',
    path: '/step-0-welcome',
    getParentRoute: () => VendorsOnboardingV1RouteRoute,
  } as any)
const VendorsOnboardingV1Step1BusinessInfoRoute =
  VendorsOnboardingV1Step1BusinessInfoRouteImport.update({
    id: '/step-1-business-info',
    path: '/step-1-business-info',
    getParentRoute: () => VendorsOnboardingV1RouteRoute,
  } as any)
const VendorsOnboardingV1Step2LegalComplianceRoute =
  VendorsOnboardingV1Step2LegalComplianceRouteImport.update({
    id: '/step-2-legal-compliance',
    path: '/step-2-legal-compliance',
    getParentRoute: () => VendorsOnboardingV1RouteRoute,
  } as any)
const VendorsOnboardingV1Step3ServiceTermRoute =
  VendorsOnboardingV1Step3ServiceTermRouteImport.update({
    id: '/step-3-service-term',
    path: '/step-3-service-term',
    getParentRoute: () => VendorsOnboardingV1RouteRoute,
  } as any)
const VendorsOnboardingV1Step4AddTechnicianRoute =
  VendorsOnboardingV1Step4AddTechnicianRouteImport.update({
    id: '/step-4-add-technician',
    path: '/step-4-add-technician',
    getParentRoute: () => VendorsOnboardingV1RouteRoute,
  } as any)
const VendorsOnboardingV1Step5ReviewInformationRoute =
  VendorsOnboardingV1Step5ReviewInformationRouteImport.update({
    id: '/step-5-review-information',
    path: '/step-5-review-information',
    getParentRoute: () => VendorsOnboardingV1RouteRoute,
  } as any)
const VendorsOnboardingV1StepFinalSubmitRoute =
  VendorsOnboardingV1StepFinalSubmitRouteImport.update({
    id: '/step-final-submit',
    path: '/step-final-submit',
    getParentRoute: () => VendorsOnboardingV1RouteRoute,
  } as any)
const memberprotectedMyCampaignsCampaignSlugRoute =
  memberprotectedMyCampaignsCampaignSlugRouteImport.update({
    id: '/campaigns/$campaignSlug',
    path: '/campaigns/$campaignSlug',
    getParentRoute: () => memberprotectedMyRoute,
  } as any)
const memberprotectedMyCheckoutIndexRoute =
  memberprotectedMyCheckoutIndexRouteImport.update({
    id: '/checkout/',
    path: '/checkout/',
    getParentRoute: () => memberprotectedMyRoute,
  } as any)
const memberprotectedMyCheckoutCheckoutIdRoute =
  memberprotectedMyCheckoutCheckoutIdRouteImport.update({
    id: '/checkout/$checkoutId',
    path: '/checkout/$checkoutId',
    getParentRoute: () => memberprotectedMyRoute,
  } as any)
const memberprotectedMyCheckoutSuccessRoute =
  memberprotectedMyCheckoutSuccessRouteImport.update({
    id: '/checkout/success',
    path: '/checkout/success',
    getParentRoute: () => memberprotectedMyRoute,
  } as any)
const memberprotectedMyFeedbackIndexRoute =
  memberprotectedMyFeedbackIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => memberprotectedMyFeedbackRoute,
  } as any)
const memberprotectedMyFeedbackFeedbackIdRoute =
  memberprotectedMyFeedbackFeedbackIdRouteImport.update({
    id: '/$feedbackId',
    path: '/$feedbackId',
    getParentRoute: () => memberprotectedMyFeedbackRoute,
  } as any)
const memberprotectedMyListIndexRoute =
  memberprotectedMyListIndexRouteImport.update({
    id: '/list/',
    path: '/list/',
    getParentRoute: () => memberprotectedMyRoute,
  } as any)
const memberprotectedMyListArchivedRoute =
  memberprotectedMyListArchivedRouteImport.update({
    id: '/list/archived',
    path: '/list/archived',
    getParentRoute: () => memberprotectedMyRoute,
  } as any)
const memberprotectedMyOrdersOrderIdRoute =
  memberprotectedMyOrdersOrderIdRouteImport.update({
    id: '/orders/$orderId',
    path: '/orders/$orderId',
    getParentRoute: () => memberprotectedMyRoute,
  } as any)
const memberprotectedMyOrdersCreateRoute =
  memberprotectedMyOrdersCreateRouteImport.update({
    id: '/orders/create',
    path: '/orders/create',
    getParentRoute: () => memberprotectedMyRoute,
  } as any)
const memberprotectedMyPlacesIndexRoute =
  memberprotectedMyPlacesIndexRouteImport.update({
    id: '/places/',
    path: '/places/',
    getParentRoute: () => memberprotectedMyRoute,
  } as any)
const memberprotectedMyPlacesAddRoute =
  memberprotectedMyPlacesAddRouteImport.update({
    id: '/places/add',
    path: '/places/add',
    getParentRoute: () => memberprotectedMyRoute,
  } as any)
const memberprotectedMyPlacesExistRoute =
  memberprotectedMyPlacesExistRouteImport.update({
    id: '/places/exist',
    path: '/places/exist',
    getParentRoute: () => memberprotectedMyRoute,
  } as any)
const memberprotectedMyQuotesQuoteIdRoute =
  memberprotectedMyQuotesQuoteIdRouteImport.update({
    id: '/quotes/$quoteId',
    path: '/quotes/$quoteId',
    getParentRoute: () => memberprotectedMyRoute,
  } as any)
const memberprotectedMyRequestsSubmitRoute =
  memberprotectedMyRequestsSubmitRouteImport.update({
    id: '/requests/submit',
    path: '/requests/submit',
    getParentRoute: () => memberprotectedMyRoute,
  } as any)
const memberprotectedMySettingsIndexRoute =
  memberprotectedMySettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => memberprotectedMySettingsRoute,
  } as any)
const memberpublicInviteTokenIndexRoute =
  memberpublicInviteTokenIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => memberpublicInviteTokenRoute,
  } as any)
const memberpublicInviteTokenSignUpRoute =
  memberpublicInviteTokenSignUpRouteImport.update({
    id: '/sign-up',
    path: '/sign-up',
    getParentRoute: () => memberpublicInviteTokenRoute,
  } as any)
const memberpublicInviteTokenSuccessRoute =
  memberpublicInviteTokenSuccessRouteImport.update({
    id: '/success',
    path: '/success',
    getParentRoute: () => memberpublicInviteTokenRoute,
  } as any)
const memberpublicInviteTokenVerifyRoute =
  memberpublicInviteTokenVerifyRouteImport.update({
    id: '/verify',
    path: '/verify',
    getParentRoute: () => memberpublicInviteTokenRoute,
  } as any)
const memberpublicPublicOrdersOrderIdRoute =
  memberpublicPublicOrdersOrderIdRouteImport.update({
    id: '/(public)/public/orders/$orderId',
    path: '/public/orders/$orderId',
    getParentRoute: () => memberRouteRoute,
  } as any)
const OfficeBillingAccountsAccountIdWalletRoute =
  OfficeBillingAccountsAccountIdWalletRouteImport.update({
    id: '/billing/accounts/$accountId/wallet',
    path: '/billing/accounts/$accountId/wallet',
    getParentRoute: () => OfficeRouteRoute,
  } as any)
const OfficeBillingInvoicesInvoiceIdEditRoute =
  OfficeBillingInvoicesInvoiceIdEditRouteImport.update({
    id: '/billing/invoices/$invoiceId/edit',
    path: '/billing/invoices/$invoiceId/edit',
    getParentRoute: () => OfficeRouteRoute,
  } as any)
const memberprotectedMySettingsAccountBillingRoute =
  memberprotectedMySettingsAccountBillingRouteImport.update({
    id: '/account/billing',
    path: '/account/billing',
    getParentRoute: () => memberprotectedMySettingsRoute,
  } as any)
const memberprotectedMySettingsAccountNotificationsRoute =
  memberprotectedMySettingsAccountNotificationsRouteImport.update({
    id: '/account/notifications',
    path: '/account/notifications',
    getParentRoute: () => memberprotectedMySettingsRoute,
  } as any)
const memberprotectedMySettingsAccountProfileRoute =
  memberprotectedMySettingsAccountProfileRouteImport.update({
    id: '/account/profile',
    path: '/account/profile',
    getParentRoute: () => memberprotectedMySettingsRoute,
  } as any)
const memberprotectedMySettingsAccountSecurityRoute =
  memberprotectedMySettingsAccountSecurityRouteImport.update({
    id: '/account/security',
    path: '/account/security',
    getParentRoute: () => memberprotectedMySettingsRoute,
  } as any)
const memberprotectedMySettingsHouseholdMembersRoute =
  memberprotectedMySettingsHouseholdMembersRouteImport.update({
    id: '/household/members',
    path: '/household/members',
    getParentRoute: () => memberprotectedMySettingsRoute,
  } as any)
const memberprotectedMySettingsHouseholdMembershipRoute =
  memberprotectedMySettingsHouseholdMembershipRouteImport.update({
    id: '/household/membership',
    path: '/household/membership',
    getParentRoute: () => memberprotectedMySettingsRoute,
  } as any)
const memberprotectedMySettingsAccountBillingIndexRoute =
  memberprotectedMySettingsAccountBillingIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => memberprotectedMySettingsAccountBillingRoute,
  } as any)
const memberprotectedMySettingsAccountBillingPaymentsRoute =
  memberprotectedMySettingsAccountBillingPaymentsRouteImport.update({
    id: '/payments',
    path: '/payments',
    getParentRoute: () => memberprotectedMySettingsAccountBillingRoute,
  } as any)
const memberprotectedMySettingsAccountBillingWalletRoute =
  memberprotectedMySettingsAccountBillingWalletRouteImport.update({
    id: '/wallet',
    path: '/wallet',
    getParentRoute: () => memberprotectedMySettingsAccountBillingRoute,
  } as any)
const memberprotectedMySettingsAccountInvoicesIndexRoute =
  memberprotectedMySettingsAccountInvoicesIndexRouteImport.update({
    id: '/account/invoices/',
    path: '/account/invoices/',
    getParentRoute: () => memberprotectedMySettingsRoute,
  } as any)
const memberprotectedMySettingsAccountInvoicesInvoiceIdRoute =
  memberprotectedMySettingsAccountInvoicesInvoiceIdRouteImport.update({
    id: '/account/invoices/$invoiceId',
    path: '/account/invoices/$invoiceId',
    getParentRoute: () => memberprotectedMySettingsRoute,
  } as any)
const memberprotectedMySettingsAccountBillingPaymentsIndexRoute =
  memberprotectedMySettingsAccountBillingPaymentsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => memberprotectedMySettingsAccountBillingPaymentsRoute,
  } as any)
const memberprotectedMySettingsAccountBillingPaymentsPaymentMethodIdRoute =
  memberprotectedMySettingsAccountBillingPaymentsPaymentMethodIdRouteImport.update(
    {
      id: '/$paymentMethodId',
      path: '/$paymentMethodId',
      getParentRoute: () =>
        memberprotectedMySettingsAccountBillingPaymentsRoute,
    } as any,
  )
const memberprotectedMySettingsAccountBillingPaymentsHistoryRoute =
  memberprotectedMySettingsAccountBillingPaymentsHistoryRouteImport.update({
    id: '/history',
    path: '/history',
    getParentRoute: () => memberprotectedMySettingsAccountBillingPaymentsRoute,
  } as any)
const memberprotectedMySettingsAccountBillingWalletIndexRoute =
  memberprotectedMySettingsAccountBillingWalletIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => memberprotectedMySettingsAccountBillingWalletRoute,
  } as any)
const memberprotectedMySettingsAccountBillingWalletHistoryRoute =
  memberprotectedMySettingsAccountBillingWalletHistoryRouteImport.update({
    id: '/history',
    path: '/history',
    getParentRoute: () => memberprotectedMySettingsAccountBillingWalletRoute,
  } as any)
const memberprotectedMySettingsAccountBillingPaymentsHistoryTransactionIdRoute =
  memberprotectedMySettingsAccountBillingPaymentsHistoryTransactionIdRouteImport.update(
    {
      id: '/history_/$transactionId',
      path: '/history/$transactionId',
      getParentRoute: () =>
        memberprotectedMySettingsAccountBillingPaymentsRoute,
    } as any,
  )
const memberprotectedMySettingsAccountBillingWalletHistoryWalletItemIdRoute =
  memberprotectedMySettingsAccountBillingWalletHistoryWalletItemIdRouteImport.update(
    {
      id: '/history_/$walletItemId',
      path: '/history/$walletItemId',
      getParentRoute: () => memberprotectedMySettingsAccountBillingWalletRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/birdie': typeof BirdieRouteRouteWithChildren
  '/document': typeof DocumentRouteRouteWithChildren
  '/office': typeof OfficeRouteRouteWithChildren
  '/activate': typeof authActivateRoute
  '/auto-sign-in': typeof authAutoSignInRoute
  '/forgot-password': typeof authForgotPasswordRoute
  '/forgot-password-otp': typeof authForgotPasswordOtpRoute
  '/reset-password': typeof authResetPasswordRoute
  '/reset-password-invalid': typeof authResetPasswordInvalidRoute
  '/reset-password-success': typeof authResetPasswordSuccessRoute
  '/sign-in': typeof authSignInRoute
  '/sign-in-im': typeof authSignInImRoute
  '/sign-in-otp': typeof authSignInOtpRoute
  '/sign-in-password': typeof authSignInPasswordRoute
  '/media-v3-upload': typeof devMediaV3UploadRoute
  '/page-forbidden': typeof errorPageForbiddenRoute
  '/page-not-found': typeof errorPageNotFoundRoute
  '/admin/global-birdie-chat': typeof AdminGlobalBirdieChatRoute
  '/admin/locations': typeof AdminLocationsRouteWithChildren
  '/admin/service-areas': typeof AdminServiceAreasRoute
  '/custom-app/migate-to-quote': typeof CustomAppMigateToQuoteRoute
  '/custom-app/migrate-to-quote': typeof CustomAppMigrateToQuoteRoute
  '/document/$slug': typeof DocumentSlugRoute
  '/homecare-proposal/$proposalId': typeof HomecareProposalProposalIdRoute
  '/office/connect-gg-calendar': typeof OfficeConnectGgCalendarRoute
  '/office/global-birdie-chat': typeof OfficeGlobalBirdieChatRoute
  '/office/global-search': typeof OfficeGlobalSearchRoute
  '/office/inbox': typeof OfficeInboxRoute
  '/office/manage-account': typeof OfficeManageAccountRoute
  '/office/quotes': typeof OfficeQuotesRoute
  '/office/search': typeof OfficeSearchRoute
  '/v/$linkCode': typeof VLinkCodeRoute
  '/admin/': typeof AdminIndexRoute
  '/birdie/': typeof BirdieIndexRoute
  '/document/': typeof DocumentIndexRoute
  '/office/': typeof OfficeIndexRoute
  '/vendors/onboarding/v1': typeof VendorsOnboardingV1RouteRouteWithChildren
  '/meet/$roomName': typeof meetMeetRoomNameRoute
  '/my': typeof memberprotectedMyRouteWithChildren
  '/join': typeof memberpublicJoinRouteWithChildren
  '/pay/$token': typeof payPayTokenRoute
  '/admin/authorization/$roleKey': typeof AdminAuthorizationRoleKeyRoute
  '/admin/authorization/create': typeof AdminAuthorizationCreateRoute
  '/admin/campaigns/$campaignId': typeof AdminCampaignsCampaignIdRoute
  '/admin/campaigns/create': typeof AdminCampaignsCreateRoute
  '/admin/checkout-links/create': typeof AdminCheckoutLinksCreateRoute
  '/admin/customers/$customerId': typeof AdminCustomersCustomerIdRoute
  '/admin/customers/create': typeof AdminCustomersCreateRoute
  '/admin/locations/create': typeof AdminLocationsCreateRoute
  '/admin/subscriptions/create': typeof AdminSubscriptionsCreateRoute
  '/admin/users/create': typeof AdminUsersCreateRoute
  '/admin/users/managers': typeof AdminUsersManagersRouteWithChildren
  '/admin/users/members': typeof AdminUsersMembersRouteWithChildren
  '/admin/users/technicians': typeof AdminUsersTechniciansRouteWithChildren
  '/admin/visits/available-time-slots': typeof AdminVisitsAvailableTimeSlotsRoute
  '/birdie/sessions/$sessionId': typeof BirdieSessionsSessionIdRoute
  '/office/billing/todo': typeof OfficeBillingTodoRoute
  '/office/catalog-new/$catalogItemId': typeof OfficeCatalogNewCatalogItemIdRoute
  '/office/orders/$orderId': typeof OfficeOrdersOrderIdRoute
  '/office/orders/active': typeof OfficeOrdersActiveRoute
  '/office/orders/all': typeof OfficeOrdersAllRoute
  '/office/orders/create': typeof OfficeOrdersCreateRoute
  '/office/orders/future': typeof OfficeOrdersFutureRoute
  '/office/orders/workflow': typeof OfficeOrdersWorkflowRoute
  '/office/places/$placeId': typeof OfficePlacesPlaceIdRoute
  '/office/places/active': typeof OfficePlacesActiveRoute
  '/office/places/all': typeof OfficePlacesAllRoute
  '/office/places/create': typeof OfficePlacesCreateRoute
  '/office/reports/ai-feedback': typeof OfficeReportsAiFeedbackRoute
  '/office/reports/confirmed-churn': typeof OfficeReportsConfirmedChurnRoute
  '/office/reports/homecare-renewals': typeof OfficeReportsHomecareRenewalsRoute
  '/office/reports/member-activation': typeof OfficeReportsMemberActivationRoute
  '/office/reports/one-off-revenue': typeof OfficeReportsOneOffRevenueRoute
  '/office/reports/order-overview': typeof OfficeReportsOrderOverviewRoute
  '/office/reports/revenue': typeof OfficeReportsRevenueRoute
  '/office/reports/vendor-scorecard': typeof OfficeReportsVendorScorecardRoute
  '/office/smart-actions/accuracy': typeof OfficeSmartActionsAccuracyRoute
  '/office/smart-actions/board': typeof OfficeSmartActionsBoardRoute
  '/office/smart-actions/forecast': typeof OfficeSmartActionsForecastRoute
  '/office/smart-actions/lost-costs': typeof OfficeSmartActionsLostCostsRoute
  '/office/tasks/create': typeof OfficeTasksCreateRoute
  '/office/vendors/create': typeof OfficeVendorsCreateRoute
  '/office/vendors/visits': typeof OfficeVendorsVisitsRoute
  '/themes/': typeof devThemesIndexRoute
  '/admin/accounts/': typeof AdminAccountsIndexRoute
  '/admin/authorization/': typeof AdminAuthorizationIndexRoute
  '/admin/campaigns/': typeof AdminCampaignsIndexRoute
  '/admin/checkout-links/': typeof AdminCheckoutLinksIndexRoute
  '/admin/customers/': typeof AdminCustomersIndexRoute
  '/admin/homecare-plan-proposals/': typeof AdminHomecarePlanProposalsIndexRoute
  '/admin/purchase-intents/': typeof AdminPurchaseIntentsIndexRoute
  '/admin/subscriptions/': typeof AdminSubscriptionsIndexRoute
  '/admin/tags/': typeof AdminTagsIndexRoute
  '/admin/users/': typeof AdminUsersIndexRoute
  '/admin/visits/': typeof AdminVisitsIndexRoute
  '/birdie/sessions/': typeof BirdieSessionsIndexRoute
  '/office/catalog-new/': typeof OfficeCatalogNewIndexRoute
  '/office/notifications/': typeof OfficeNotificationsIndexRoute
  '/office/orders/': typeof OfficeOrdersIndexRoute
  '/office/places/': typeof OfficePlacesIndexRoute
  '/office/reports/': typeof OfficeReportsIndexRoute
  '/office/schedule/': typeof OfficeScheduleIndexRoute
  '/office/smart-actions/': typeof OfficeSmartActionsIndexRoute
  '/office/tasks/': typeof OfficeTasksIndexRoute
  '/office/vendors/': typeof OfficeVendorsIndexRoute
  '/meet/join/$roomName': typeof meetMeetJoinRoomNameRoute
  '/my/birdie': typeof memberprotectedMyBirdieRoute
  '/my/cart': typeof memberprotectedMyCartRoute
  '/my/chats': typeof memberprotectedMyChatsRoute
  '/my/download': typeof memberprotectedMyDownloadRoute
  '/my/download-app': typeof memberprotectedMyDownloadAppRoute
  '/my/feedback': typeof memberprotectedMyFeedbackRouteWithChildren
  '/my/global-search': typeof memberprotectedMyGlobalSearchRoute
  '/my/help': typeof memberprotectedMyHelpRoute
  '/my/home': typeof memberprotectedMyHomeRoute
  '/my/onboarding': typeof memberprotectedMyOnboardingRoute
  '/my/records': typeof memberprotectedMyRecordsRoute
  '/my/settings': typeof memberprotectedMySettingsRouteWithChildren
  '/my/verify-phone': typeof memberprotectedMyVerifyPhoneRoute
  '/invite/$token': typeof memberpublicInviteTokenRouteWithChildren
  '/join/sign-up': typeof memberpublicJoinSignUpRoute
  '/join/verify': typeof memberpublicJoinVerifyRoute
  '/presale/$': typeof memberpublicPresaleSplatRoute
  '/admin/users/managers/create': typeof AdminUsersManagersCreateRoute
  '/admin/users/members/create': typeof AdminUsersMembersCreateRoute
  '/admin/users/technicians/create': typeof AdminUsersTechniciansCreateRoute
  '/vendors/onboarding/v1/step-0-welcome': typeof VendorsOnboardingV1Step0WelcomeRoute
  '/vendors/onboarding/v1/step-1-business-info': typeof VendorsOnboardingV1Step1BusinessInfoRoute
  '/vendors/onboarding/v1/step-2-legal-compliance': typeof VendorsOnboardingV1Step2LegalComplianceRoute
  '/vendors/onboarding/v1/step-3-service-term': typeof VendorsOnboardingV1Step3ServiceTermRoute
  '/vendors/onboarding/v1/step-4-add-technician': typeof VendorsOnboardingV1Step4AddTechnicianRoute
  '/vendors/onboarding/v1/step-5-review-information': typeof VendorsOnboardingV1Step5ReviewInformationRoute
  '/vendors/onboarding/v1/step-final-submit': typeof VendorsOnboardingV1StepFinalSubmitRoute
  '/my/': typeof memberprotectedMyIndexRoute
  '/join/': typeof memberpublicJoinIndexRoute
  '/office/billing/invoices/': typeof OfficeBillingInvoicesIndexRoute
  '/office/places/onboarding/': typeof OfficePlacesOnboardingIndexRoute
  '/my/campaigns/$campaignSlug': typeof memberprotectedMyCampaignsCampaignSlugRoute
  '/my/checkout/$checkoutId': typeof memberprotectedMyCheckoutCheckoutIdRoute
  '/my/checkout/success': typeof memberprotectedMyCheckoutSuccessRoute
  '/my/feedback/$feedbackId': typeof memberprotectedMyFeedbackFeedbackIdRoute
  '/my/list/archived': typeof memberprotectedMyListArchivedRoute
  '/my/orders/$orderId': typeof memberprotectedMyOrdersOrderIdRoute
  '/my/orders/create': typeof memberprotectedMyOrdersCreateRoute
  '/my/places/add': typeof memberprotectedMyPlacesAddRoute
  '/my/places/exist': typeof memberprotectedMyPlacesExistRoute
  '/my/quotes/$quoteId': typeof memberprotectedMyQuotesQuoteIdRoute
  '/my/requests/submit': typeof memberprotectedMyRequestsSubmitRoute
  '/invite/$token/sign-up': typeof memberpublicInviteTokenSignUpRoute
  '/invite/$token/success': typeof memberpublicInviteTokenSuccessRoute
  '/invite/$token/verify': typeof memberpublicInviteTokenVerifyRoute
  '/public/orders/$orderId': typeof memberpublicPublicOrdersOrderIdRoute
  '/office/billing/accounts/$accountId/wallet': typeof OfficeBillingAccountsAccountIdWalletRoute
  '/office/billing/invoices/$invoiceId/edit': typeof OfficeBillingInvoicesInvoiceIdEditRoute
  '/my/checkout/': typeof memberprotectedMyCheckoutIndexRoute
  '/my/feedback/': typeof memberprotectedMyFeedbackIndexRoute
  '/my/list/': typeof memberprotectedMyListIndexRoute
  '/my/places/': typeof memberprotectedMyPlacesIndexRoute
  '/my/settings/': typeof memberprotectedMySettingsIndexRoute
  '/invite/$token/': typeof memberpublicInviteTokenIndexRoute
  '/my/settings/account/billing': typeof memberprotectedMySettingsAccountBillingRouteWithChildren
  '/my/settings/account/notifications': typeof memberprotectedMySettingsAccountNotificationsRoute
  '/my/settings/account/profile': typeof memberprotectedMySettingsAccountProfileRoute
  '/my/settings/account/security': typeof memberprotectedMySettingsAccountSecurityRoute
  '/my/settings/household/members': typeof memberprotectedMySettingsHouseholdMembersRoute
  '/my/settings/household/membership': typeof memberprotectedMySettingsHouseholdMembershipRoute
  '/my/settings/account/billing/payments': typeof memberprotectedMySettingsAccountBillingPaymentsRouteWithChildren
  '/my/settings/account/billing/wallet': typeof memberprotectedMySettingsAccountBillingWalletRouteWithChildren
  '/my/settings/account/invoices/$invoiceId': typeof memberprotectedMySettingsAccountInvoicesInvoiceIdRoute
  '/my/settings/account/billing/': typeof memberprotectedMySettingsAccountBillingIndexRoute
  '/my/settings/account/invoices/': typeof memberprotectedMySettingsAccountInvoicesIndexRoute
  '/my/settings/account/billing/payments/$paymentMethodId': typeof memberprotectedMySettingsAccountBillingPaymentsPaymentMethodIdRoute
  '/my/settings/account/billing/payments/history': typeof memberprotectedMySettingsAccountBillingPaymentsHistoryRoute
  '/my/settings/account/billing/wallet/history': typeof memberprotectedMySettingsAccountBillingWalletHistoryRoute
  '/my/settings/account/billing/payments/': typeof memberprotectedMySettingsAccountBillingPaymentsIndexRoute
  '/my/settings/account/billing/wallet/': typeof memberprotectedMySettingsAccountBillingWalletIndexRoute
  '/my/settings/account/billing/payments/history/$transactionId': typeof memberprotectedMySettingsAccountBillingPaymentsHistoryTransactionIdRoute
  '/my/settings/account/billing/wallet/history/$walletItemId': typeof memberprotectedMySettingsAccountBillingWalletHistoryWalletItemIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/activate': typeof authActivateRoute
  '/auto-sign-in': typeof authAutoSignInRoute
  '/forgot-password': typeof authForgotPasswordRoute
  '/forgot-password-otp': typeof authForgotPasswordOtpRoute
  '/reset-password': typeof authResetPasswordRoute
  '/reset-password-invalid': typeof authResetPasswordInvalidRoute
  '/reset-password-success': typeof authResetPasswordSuccessRoute
  '/sign-in': typeof authSignInRoute
  '/sign-in-im': typeof authSignInImRoute
  '/sign-in-otp': typeof authSignInOtpRoute
  '/sign-in-password': typeof authSignInPasswordRoute
  '/media-v3-upload': typeof devMediaV3UploadRoute
  '/page-forbidden': typeof errorPageForbiddenRoute
  '/page-not-found': typeof errorPageNotFoundRoute
  '/admin/global-birdie-chat': typeof AdminGlobalBirdieChatRoute
  '/admin/locations': typeof AdminLocationsRouteWithChildren
  '/admin/service-areas': typeof AdminServiceAreasRoute
  '/custom-app/migate-to-quote': typeof CustomAppMigateToQuoteRoute
  '/custom-app/migrate-to-quote': typeof CustomAppMigrateToQuoteRoute
  '/document/$slug': typeof DocumentSlugRoute
  '/homecare-proposal/$proposalId': typeof HomecareProposalProposalIdRoute
  '/office/connect-gg-calendar': typeof OfficeConnectGgCalendarRoute
  '/office/global-birdie-chat': typeof OfficeGlobalBirdieChatRoute
  '/office/global-search': typeof OfficeGlobalSearchRoute
  '/office/inbox': typeof OfficeInboxRoute
  '/office/manage-account': typeof OfficeManageAccountRoute
  '/office/quotes': typeof OfficeQuotesRoute
  '/office/search': typeof OfficeSearchRoute
  '/v/$linkCode': typeof VLinkCodeRoute
  '/admin': typeof AdminIndexRoute
  '/birdie': typeof BirdieIndexRoute
  '/document': typeof DocumentIndexRoute
  '/office': typeof OfficeIndexRoute
  '/vendors/onboarding/v1': typeof VendorsOnboardingV1RouteRouteWithChildren
  '/meet/$roomName': typeof meetMeetRoomNameRoute
  '/pay/$token': typeof payPayTokenRoute
  '/admin/authorization/$roleKey': typeof AdminAuthorizationRoleKeyRoute
  '/admin/authorization/create': typeof AdminAuthorizationCreateRoute
  '/admin/campaigns/$campaignId': typeof AdminCampaignsCampaignIdRoute
  '/admin/campaigns/create': typeof AdminCampaignsCreateRoute
  '/admin/checkout-links/create': typeof AdminCheckoutLinksCreateRoute
  '/admin/customers/$customerId': typeof AdminCustomersCustomerIdRoute
  '/admin/customers/create': typeof AdminCustomersCreateRoute
  '/admin/locations/create': typeof AdminLocationsCreateRoute
  '/admin/subscriptions/create': typeof AdminSubscriptionsCreateRoute
  '/admin/users/create': typeof AdminUsersCreateRoute
  '/admin/users/managers': typeof AdminUsersManagersRouteWithChildren
  '/admin/users/members': typeof AdminUsersMembersRouteWithChildren
  '/admin/users/technicians': typeof AdminUsersTechniciansRouteWithChildren
  '/admin/visits/available-time-slots': typeof AdminVisitsAvailableTimeSlotsRoute
  '/birdie/sessions/$sessionId': typeof BirdieSessionsSessionIdRoute
  '/office/billing/todo': typeof OfficeBillingTodoRoute
  '/office/catalog-new/$catalogItemId': typeof OfficeCatalogNewCatalogItemIdRoute
  '/office/orders/$orderId': typeof OfficeOrdersOrderIdRoute
  '/office/orders/active': typeof OfficeOrdersActiveRoute
  '/office/orders/all': typeof OfficeOrdersAllRoute
  '/office/orders/create': typeof OfficeOrdersCreateRoute
  '/office/orders/future': typeof OfficeOrdersFutureRoute
  '/office/orders/workflow': typeof OfficeOrdersWorkflowRoute
  '/office/places/$placeId': typeof OfficePlacesPlaceIdRoute
  '/office/places/active': typeof OfficePlacesActiveRoute
  '/office/places/all': typeof OfficePlacesAllRoute
  '/office/places/create': typeof OfficePlacesCreateRoute
  '/office/reports/ai-feedback': typeof OfficeReportsAiFeedbackRoute
  '/office/reports/confirmed-churn': typeof OfficeReportsConfirmedChurnRoute
  '/office/reports/homecare-renewals': typeof OfficeReportsHomecareRenewalsRoute
  '/office/reports/member-activation': typeof OfficeReportsMemberActivationRoute
  '/office/reports/one-off-revenue': typeof OfficeReportsOneOffRevenueRoute
  '/office/reports/order-overview': typeof OfficeReportsOrderOverviewRoute
  '/office/reports/revenue': typeof OfficeReportsRevenueRoute
  '/office/reports/vendor-scorecard': typeof OfficeReportsVendorScorecardRoute
  '/office/smart-actions/accuracy': typeof OfficeSmartActionsAccuracyRoute
  '/office/smart-actions/board': typeof OfficeSmartActionsBoardRoute
  '/office/smart-actions/forecast': typeof OfficeSmartActionsForecastRoute
  '/office/smart-actions/lost-costs': typeof OfficeSmartActionsLostCostsRoute
  '/office/tasks/create': typeof OfficeTasksCreateRoute
  '/office/vendors/create': typeof OfficeVendorsCreateRoute
  '/office/vendors/visits': typeof OfficeVendorsVisitsRoute
  '/themes': typeof devThemesIndexRoute
  '/admin/accounts': typeof AdminAccountsIndexRoute
  '/admin/authorization': typeof AdminAuthorizationIndexRoute
  '/admin/campaigns': typeof AdminCampaignsIndexRoute
  '/admin/checkout-links': typeof AdminCheckoutLinksIndexRoute
  '/admin/customers': typeof AdminCustomersIndexRoute
  '/admin/homecare-plan-proposals': typeof AdminHomecarePlanProposalsIndexRoute
  '/admin/purchase-intents': typeof AdminPurchaseIntentsIndexRoute
  '/admin/subscriptions': typeof AdminSubscriptionsIndexRoute
  '/admin/tags': typeof AdminTagsIndexRoute
  '/admin/users': typeof AdminUsersIndexRoute
  '/admin/visits': typeof AdminVisitsIndexRoute
  '/birdie/sessions': typeof BirdieSessionsIndexRoute
  '/office/catalog-new': typeof OfficeCatalogNewIndexRoute
  '/office/notifications': typeof OfficeNotificationsIndexRoute
  '/office/orders': typeof OfficeOrdersIndexRoute
  '/office/places': typeof OfficePlacesIndexRoute
  '/office/reports': typeof OfficeReportsIndexRoute
  '/office/schedule': typeof OfficeScheduleIndexRoute
  '/office/smart-actions': typeof OfficeSmartActionsIndexRoute
  '/office/tasks': typeof OfficeTasksIndexRoute
  '/office/vendors': typeof OfficeVendorsIndexRoute
  '/meet/join/$roomName': typeof meetMeetJoinRoomNameRoute
  '/my/birdie': typeof memberprotectedMyBirdieRoute
  '/my/cart': typeof memberprotectedMyCartRoute
  '/my/chats': typeof memberprotectedMyChatsRoute
  '/my/download': typeof memberprotectedMyDownloadRoute
  '/my/download-app': typeof memberprotectedMyDownloadAppRoute
  '/my/global-search': typeof memberprotectedMyGlobalSearchRoute
  '/my/help': typeof memberprotectedMyHelpRoute
  '/my/home': typeof memberprotectedMyHomeRoute
  '/my/onboarding': typeof memberprotectedMyOnboardingRoute
  '/my/records': typeof memberprotectedMyRecordsRoute
  '/my/verify-phone': typeof memberprotectedMyVerifyPhoneRoute
  '/join/sign-up': typeof memberpublicJoinSignUpRoute
  '/join/verify': typeof memberpublicJoinVerifyRoute
  '/presale/$': typeof memberpublicPresaleSplatRoute
  '/admin/users/managers/create': typeof AdminUsersManagersCreateRoute
  '/admin/users/members/create': typeof AdminUsersMembersCreateRoute
  '/admin/users/technicians/create': typeof AdminUsersTechniciansCreateRoute
  '/vendors/onboarding/v1/step-0-welcome': typeof VendorsOnboardingV1Step0WelcomeRoute
  '/vendors/onboarding/v1/step-1-business-info': typeof VendorsOnboardingV1Step1BusinessInfoRoute
  '/vendors/onboarding/v1/step-2-legal-compliance': typeof VendorsOnboardingV1Step2LegalComplianceRoute
  '/vendors/onboarding/v1/step-3-service-term': typeof VendorsOnboardingV1Step3ServiceTermRoute
  '/vendors/onboarding/v1/step-4-add-technician': typeof VendorsOnboardingV1Step4AddTechnicianRoute
  '/vendors/onboarding/v1/step-5-review-information': typeof VendorsOnboardingV1Step5ReviewInformationRoute
  '/vendors/onboarding/v1/step-final-submit': typeof VendorsOnboardingV1StepFinalSubmitRoute
  '/my': typeof memberprotectedMyIndexRoute
  '/join': typeof memberpublicJoinIndexRoute
  '/office/billing/invoices': typeof OfficeBillingInvoicesIndexRoute
  '/office/places/onboarding': typeof OfficePlacesOnboardingIndexRoute
  '/my/campaigns/$campaignSlug': typeof memberprotectedMyCampaignsCampaignSlugRoute
  '/my/checkout/$checkoutId': typeof memberprotectedMyCheckoutCheckoutIdRoute
  '/my/checkout/success': typeof memberprotectedMyCheckoutSuccessRoute
  '/my/feedback/$feedbackId': typeof memberprotectedMyFeedbackFeedbackIdRoute
  '/my/list/archived': typeof memberprotectedMyListArchivedRoute
  '/my/orders/$orderId': typeof memberprotectedMyOrdersOrderIdRoute
  '/my/orders/create': typeof memberprotectedMyOrdersCreateRoute
  '/my/places/add': typeof memberprotectedMyPlacesAddRoute
  '/my/places/exist': typeof memberprotectedMyPlacesExistRoute
  '/my/quotes/$quoteId': typeof memberprotectedMyQuotesQuoteIdRoute
  '/my/requests/submit': typeof memberprotectedMyRequestsSubmitRoute
  '/invite/$token/sign-up': typeof memberpublicInviteTokenSignUpRoute
  '/invite/$token/success': typeof memberpublicInviteTokenSuccessRoute
  '/invite/$token/verify': typeof memberpublicInviteTokenVerifyRoute
  '/public/orders/$orderId': typeof memberpublicPublicOrdersOrderIdRoute
  '/office/billing/accounts/$accountId/wallet': typeof OfficeBillingAccountsAccountIdWalletRoute
  '/office/billing/invoices/$invoiceId/edit': typeof OfficeBillingInvoicesInvoiceIdEditRoute
  '/my/checkout': typeof memberprotectedMyCheckoutIndexRoute
  '/my/feedback': typeof memberprotectedMyFeedbackIndexRoute
  '/my/list': typeof memberprotectedMyListIndexRoute
  '/my/places': typeof memberprotectedMyPlacesIndexRoute
  '/my/settings': typeof memberprotectedMySettingsIndexRoute
  '/invite/$token': typeof memberpublicInviteTokenIndexRoute
  '/my/settings/account/notifications': typeof memberprotectedMySettingsAccountNotificationsRoute
  '/my/settings/account/profile': typeof memberprotectedMySettingsAccountProfileRoute
  '/my/settings/account/security': typeof memberprotectedMySettingsAccountSecurityRoute
  '/my/settings/household/members': typeof memberprotectedMySettingsHouseholdMembersRoute
  '/my/settings/household/membership': typeof memberprotectedMySettingsHouseholdMembershipRoute
  '/my/settings/account/invoices/$invoiceId': typeof memberprotectedMySettingsAccountInvoicesInvoiceIdRoute
  '/my/settings/account/billing': typeof memberprotectedMySettingsAccountBillingIndexRoute
  '/my/settings/account/invoices': typeof memberprotectedMySettingsAccountInvoicesIndexRoute
  '/my/settings/account/billing/payments/$paymentMethodId': typeof memberprotectedMySettingsAccountBillingPaymentsPaymentMethodIdRoute
  '/my/settings/account/billing/payments/history': typeof memberprotectedMySettingsAccountBillingPaymentsHistoryRoute
  '/my/settings/account/billing/wallet/history': typeof memberprotectedMySettingsAccountBillingWalletHistoryRoute
  '/my/settings/account/billing/payments': typeof memberprotectedMySettingsAccountBillingPaymentsIndexRoute
  '/my/settings/account/billing/wallet': typeof memberprotectedMySettingsAccountBillingWalletIndexRoute
  '/my/settings/account/billing/payments/history/$transactionId': typeof memberprotectedMySettingsAccountBillingPaymentsHistoryTransactionIdRoute
  '/my/settings/account/billing/wallet/history/$walletItemId': typeof memberprotectedMySettingsAccountBillingWalletHistoryWalletItemIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/(error)': typeof errorRouteRouteWithChildren
  '/(meet)': typeof meetRouteRouteWithChildren
  '/(member)': typeof memberRouteRouteWithChildren
  '/(pay)': typeof payRouteRouteWithChildren
  '/admin': typeof AdminRouteRouteWithChildren
  '/birdie': typeof BirdieRouteRouteWithChildren
  '/document': typeof DocumentRouteRouteWithChildren
  '/office': typeof OfficeRouteRouteWithChildren
  '/(member)/(protected)': typeof memberprotectedRouteRouteWithChildren
  '/(auth)/activate': typeof authActivateRoute
  '/(auth)/auto-sign-in': typeof authAutoSignInRoute
  '/(auth)/forgot-password': typeof authForgotPasswordRoute
  '/(auth)/forgot-password-otp': typeof authForgotPasswordOtpRoute
  '/(auth)/reset-password': typeof authResetPasswordRoute
  '/(auth)/reset-password-invalid': typeof authResetPasswordInvalidRoute
  '/(auth)/reset-password-success': typeof authResetPasswordSuccessRoute
  '/(auth)/sign-in': typeof authSignInRoute
  '/(auth)/sign-in-im': typeof authSignInImRoute
  '/(auth)/sign-in-otp': typeof authSignInOtpRoute
  '/(auth)/sign-in-password': typeof authSignInPasswordRoute
  '/(dev)/media-v3-upload': typeof devMediaV3UploadRoute
  '/(error)/page-forbidden': typeof errorPageForbiddenRoute
  '/(error)/page-not-found': typeof errorPageNotFoundRoute
  '/admin/global-birdie-chat': typeof AdminGlobalBirdieChatRoute
  '/admin/locations': typeof AdminLocationsRouteWithChildren
  '/admin/service-areas': typeof AdminServiceAreasRoute
  '/custom-app/migate-to-quote': typeof CustomAppMigateToQuoteRoute
  '/custom-app/migrate-to-quote': typeof CustomAppMigrateToQuoteRoute
  '/document/$slug': typeof DocumentSlugRoute
  '/homecare-proposal/$proposalId': typeof HomecareProposalProposalIdRoute
  '/office/connect-gg-calendar': typeof OfficeConnectGgCalendarRoute
  '/office/global-birdie-chat': typeof OfficeGlobalBirdieChatRoute
  '/office/global-search': typeof OfficeGlobalSearchRoute
  '/office/inbox': typeof OfficeInboxRoute
  '/office/manage-account': typeof OfficeManageAccountRoute
  '/office/quotes': typeof OfficeQuotesRoute
  '/office/search': typeof OfficeSearchRoute
  '/v/$linkCode': typeof VLinkCodeRoute
  '/admin/': typeof AdminIndexRoute
  '/birdie/': typeof BirdieIndexRoute
  '/document/': typeof DocumentIndexRoute
  '/office/': typeof OfficeIndexRoute
  '/vendors/onboarding/v1': typeof VendorsOnboardingV1RouteRouteWithChildren
  '/(meet)/meet/$roomName': typeof meetMeetRoomNameRoute
  '/(member)/(protected)/my': typeof memberprotectedMyRouteWithChildren
  '/(member)/(public)/join': typeof memberpublicJoinRouteWithChildren
  '/(pay)/pay/$token': typeof payPayTokenRoute
  '/admin/authorization/$roleKey': typeof AdminAuthorizationRoleKeyRoute
  '/admin/authorization/create': typeof AdminAuthorizationCreateRoute
  '/admin/campaigns/$campaignId': typeof AdminCampaignsCampaignIdRoute
  '/admin/campaigns/create': typeof AdminCampaignsCreateRoute
  '/admin/checkout-links/create': typeof AdminCheckoutLinksCreateRoute
  '/admin/customers/$customerId': typeof AdminCustomersCustomerIdRoute
  '/admin/customers/create': typeof AdminCustomersCreateRoute
  '/admin/locations/create': typeof AdminLocationsCreateRoute
  '/admin/subscriptions/create': typeof AdminSubscriptionsCreateRoute
  '/admin/users/create': typeof AdminUsersCreateRoute
  '/admin/users/managers': typeof AdminUsersManagersRouteWithChildren
  '/admin/users/members': typeof AdminUsersMembersRouteWithChildren
  '/admin/users/technicians': typeof AdminUsersTechniciansRouteWithChildren
  '/admin/visits/available-time-slots': typeof AdminVisitsAvailableTimeSlotsRoute
  '/birdie/sessions/$sessionId': typeof BirdieSessionsSessionIdRoute
  '/office/billing/todo': typeof OfficeBillingTodoRoute
  '/office/catalog-new/$catalogItemId': typeof OfficeCatalogNewCatalogItemIdRoute
  '/office/orders/$orderId': typeof OfficeOrdersOrderIdRoute
  '/office/orders/active': typeof OfficeOrdersActiveRoute
  '/office/orders/all': typeof OfficeOrdersAllRoute
  '/office/orders/create': typeof OfficeOrdersCreateRoute
  '/office/orders/future': typeof OfficeOrdersFutureRoute
  '/office/orders/workflow': typeof OfficeOrdersWorkflowRoute
  '/office/places/$placeId': typeof OfficePlacesPlaceIdRoute
  '/office/places/active': typeof OfficePlacesActiveRoute
  '/office/places/all': typeof OfficePlacesAllRoute
  '/office/places/create': typeof OfficePlacesCreateRoute
  '/office/reports/ai-feedback': typeof OfficeReportsAiFeedbackRoute
  '/office/reports/confirmed-churn': typeof OfficeReportsConfirmedChurnRoute
  '/office/reports/homecare-renewals': typeof OfficeReportsHomecareRenewalsRoute
  '/office/reports/member-activation': typeof OfficeReportsMemberActivationRoute
  '/office/reports/one-off-revenue': typeof OfficeReportsOneOffRevenueRoute
  '/office/reports/order-overview': typeof OfficeReportsOrderOverviewRoute
  '/office/reports/revenue': typeof OfficeReportsRevenueRoute
  '/office/reports/vendor-scorecard': typeof OfficeReportsVendorScorecardRoute
  '/office/smart-actions/accuracy': typeof OfficeSmartActionsAccuracyRoute
  '/office/smart-actions/board': typeof OfficeSmartActionsBoardRoute
  '/office/smart-actions/forecast': typeof OfficeSmartActionsForecastRoute
  '/office/smart-actions/lost-costs': typeof OfficeSmartActionsLostCostsRoute
  '/office/tasks/create': typeof OfficeTasksCreateRoute
  '/office/vendors/create': typeof OfficeVendorsCreateRoute
  '/office/vendors/visits': typeof OfficeVendorsVisitsRoute
  '/(dev)/themes/': typeof devThemesIndexRoute
  '/admin/accounts/': typeof AdminAccountsIndexRoute
  '/admin/authorization/': typeof AdminAuthorizationIndexRoute
  '/admin/campaigns/': typeof AdminCampaignsIndexRoute
  '/admin/checkout-links/': typeof AdminCheckoutLinksIndexRoute
  '/admin/customers/': typeof AdminCustomersIndexRoute
  '/admin/homecare-plan-proposals/': typeof AdminHomecarePlanProposalsIndexRoute
  '/admin/purchase-intents/': typeof AdminPurchaseIntentsIndexRoute
  '/admin/subscriptions/': typeof AdminSubscriptionsIndexRoute
  '/admin/tags/': typeof AdminTagsIndexRoute
  '/admin/users/': typeof AdminUsersIndexRoute
  '/admin/visits/': typeof AdminVisitsIndexRoute
  '/birdie/sessions/': typeof BirdieSessionsIndexRoute
  '/office/catalog-new/': typeof OfficeCatalogNewIndexRoute
  '/office/notifications/': typeof OfficeNotificationsIndexRoute
  '/office/orders/': typeof OfficeOrdersIndexRoute
  '/office/places/': typeof OfficePlacesIndexRoute
  '/office/reports/': typeof OfficeReportsIndexRoute
  '/office/schedule/': typeof OfficeScheduleIndexRoute
  '/office/smart-actions/': typeof OfficeSmartActionsIndexRoute
  '/office/tasks/': typeof OfficeTasksIndexRoute
  '/office/vendors/': typeof OfficeVendorsIndexRoute
  '/(meet)/meet/join/$roomName': typeof meetMeetJoinRoomNameRoute
  '/(member)/(protected)/my/birdie': typeof memberprotectedMyBirdieRoute
  '/(member)/(protected)/my/cart': typeof memberprotectedMyCartRoute
  '/(member)/(protected)/my/chats': typeof memberprotectedMyChatsRoute
  '/(member)/(protected)/my/download': typeof memberprotectedMyDownloadRoute
  '/(member)/(protected)/my/download-app': typeof memberprotectedMyDownloadAppRoute
  '/(member)/(protected)/my/feedback': typeof memberprotectedMyFeedbackRouteWithChildren
  '/(member)/(protected)/my/global-search': typeof memberprotectedMyGlobalSearchRoute
  '/(member)/(protected)/my/help': typeof memberprotectedMyHelpRoute
  '/(member)/(protected)/my/home': typeof memberprotectedMyHomeRoute
  '/(member)/(protected)/my/onboarding': typeof memberprotectedMyOnboardingRoute
  '/(member)/(protected)/my/records': typeof memberprotectedMyRecordsRoute
  '/(member)/(protected)/my/settings': typeof memberprotectedMySettingsRouteWithChildren
  '/(member)/(protected)/my/verify-phone': typeof memberprotectedMyVerifyPhoneRoute
  '/(member)/(public)/invite/$token': typeof memberpublicInviteTokenRouteWithChildren
  '/(member)/(public)/join/sign-up': typeof memberpublicJoinSignUpRoute
  '/(member)/(public)/join/verify': typeof memberpublicJoinVerifyRoute
  '/(member)/(public)/presale/$': typeof memberpublicPresaleSplatRoute
  '/admin/users/managers/create': typeof AdminUsersManagersCreateRoute
  '/admin/users/members/create': typeof AdminUsersMembersCreateRoute
  '/admin/users/technicians/create': typeof AdminUsersTechniciansCreateRoute
  '/vendors/onboarding/v1/step-0-welcome': typeof VendorsOnboardingV1Step0WelcomeRoute
  '/vendors/onboarding/v1/step-1-business-info': typeof VendorsOnboardingV1Step1BusinessInfoRoute
  '/vendors/onboarding/v1/step-2-legal-compliance': typeof VendorsOnboardingV1Step2LegalComplianceRoute
  '/vendors/onboarding/v1/step-3-service-term': typeof VendorsOnboardingV1Step3ServiceTermRoute
  '/vendors/onboarding/v1/step-4-add-technician': typeof VendorsOnboardingV1Step4AddTechnicianRoute
  '/vendors/onboarding/v1/step-5-review-information': typeof VendorsOnboardingV1Step5ReviewInformationRoute
  '/vendors/onboarding/v1/step-final-submit': typeof VendorsOnboardingV1StepFinalSubmitRoute
  '/(member)/(protected)/my/': typeof memberprotectedMyIndexRoute
  '/(member)/(public)/join/': typeof memberpublicJoinIndexRoute
  '/office/billing/invoices/': typeof OfficeBillingInvoicesIndexRoute
  '/office/places/onboarding/': typeof OfficePlacesOnboardingIndexRoute
  '/(member)/(protected)/my/campaigns/$campaignSlug': typeof memberprotectedMyCampaignsCampaignSlugRoute
  '/(member)/(protected)/my/checkout/$checkoutId': typeof memberprotectedMyCheckoutCheckoutIdRoute
  '/(member)/(protected)/my/checkout/success': typeof memberprotectedMyCheckoutSuccessRoute
  '/(member)/(protected)/my/feedback/$feedbackId': typeof memberprotectedMyFeedbackFeedbackIdRoute
  '/(member)/(protected)/my/list/archived': typeof memberprotectedMyListArchivedRoute
  '/(member)/(protected)/my/orders/$orderId': typeof memberprotectedMyOrdersOrderIdRoute
  '/(member)/(protected)/my/orders/create': typeof memberprotectedMyOrdersCreateRoute
  '/(member)/(protected)/my/places/add': typeof memberprotectedMyPlacesAddRoute
  '/(member)/(protected)/my/places/exist': typeof memberprotectedMyPlacesExistRoute
  '/(member)/(protected)/my/quotes/$quoteId': typeof memberprotectedMyQuotesQuoteIdRoute
  '/(member)/(protected)/my/requests/submit': typeof memberprotectedMyRequestsSubmitRoute
  '/(member)/(public)/invite/$token/sign-up': typeof memberpublicInviteTokenSignUpRoute
  '/(member)/(public)/invite/$token/success': typeof memberpublicInviteTokenSuccessRoute
  '/(member)/(public)/invite/$token/verify': typeof memberpublicInviteTokenVerifyRoute
  '/(member)/(public)/public/orders/$orderId': typeof memberpublicPublicOrdersOrderIdRoute
  '/office/billing/accounts/$accountId/wallet': typeof OfficeBillingAccountsAccountIdWalletRoute
  '/office/billing/invoices/$invoiceId/edit': typeof OfficeBillingInvoicesInvoiceIdEditRoute
  '/(member)/(protected)/my/checkout/': typeof memberprotectedMyCheckoutIndexRoute
  '/(member)/(protected)/my/feedback/': typeof memberprotectedMyFeedbackIndexRoute
  '/(member)/(protected)/my/list/': typeof memberprotectedMyListIndexRoute
  '/(member)/(protected)/my/places/': typeof memberprotectedMyPlacesIndexRoute
  '/(member)/(protected)/my/settings/': typeof memberprotectedMySettingsIndexRoute
  '/(member)/(public)/invite/$token/': typeof memberpublicInviteTokenIndexRoute
  '/(member)/(protected)/my/settings/account/billing': typeof memberprotectedMySettingsAccountBillingRouteWithChildren
  '/(member)/(protected)/my/settings/account/notifications': typeof memberprotectedMySettingsAccountNotificationsRoute
  '/(member)/(protected)/my/settings/account/profile': typeof memberprotectedMySettingsAccountProfileRoute
  '/(member)/(protected)/my/settings/account/security': typeof memberprotectedMySettingsAccountSecurityRoute
  '/(member)/(protected)/my/settings/household/members': typeof memberprotectedMySettingsHouseholdMembersRoute
  '/(member)/(protected)/my/settings/household/membership': typeof memberprotectedMySettingsHouseholdMembershipRoute
  '/(member)/(protected)/my/settings/account/billing/payments': typeof memberprotectedMySettingsAccountBillingPaymentsRouteWithChildren
  '/(member)/(protected)/my/settings/account/billing/wallet': typeof memberprotectedMySettingsAccountBillingWalletRouteWithChildren
  '/(member)/(protected)/my/settings/account/invoices/$invoiceId': typeof memberprotectedMySettingsAccountInvoicesInvoiceIdRoute
  '/(member)/(protected)/my/settings/account/billing/': typeof memberprotectedMySettingsAccountBillingIndexRoute
  '/(member)/(protected)/my/settings/account/invoices/': typeof memberprotectedMySettingsAccountInvoicesIndexRoute
  '/(member)/(protected)/my/settings/account/billing/payments/$paymentMethodId': typeof memberprotectedMySettingsAccountBillingPaymentsPaymentMethodIdRoute
  '/(member)/(protected)/my/settings/account/billing/payments/history': typeof memberprotectedMySettingsAccountBillingPaymentsHistoryRoute
  '/(member)/(protected)/my/settings/account/billing/wallet/history': typeof memberprotectedMySettingsAccountBillingWalletHistoryRoute
  '/(member)/(protected)/my/settings/account/billing/payments/': typeof memberprotectedMySettingsAccountBillingPaymentsIndexRoute
  '/(member)/(protected)/my/settings/account/billing/wallet/': typeof memberprotectedMySettingsAccountBillingWalletIndexRoute
  '/(member)/(protected)/my/settings/account/billing/payments/history_/$transactionId': typeof memberprotectedMySettingsAccountBillingPaymentsHistoryTransactionIdRoute
  '/(member)/(protected)/my/settings/account/billing/wallet/history_/$walletItemId': typeof memberprotectedMySettingsAccountBillingWalletHistoryWalletItemIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/birdie'
    | '/document'
    | '/office'
    | '/activate'
    | '/auto-sign-in'
    | '/forgot-password'
    | '/forgot-password-otp'
    | '/reset-password'
    | '/reset-password-invalid'
    | '/reset-password-success'
    | '/sign-in'
    | '/sign-in-im'
    | '/sign-in-otp'
    | '/sign-in-password'
    | '/media-v3-upload'
    | '/page-forbidden'
    | '/page-not-found'
    | '/admin/global-birdie-chat'
    | '/admin/locations'
    | '/admin/service-areas'
    | '/custom-app/migate-to-quote'
    | '/custom-app/migrate-to-quote'
    | '/document/$slug'
    | '/homecare-proposal/$proposalId'
    | '/office/connect-gg-calendar'
    | '/office/global-birdie-chat'
    | '/office/global-search'
    | '/office/inbox'
    | '/office/manage-account'
    | '/office/quotes'
    | '/office/search'
    | '/v/$linkCode'
    | '/admin/'
    | '/birdie/'
    | '/document/'
    | '/office/'
    | '/vendors/onboarding/v1'
    | '/meet/$roomName'
    | '/my'
    | '/join'
    | '/pay/$token'
    | '/admin/authorization/$roleKey'
    | '/admin/authorization/create'
    | '/admin/campaigns/$campaignId'
    | '/admin/campaigns/create'
    | '/admin/checkout-links/create'
    | '/admin/customers/$customerId'
    | '/admin/customers/create'
    | '/admin/locations/create'
    | '/admin/subscriptions/create'
    | '/admin/users/create'
    | '/admin/users/managers'
    | '/admin/users/members'
    | '/admin/users/technicians'
    | '/admin/visits/available-time-slots'
    | '/birdie/sessions/$sessionId'
    | '/office/billing/todo'
    | '/office/catalog-new/$catalogItemId'
    | '/office/orders/$orderId'
    | '/office/orders/active'
    | '/office/orders/all'
    | '/office/orders/create'
    | '/office/orders/future'
    | '/office/orders/workflow'
    | '/office/places/$placeId'
    | '/office/places/active'
    | '/office/places/all'
    | '/office/places/create'
    | '/office/reports/ai-feedback'
    | '/office/reports/confirmed-churn'
    | '/office/reports/homecare-renewals'
    | '/office/reports/member-activation'
    | '/office/reports/one-off-revenue'
    | '/office/reports/order-overview'
    | '/office/reports/revenue'
    | '/office/reports/vendor-scorecard'
    | '/office/smart-actions/accuracy'
    | '/office/smart-actions/board'
    | '/office/smart-actions/forecast'
    | '/office/smart-actions/lost-costs'
    | '/office/tasks/create'
    | '/office/vendors/create'
    | '/office/vendors/visits'
    | '/themes/'
    | '/admin/accounts/'
    | '/admin/authorization/'
    | '/admin/campaigns/'
    | '/admin/checkout-links/'
    | '/admin/customers/'
    | '/admin/homecare-plan-proposals/'
    | '/admin/purchase-intents/'
    | '/admin/subscriptions/'
    | '/admin/tags/'
    | '/admin/users/'
    | '/admin/visits/'
    | '/birdie/sessions/'
    | '/office/catalog-new/'
    | '/office/notifications/'
    | '/office/orders/'
    | '/office/places/'
    | '/office/reports/'
    | '/office/schedule/'
    | '/office/smart-actions/'
    | '/office/tasks/'
    | '/office/vendors/'
    | '/meet/join/$roomName'
    | '/my/birdie'
    | '/my/cart'
    | '/my/chats'
    | '/my/download'
    | '/my/download-app'
    | '/my/feedback'
    | '/my/global-search'
    | '/my/help'
    | '/my/home'
    | '/my/onboarding'
    | '/my/records'
    | '/my/settings'
    | '/my/verify-phone'
    | '/invite/$token'
    | '/join/sign-up'
    | '/join/verify'
    | '/presale/$'
    | '/admin/users/managers/create'
    | '/admin/users/members/create'
    | '/admin/users/technicians/create'
    | '/vendors/onboarding/v1/step-0-welcome'
    | '/vendors/onboarding/v1/step-1-business-info'
    | '/vendors/onboarding/v1/step-2-legal-compliance'
    | '/vendors/onboarding/v1/step-3-service-term'
    | '/vendors/onboarding/v1/step-4-add-technician'
    | '/vendors/onboarding/v1/step-5-review-information'
    | '/vendors/onboarding/v1/step-final-submit'
    | '/my/'
    | '/join/'
    | '/office/billing/invoices/'
    | '/office/places/onboarding/'
    | '/my/campaigns/$campaignSlug'
    | '/my/checkout/$checkoutId'
    | '/my/checkout/success'
    | '/my/feedback/$feedbackId'
    | '/my/list/archived'
    | '/my/orders/$orderId'
    | '/my/orders/create'
    | '/my/places/add'
    | '/my/places/exist'
    | '/my/quotes/$quoteId'
    | '/my/requests/submit'
    | '/invite/$token/sign-up'
    | '/invite/$token/success'
    | '/invite/$token/verify'
    | '/public/orders/$orderId'
    | '/office/billing/accounts/$accountId/wallet'
    | '/office/billing/invoices/$invoiceId/edit'
    | '/my/checkout/'
    | '/my/feedback/'
    | '/my/list/'
    | '/my/places/'
    | '/my/settings/'
    | '/invite/$token/'
    | '/my/settings/account/billing'
    | '/my/settings/account/notifications'
    | '/my/settings/account/profile'
    | '/my/settings/account/security'
    | '/my/settings/household/members'
    | '/my/settings/household/membership'
    | '/my/settings/account/billing/payments'
    | '/my/settings/account/billing/wallet'
    | '/my/settings/account/invoices/$invoiceId'
    | '/my/settings/account/billing/'
    | '/my/settings/account/invoices/'
    | '/my/settings/account/billing/payments/$paymentMethodId'
    | '/my/settings/account/billing/payments/history'
    | '/my/settings/account/billing/wallet/history'
    | '/my/settings/account/billing/payments/'
    | '/my/settings/account/billing/wallet/'
    | '/my/settings/account/billing/payments/history/$transactionId'
    | '/my/settings/account/billing/wallet/history/$walletItemId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/activate'
    | '/auto-sign-in'
    | '/forgot-password'
    | '/forgot-password-otp'
    | '/reset-password'
    | '/reset-password-invalid'
    | '/reset-password-success'
    | '/sign-in'
    | '/sign-in-im'
    | '/sign-in-otp'
    | '/sign-in-password'
    | '/media-v3-upload'
    | '/page-forbidden'
    | '/page-not-found'
    | '/admin/global-birdie-chat'
    | '/admin/locations'
    | '/admin/service-areas'
    | '/custom-app/migate-to-quote'
    | '/custom-app/migrate-to-quote'
    | '/document/$slug'
    | '/homecare-proposal/$proposalId'
    | '/office/connect-gg-calendar'
    | '/office/global-birdie-chat'
    | '/office/global-search'
    | '/office/inbox'
    | '/office/manage-account'
    | '/office/quotes'
    | '/office/search'
    | '/v/$linkCode'
    | '/admin'
    | '/birdie'
    | '/document'
    | '/office'
    | '/vendors/onboarding/v1'
    | '/meet/$roomName'
    | '/pay/$token'
    | '/admin/authorization/$roleKey'
    | '/admin/authorization/create'
    | '/admin/campaigns/$campaignId'
    | '/admin/campaigns/create'
    | '/admin/checkout-links/create'
    | '/admin/customers/$customerId'
    | '/admin/customers/create'
    | '/admin/locations/create'
    | '/admin/subscriptions/create'
    | '/admin/users/create'
    | '/admin/users/managers'
    | '/admin/users/members'
    | '/admin/users/technicians'
    | '/admin/visits/available-time-slots'
    | '/birdie/sessions/$sessionId'
    | '/office/billing/todo'
    | '/office/catalog-new/$catalogItemId'
    | '/office/orders/$orderId'
    | '/office/orders/active'
    | '/office/orders/all'
    | '/office/orders/create'
    | '/office/orders/future'
    | '/office/orders/workflow'
    | '/office/places/$placeId'
    | '/office/places/active'
    | '/office/places/all'
    | '/office/places/create'
    | '/office/reports/ai-feedback'
    | '/office/reports/confirmed-churn'
    | '/office/reports/homecare-renewals'
    | '/office/reports/member-activation'
    | '/office/reports/one-off-revenue'
    | '/office/reports/order-overview'
    | '/office/reports/revenue'
    | '/office/reports/vendor-scorecard'
    | '/office/smart-actions/accuracy'
    | '/office/smart-actions/board'
    | '/office/smart-actions/forecast'
    | '/office/smart-actions/lost-costs'
    | '/office/tasks/create'
    | '/office/vendors/create'
    | '/office/vendors/visits'
    | '/themes'
    | '/admin/accounts'
    | '/admin/authorization'
    | '/admin/campaigns'
    | '/admin/checkout-links'
    | '/admin/customers'
    | '/admin/homecare-plan-proposals'
    | '/admin/purchase-intents'
    | '/admin/subscriptions'
    | '/admin/tags'
    | '/admin/users'
    | '/admin/visits'
    | '/birdie/sessions'
    | '/office/catalog-new'
    | '/office/notifications'
    | '/office/orders'
    | '/office/places'
    | '/office/reports'
    | '/office/schedule'
    | '/office/smart-actions'
    | '/office/tasks'
    | '/office/vendors'
    | '/meet/join/$roomName'
    | '/my/birdie'
    | '/my/cart'
    | '/my/chats'
    | '/my/download'
    | '/my/download-app'
    | '/my/global-search'
    | '/my/help'
    | '/my/home'
    | '/my/onboarding'
    | '/my/records'
    | '/my/verify-phone'
    | '/join/sign-up'
    | '/join/verify'
    | '/presale/$'
    | '/admin/users/managers/create'
    | '/admin/users/members/create'
    | '/admin/users/technicians/create'
    | '/vendors/onboarding/v1/step-0-welcome'
    | '/vendors/onboarding/v1/step-1-business-info'
    | '/vendors/onboarding/v1/step-2-legal-compliance'
    | '/vendors/onboarding/v1/step-3-service-term'
    | '/vendors/onboarding/v1/step-4-add-technician'
    | '/vendors/onboarding/v1/step-5-review-information'
    | '/vendors/onboarding/v1/step-final-submit'
    | '/my'
    | '/join'
    | '/office/billing/invoices'
    | '/office/places/onboarding'
    | '/my/campaigns/$campaignSlug'
    | '/my/checkout/$checkoutId'
    | '/my/checkout/success'
    | '/my/feedback/$feedbackId'
    | '/my/list/archived'
    | '/my/orders/$orderId'
    | '/my/orders/create'
    | '/my/places/add'
    | '/my/places/exist'
    | '/my/quotes/$quoteId'
    | '/my/requests/submit'
    | '/invite/$token/sign-up'
    | '/invite/$token/success'
    | '/invite/$token/verify'
    | '/public/orders/$orderId'
    | '/office/billing/accounts/$accountId/wallet'
    | '/office/billing/invoices/$invoiceId/edit'
    | '/my/checkout'
    | '/my/feedback'
    | '/my/list'
    | '/my/places'
    | '/my/settings'
    | '/invite/$token'
    | '/my/settings/account/notifications'
    | '/my/settings/account/profile'
    | '/my/settings/account/security'
    | '/my/settings/household/members'
    | '/my/settings/household/membership'
    | '/my/settings/account/invoices/$invoiceId'
    | '/my/settings/account/billing'
    | '/my/settings/account/invoices'
    | '/my/settings/account/billing/payments/$paymentMethodId'
    | '/my/settings/account/billing/payments/history'
    | '/my/settings/account/billing/wallet/history'
    | '/my/settings/account/billing/payments'
    | '/my/settings/account/billing/wallet'
    | '/my/settings/account/billing/payments/history/$transactionId'
    | '/my/settings/account/billing/wallet/history/$walletItemId'
  id:
    | '__root__'
    | '/'
    | '/(error)'
    | '/(meet)'
    | '/(member)'
    | '/(pay)'
    | '/admin'
    | '/birdie'
    | '/document'
    | '/office'
    | '/(member)/(protected)'
    | '/(auth)/activate'
    | '/(auth)/auto-sign-in'
    | '/(auth)/forgot-password'
    | '/(auth)/forgot-password-otp'
    | '/(auth)/reset-password'
    | '/(auth)/reset-password-invalid'
    | '/(auth)/reset-password-success'
    | '/(auth)/sign-in'
    | '/(auth)/sign-in-im'
    | '/(auth)/sign-in-otp'
    | '/(auth)/sign-in-password'
    | '/(dev)/media-v3-upload'
    | '/(error)/page-forbidden'
    | '/(error)/page-not-found'
    | '/admin/global-birdie-chat'
    | '/admin/locations'
    | '/admin/service-areas'
    | '/custom-app/migate-to-quote'
    | '/custom-app/migrate-to-quote'
    | '/document/$slug'
    | '/homecare-proposal/$proposalId'
    | '/office/connect-gg-calendar'
    | '/office/global-birdie-chat'
    | '/office/global-search'
    | '/office/inbox'
    | '/office/manage-account'
    | '/office/quotes'
    | '/office/search'
    | '/v/$linkCode'
    | '/admin/'
    | '/birdie/'
    | '/document/'
    | '/office/'
    | '/vendors/onboarding/v1'
    | '/(meet)/meet/$roomName'
    | '/(member)/(protected)/my'
    | '/(member)/(public)/join'
    | '/(pay)/pay/$token'
    | '/admin/authorization/$roleKey'
    | '/admin/authorization/create'
    | '/admin/campaigns/$campaignId'
    | '/admin/campaigns/create'
    | '/admin/checkout-links/create'
    | '/admin/customers/$customerId'
    | '/admin/customers/create'
    | '/admin/locations/create'
    | '/admin/subscriptions/create'
    | '/admin/users/create'
    | '/admin/users/managers'
    | '/admin/users/members'
    | '/admin/users/technicians'
    | '/admin/visits/available-time-slots'
    | '/birdie/sessions/$sessionId'
    | '/office/billing/todo'
    | '/office/catalog-new/$catalogItemId'
    | '/office/orders/$orderId'
    | '/office/orders/active'
    | '/office/orders/all'
    | '/office/orders/create'
    | '/office/orders/future'
    | '/office/orders/workflow'
    | '/office/places/$placeId'
    | '/office/places/active'
    | '/office/places/all'
    | '/office/places/create'
    | '/office/reports/ai-feedback'
    | '/office/reports/confirmed-churn'
    | '/office/reports/homecare-renewals'
    | '/office/reports/member-activation'
    | '/office/reports/one-off-revenue'
    | '/office/reports/order-overview'
    | '/office/reports/revenue'
    | '/office/reports/vendor-scorecard'
    | '/office/smart-actions/accuracy'
    | '/office/smart-actions/board'
    | '/office/smart-actions/forecast'
    | '/office/smart-actions/lost-costs'
    | '/office/tasks/create'
    | '/office/vendors/create'
    | '/office/vendors/visits'
    | '/(dev)/themes/'
    | '/admin/accounts/'
    | '/admin/authorization/'
    | '/admin/campaigns/'
    | '/admin/checkout-links/'
    | '/admin/customers/'
    | '/admin/homecare-plan-proposals/'
    | '/admin/purchase-intents/'
    | '/admin/subscriptions/'
    | '/admin/tags/'
    | '/admin/users/'
    | '/admin/visits/'
    | '/birdie/sessions/'
    | '/office/catalog-new/'
    | '/office/notifications/'
    | '/office/orders/'
    | '/office/places/'
    | '/office/reports/'
    | '/office/schedule/'
    | '/office/smart-actions/'
    | '/office/tasks/'
    | '/office/vendors/'
    | '/(meet)/meet/join/$roomName'
    | '/(member)/(protected)/my/birdie'
    | '/(member)/(protected)/my/cart'
    | '/(member)/(protected)/my/chats'
    | '/(member)/(protected)/my/download'
    | '/(member)/(protected)/my/download-app'
    | '/(member)/(protected)/my/feedback'
    | '/(member)/(protected)/my/global-search'
    | '/(member)/(protected)/my/help'
    | '/(member)/(protected)/my/home'
    | '/(member)/(protected)/my/onboarding'
    | '/(member)/(protected)/my/records'
    | '/(member)/(protected)/my/settings'
    | '/(member)/(protected)/my/verify-phone'
    | '/(member)/(public)/invite/$token'
    | '/(member)/(public)/join/sign-up'
    | '/(member)/(public)/join/verify'
    | '/(member)/(public)/presale/$'
    | '/admin/users/managers/create'
    | '/admin/users/members/create'
    | '/admin/users/technicians/create'
    | '/vendors/onboarding/v1/step-0-welcome'
    | '/vendors/onboarding/v1/step-1-business-info'
    | '/vendors/onboarding/v1/step-2-legal-compliance'
    | '/vendors/onboarding/v1/step-3-service-term'
    | '/vendors/onboarding/v1/step-4-add-technician'
    | '/vendors/onboarding/v1/step-5-review-information'
    | '/vendors/onboarding/v1/step-final-submit'
    | '/(member)/(protected)/my/'
    | '/(member)/(public)/join/'
    | '/office/billing/invoices/'
    | '/office/places/onboarding/'
    | '/(member)/(protected)/my/campaigns/$campaignSlug'
    | '/(member)/(protected)/my/checkout/$checkoutId'
    | '/(member)/(protected)/my/checkout/success'
    | '/(member)/(protected)/my/feedback/$feedbackId'
    | '/(member)/(protected)/my/list/archived'
    | '/(member)/(protected)/my/orders/$orderId'
    | '/(member)/(protected)/my/orders/create'
    | '/(member)/(protected)/my/places/add'
    | '/(member)/(protected)/my/places/exist'
    | '/(member)/(protected)/my/quotes/$quoteId'
    | '/(member)/(protected)/my/requests/submit'
    | '/(member)/(public)/invite/$token/sign-up'
    | '/(member)/(public)/invite/$token/success'
    | '/(member)/(public)/invite/$token/verify'
    | '/(member)/(public)/public/orders/$orderId'
    | '/office/billing/accounts/$accountId/wallet'
    | '/office/billing/invoices/$invoiceId/edit'
    | '/(member)/(protected)/my/checkout/'
    | '/(member)/(protected)/my/feedback/'
    | '/(member)/(protected)/my/list/'
    | '/(member)/(protected)/my/places/'
    | '/(member)/(protected)/my/settings/'
    | '/(member)/(public)/invite/$token/'
    | '/(member)/(protected)/my/settings/account/billing'
    | '/(member)/(protected)/my/settings/account/notifications'
    | '/(member)/(protected)/my/settings/account/profile'
    | '/(member)/(protected)/my/settings/account/security'
    | '/(member)/(protected)/my/settings/household/members'
    | '/(member)/(protected)/my/settings/household/membership'
    | '/(member)/(protected)/my/settings/account/billing/payments'
    | '/(member)/(protected)/my/settings/account/billing/wallet'
    | '/(member)/(protected)/my/settings/account/invoices/$invoiceId'
    | '/(member)/(protected)/my/settings/account/billing/'
    | '/(member)/(protected)/my/settings/account/invoices/'
    | '/(member)/(protected)/my/settings/account/billing/payments/$paymentMethodId'
    | '/(member)/(protected)/my/settings/account/billing/payments/history'
    | '/(member)/(protected)/my/settings/account/billing/wallet/history'
    | '/(member)/(protected)/my/settings/account/billing/payments/'
    | '/(member)/(protected)/my/settings/account/billing/wallet/'
    | '/(member)/(protected)/my/settings/account/billing/payments/history_/$transactionId'
    | '/(member)/(protected)/my/settings/account/billing/wallet/history_/$walletItemId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  errorRouteRoute: typeof errorRouteRouteWithChildren
  meetRouteRoute: typeof meetRouteRouteWithChildren
  memberRouteRoute: typeof memberRouteRouteWithChildren
  payRouteRoute: typeof payRouteRouteWithChildren
  AdminRouteRoute: typeof AdminRouteRouteWithChildren
  BirdieRouteRoute: typeof BirdieRouteRouteWithChildren
  DocumentRouteRoute: typeof DocumentRouteRouteWithChildren
  OfficeRouteRoute: typeof OfficeRouteRouteWithChildren
  authActivateRoute: typeof authActivateRoute
  authAutoSignInRoute: typeof authAutoSignInRoute
  authForgotPasswordRoute: typeof authForgotPasswordRoute
  authForgotPasswordOtpRoute: typeof authForgotPasswordOtpRoute
  authResetPasswordRoute: typeof authResetPasswordRoute
  authResetPasswordInvalidRoute: typeof authResetPasswordInvalidRoute
  authResetPasswordSuccessRoute: typeof authResetPasswordSuccessRoute
  authSignInRoute: typeof authSignInRoute
  authSignInImRoute: typeof authSignInImRoute
  authSignInOtpRoute: typeof authSignInOtpRoute
  authSignInPasswordRoute: typeof authSignInPasswordRoute
  devMediaV3UploadRoute: typeof devMediaV3UploadRoute
  CustomAppMigateToQuoteRoute: typeof CustomAppMigateToQuoteRoute
  CustomAppMigrateToQuoteRoute: typeof CustomAppMigrateToQuoteRoute
  HomecareProposalProposalIdRoute: typeof HomecareProposalProposalIdRoute
  VLinkCodeRoute: typeof VLinkCodeRoute
  VendorsOnboardingV1RouteRoute: typeof VendorsOnboardingV1RouteRouteWithChildren
  devThemesIndexRoute: typeof devThemesIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(error)': {
      id: '/(error)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof errorRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(meet)': {
      id: '/(meet)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof meetRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(member)': {
      id: '/(member)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof memberRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(pay)': {
      id: '/(pay)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof payRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/birdie': {
      id: '/birdie'
      path: '/birdie'
      fullPath: '/birdie'
      preLoaderRoute: typeof BirdieRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/document': {
      id: '/document'
      path: '/document'
      fullPath: '/document'
      preLoaderRoute: typeof DocumentRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/office': {
      id: '/office'
      path: '/office'
      fullPath: '/office'
      preLoaderRoute: typeof OfficeRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/activate': {
      id: '/(auth)/activate'
      path: '/activate'
      fullPath: '/activate'
      preLoaderRoute: typeof authActivateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/auto-sign-in': {
      id: '/(auth)/auto-sign-in'
      path: '/auto-sign-in'
      fullPath: '/auto-sign-in'
      preLoaderRoute: typeof authAutoSignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/forgot-password': {
      id: '/(auth)/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof authForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/forgot-password-otp': {
      id: '/(auth)/forgot-password-otp'
      path: '/forgot-password-otp'
      fullPath: '/forgot-password-otp'
      preLoaderRoute: typeof authForgotPasswordOtpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/reset-password': {
      id: '/(auth)/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof authResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/reset-password-invalid': {
      id: '/(auth)/reset-password-invalid'
      path: '/reset-password-invalid'
      fullPath: '/reset-password-invalid'
      preLoaderRoute: typeof authResetPasswordInvalidRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/reset-password-success': {
      id: '/(auth)/reset-password-success'
      path: '/reset-password-success'
      fullPath: '/reset-password-success'
      preLoaderRoute: typeof authResetPasswordSuccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/sign-in': {
      id: '/(auth)/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof authSignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/sign-in-im': {
      id: '/(auth)/sign-in-im'
      path: '/sign-in-im'
      fullPath: '/sign-in-im'
      preLoaderRoute: typeof authSignInImRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/sign-in-otp': {
      id: '/(auth)/sign-in-otp'
      path: '/sign-in-otp'
      fullPath: '/sign-in-otp'
      preLoaderRoute: typeof authSignInOtpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/sign-in-password': {
      id: '/(auth)/sign-in-password'
      path: '/sign-in-password'
      fullPath: '/sign-in-password'
      preLoaderRoute: typeof authSignInPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(dev)/media-v3-upload': {
      id: '/(dev)/media-v3-upload'
      path: '/media-v3-upload'
      fullPath: '/media-v3-upload'
      preLoaderRoute: typeof devMediaV3UploadRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(error)/page-forbidden': {
      id: '/(error)/page-forbidden'
      path: '/page-forbidden'
      fullPath: '/page-forbidden'
      preLoaderRoute: typeof errorPageForbiddenRouteImport
      parentRoute: typeof errorRouteRoute
    }
    '/(error)/page-not-found': {
      id: '/(error)/page-not-found'
      path: '/page-not-found'
      fullPath: '/page-not-found'
      preLoaderRoute: typeof errorPageNotFoundRouteImport
      parentRoute: typeof errorRouteRoute
    }
    '/(member)/(protected)': {
      id: '/(member)/(protected)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof memberprotectedRouteRouteImport
      parentRoute: typeof memberRouteRoute
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/global-birdie-chat': {
      id: '/admin/global-birdie-chat'
      path: '/global-birdie-chat'
      fullPath: '/admin/global-birdie-chat'
      preLoaderRoute: typeof AdminGlobalBirdieChatRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/locations': {
      id: '/admin/locations'
      path: '/locations'
      fullPath: '/admin/locations'
      preLoaderRoute: typeof AdminLocationsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/service-areas': {
      id: '/admin/service-areas'
      path: '/service-areas'
      fullPath: '/admin/service-areas'
      preLoaderRoute: typeof AdminServiceAreasRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/birdie/': {
      id: '/birdie/'
      path: '/'
      fullPath: '/birdie/'
      preLoaderRoute: typeof BirdieIndexRouteImport
      parentRoute: typeof BirdieRouteRoute
    }
    '/custom-app/migate-to-quote': {
      id: '/custom-app/migate-to-quote'
      path: '/custom-app/migate-to-quote'
      fullPath: '/custom-app/migate-to-quote'
      preLoaderRoute: typeof CustomAppMigateToQuoteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/custom-app/migrate-to-quote': {
      id: '/custom-app/migrate-to-quote'
      path: '/custom-app/migrate-to-quote'
      fullPath: '/custom-app/migrate-to-quote'
      preLoaderRoute: typeof CustomAppMigrateToQuoteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/document/': {
      id: '/document/'
      path: '/'
      fullPath: '/document/'
      preLoaderRoute: typeof DocumentIndexRouteImport
      parentRoute: typeof DocumentRouteRoute
    }
    '/document/$slug': {
      id: '/document/$slug'
      path: '/$slug'
      fullPath: '/document/$slug'
      preLoaderRoute: typeof DocumentSlugRouteImport
      parentRoute: typeof DocumentRouteRoute
    }
    '/homecare-proposal/$proposalId': {
      id: '/homecare-proposal/$proposalId'
      path: '/homecare-proposal/$proposalId'
      fullPath: '/homecare-proposal/$proposalId'
      preLoaderRoute: typeof HomecareProposalProposalIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/office/': {
      id: '/office/'
      path: '/'
      fullPath: '/office/'
      preLoaderRoute: typeof OfficeIndexRouteImport
      parentRoute: typeof OfficeRouteRoute
    }
    '/office/connect-gg-calendar': {
      id: '/office/connect-gg-calendar'
      path: '/connect-gg-calendar'
      fullPath: '/office/connect-gg-calendar'
      preLoaderRoute: typeof OfficeConnectGgCalendarRouteImport
      parentRoute: typeof OfficeRouteRoute
    }
    '/office/global-birdie-chat': {
      id: '/office/global-birdie-chat'
      path: '/global-birdie-chat'
      fullPath: '/office/global-birdie-chat'
      preLoaderRoute: typeof OfficeGlobalBirdieChatRouteImport
      parentRoute: typeof OfficeRouteRoute
    }
    '/office/global-search': {
      id: '/office/global-search'
      path: '/global-search'
      fullPath: '/office/global-search'
      preLoaderRoute: typeof OfficeGlobalSearchRouteImport
      parentRoute: typeof OfficeRouteRoute
    }
    '/office/inbox': {
      id: '/office/inbox'
      path: '/inbox'
      fullPath: '/office/inbox'
      preLoaderRoute: typeof OfficeInboxRouteImport
      parentRoute: typeof OfficeRouteRoute
    }
    '/office/manage-account': {
      id: '/office/manage-account'
      path: '/manage-account'
      fullPath: '/office/manage-account'
      preLoaderRoute: typeof OfficeManageAccountRouteImport
      parentRoute: typeof OfficeRouteRoute
    }
    '/office/quotes': {
      id: '/office/quotes'
      path: '/quotes'
      fullPath: '/office/quotes'
      preLoaderRoute: typeof OfficeQuotesRouteImport
      parentRoute: typeof OfficeRouteRoute
    }
    '/office/search': {
      id: '/office/search'
      path: '/search'
      fullPath: '/office/search'
      preLoaderRoute: typeof OfficeSearchRouteImport
      parentRoute: typeof OfficeRouteRoute
    }
    '/v/$linkCode': {
      id: '/v/$linkCode'
      path: '/v/$linkCode'
      fullPath: '/v/$linkCode'
      preLoaderRoute: typeof VLinkCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(dev)/themes/': {
      id: '/(dev)/themes/'
      path: '/themes'
      fullPath: '/themes/'
      preLoaderRoute: typeof devThemesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(meet)/meet/$roomName': {
      id: '/(meet)/meet/$roomName'
      path: '/meet/$roomName'
      fullPath: '/meet/$roomName'
      preLoaderRoute: typeof meetMeetRoomNameRouteImport
      parentRoute: typeof meetRouteRoute
    }
    '/(member)/(protected)/my': {
      id: '/(member)/(protected)/my'
      path: '/my'
      fullPath: '/my'
      preLoaderRoute: typeof memberprotectedMyRouteImport
      parentRoute: typeof memberprotectedRouteRoute
    }
    '/(member)/(public)/join': {
      id: '/(member)/(public)/join'
      path: '/join'
      fullPath: '/join'
      preLoaderRoute: typeof memberpublicJoinRouteImport
      parentRoute: typeof memberRouteRoute
    }
    '/(pay)/pay/$token': {
      id: '/(pay)/pay/$token'
      path: '/pay/$token'
      fullPath: '/pay/$token'
      preLoaderRoute: typeof payPayTokenRouteImport
      parentRoute: typeof payRouteRoute
    }
    '/admin/accounts/': {
      id: '/admin/accounts/'
      path: '/accounts'
      fullPath: '/admin/accounts/'
      preLoaderRoute: typeof AdminAccountsIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/authorization/': {
      id: '/admin/authorization/'
      path: '/authorization'
      fullPath: '/admin/authorization/'
      preLoaderRoute: typeof AdminAuthorizationIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/authorization/$roleKey': {
      id: '/admin/authorization/$roleKey'
      path: '/authorization/$roleKey'
      fullPath: '/admin/authorization/$roleKey'
      preLoaderRoute: typeof AdminAuthorizationRoleKeyRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/authorization/create': {
      id: '/admin/authorization/create'
      path: '/authorization/create'
      fullPath: '/admin/authorization/create'
      preLoaderRoute: typeof AdminAuthorizationCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/campaigns/': {
      id: '/admin/campaigns/'
      path: '/campaigns'
      fullPath: '/admin/campaigns/'
      preLoaderRoute: typeof AdminCampaignsIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/campaigns/$campaignId': {
      id: '/admin/campaigns/$campaignId'
      path: '/campaigns/$campaignId'
      fullPath: '/admin/campaigns/$campaignId'
      preLoaderRoute: typeof AdminCampaignsCampaignIdRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/campaigns/create': {
      id: '/admin/campaigns/create'
      path: '/campaigns/create'
      fullPath: '/admin/campaigns/create'
      preLoaderRoute: typeof AdminCampaignsCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/checkout-links/': {
      id: '/admin/checkout-links/'
      path: '/checkout-links'
      fullPath: '/admin/checkout-links/'
      preLoaderRoute: typeof AdminCheckoutLinksIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/checkout-links/create': {
      id: '/admin/checkout-links/create'
      path: '/checkout-links/create'
      fullPath: '/admin/checkout-links/create'
      preLoaderRoute: typeof AdminCheckoutLinksCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/customers/': {
      id: '/admin/customers/'
      path: '/customers'
      fullPath: '/admin/customers/'
      preLoaderRoute: typeof AdminCustomersIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/customers/$customerId': {
      id: '/admin/customers/$customerId'
      path: '/customers/$customerId'
      fullPath: '/admin/customers/$customerId'
      preLoaderRoute: typeof AdminCustomersCustomerIdRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/customers/create': {
      id: '/admin/customers/create'
      path: '/customers/create'
      fullPath: '/admin/customers/create'
      preLoaderRoute: typeof AdminCustomersCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/homecare-plan-proposals/': {
      id: '/admin/homecare-plan-proposals/'
      path: '/homecare-plan-proposals'
      fullPath: '/admin/homecare-plan-proposals/'
      preLoaderRoute: typeof AdminHomecarePlanProposalsIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/locations/create': {
      id: '/admin/locations/create'
      path: '/create'
      fullPath: '/admin/locations/create'
      preLoaderRoute: typeof AdminLocationsCreateRouteImport
      parentRoute: typeof AdminLocationsRoute
    }
    '/admin/purchase-intents/': {
      id: '/admin/purchase-intents/'
      path: '/purchase-intents'
      fullPath: '/admin/purchase-intents/'
      preLoaderRoute: typeof AdminPurchaseIntentsIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/subscriptions/': {
      id: '/admin/subscriptions/'
      path: '/subscriptions'
      fullPath: '/admin/subscriptions/'
      preLoaderRoute: typeof AdminSubscriptionsIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/subscriptions/create': {
      id: '/admin/subscriptions/create'
      path: '/subscriptions/create'
      fullPath: '/admin/subscriptions/create'
      preLoaderRoute: typeof AdminSubscriptionsCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/tags/': {
      id: '/admin/tags/'
      path: '/tags'
      fullPath: '/admin/tags/'
      preLoaderRoute: typeof AdminTagsIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/users/': {
      id: '/admin/users/'
      path: '/users'
      fullPath: '/admin/users/'
      preLoaderRoute: typeof AdminUsersIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/users/create': {
      id: '/admin/users/create'
      path: '/users/create'
      fullPath: '/admin/users/create'
      preLoaderRoute: typeof AdminUsersCreateRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/users/managers': {
      id: '/admin/users/managers'
      path: '/users/managers'
      fullPath: '/admin/users/managers'
      preLoaderRoute: typeof AdminUsersManagersRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/users/members': {
      id: '/admin/users/members'
      path: '/users/members'
      fullPath: '/admin/users/members'
      preLoaderRoute: typeof AdminUsersMembersRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/users/technicians': {
      id: '/admin/users/technicians'
      path: '/users/technicians'
      fullPath: '/admin/users/technicians'
      preLoaderRoute: typeof AdminUsersTechniciansRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/visits/': {
      id: '/admin/visits/'
      path: '/visits'
      fullPath: '/admin/visits/'
      preLoaderRoute: typeof AdminVisitsIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/visits/available-time-slots': {
      id: '/admin/visits/available-time-slots'
      path: '/visits/available-time-slots'
      fullPath: '/admin/visits/available-time-slots'
      preLoaderRoute: typeof AdminVisitsAvailableTimeSlotsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/birdie/sessions/': {
      id: '/birdie/sessions/'
      path: '/sessions'
      fullPath: '/birdie/sessions/'
      preLoaderRoute: typeof BirdieSessionsIndexRouteImport
      parentRoute: typeof BirdieRouteRoute
    }
    '/birdie/sessions/$sessionId': {
      id: '/birdie/sessions/$sessionId'
      path: '/sessions/$sessionId'
      fullPath: '/birdie/sessions/$sessionId'
      preLoaderRoute: typeof BirdieSessionsSessionIdRouteImport
      parentRoute: typeof BirdieRouteRoute
    }
    '/office/billing/todo': {
      id: '/office/billing/todo'
      path: '/billing/todo'
      fullPath: '/office/billing/todo'
      preLoaderRoute: typeof OfficeBillingTodoRouteImport
      parentRoute: typeof OfficeRouteRoute
    }
    '/office/catalog-new/': {
      id: '/office/catalog-new/'
      path: '/catalog-new'
      fullPath: '/office/catalog-new/'
      preLoaderRoute: typeof OfficeCatalogNewIndexRouteImport
      parentRoute: typeof OfficeRouteRoute
    }
    '/office/catalog-new/$catalogItemId': {
      id: '/office/catalog-new/$catalogItemId'
      path: '/catalog-new/$catalogItemId'
      fullPath: '/office/catalog-new/$catalogItemId'
      preLoaderRoute: typeof OfficeCatalogNewCatalogItemIdRouteImport
      parentRoute: typeof OfficeRouteRoute
    }
    '/office/notifications/': {
      id: '/office/notifications/'
      path: '/notifications'
      fullPath: '/office/notifications/'
      preLoaderRoute: typeof OfficeNotificationsIndexRouteImport
      parentRoute: typeof OfficeRouteRoute
    }
    '/office/orders/': {
      id: '/office/orders/'
      path: '/orders'
      fullPath: '/office/orders/'
      preLoaderRoute: typeof OfficeOrdersIndexRouteImport
      parentRoute: typeof OfficeRouteRoute
    }
    '/office/orders/$orderId': {
      id: '/office/orders/$orderId'
      path: '/orders/$orderId'
      fullPath: '/office/orders/$orderId'
      preLoaderRoute: typeof OfficeOrdersOrderIdRouteImport
      parentRoute: typeof OfficeRouteRoute
    }
    '/office/orders/active': {
      id: '/office/orders/active'
      path: '/orders/active'
      fullPath: '/office/orders/active'
      preLoaderRoute: typeof OfficeOrdersActiveRouteImport
      parentRoute: typeof OfficeRouteRoute
    }
    '/office/orders/all': {
      id: '/office/orders/all'
      path: '/orders/all'
      fullPath: '/office/orders/all'
      preLoaderRoute: typeof OfficeOrdersAllRouteImport
      parentRoute: typeof OfficeRouteRoute
    }
    '/office/orders/create': {
      id: '/office/orders/create'
      path: '/orders/create'
      fullPath: '/office/orders/create'
      preLoaderRoute: typeof OfficeOrdersCreateRouteImport
      parentRoute: typeof OfficeRouteRoute
    }
    '/office/orders/future': {
      id: '/office/orders/future'
      path: '/orders/future'
      fullPath: '/office/orders/future'
      preLoaderRoute: typeof OfficeOrdersFutureRouteImport
      parentRoute: typeof OfficeRouteRoute
    }
    '/office/orders/workflow': {
      id: '/office/orders/workflow'
      path: '/orders/workflow'
      fullPath: '/office/orders/workflow'
      preLoaderRoute: typeof OfficeOrdersWorkflowRouteImport
      parentRoute: typeof OfficeRouteRoute
    }
    '/office/places/': {
      id: '/office/places/'
      path: '/places'
      fullPath: '/office/places/'
      preLoaderRoute: typeof OfficePlacesIndexRouteImport
      parentRoute: typeof OfficeRouteRoute
    }
    '/office/places/$placeId': {
      id: '/office/places/$placeId'
      path: '/places/$placeId'
      fullPath: '/office/places/$placeId'
      preLoaderRoute: typeof OfficePlacesPlaceIdRouteImport
      parentRoute: typeof OfficeRouteRoute
    }
    '/office/places/active': {
      id: '/office/places/active'
      path: '/places/active'
      fullPath: '/office/places/active'
      preLoaderRoute: typeof OfficePlacesActiveRouteImport
      parentRoute: typeof OfficeRouteRoute
    }
    '/office/places/all': {
      id: '/office/places/all'
      path: '/places/all'
      fullPath: '/office/places/all'
      preLoaderRoute: typeof OfficePlacesAllRouteImport
      parentRoute: typeof OfficeRouteRoute
    }
    '/office/places/create': {
      id: '/office/places/create'
      path: '/places/create'
      fullPath: '/office/places/create'
      preLoaderRoute: typeof OfficePlacesCreateRouteImport
      parentRoute: typeof OfficeRouteRoute
    }
    '/office/reports/': {
      id: '/office/reports/'
      path: '/reports'
      fullPath: '/office/reports/'
      preLoaderRoute: typeof OfficeReportsIndexRouteImport
      parentRoute: typeof OfficeRouteRoute
    }
    '/office/reports/ai-feedback': {
      id: '/office/reports/ai-feedback'
      path: '/reports/ai-feedback'
      fullPath: '/office/reports/ai-feedback'
      preLoaderRoute: typeof OfficeReportsAiFeedbackRouteImport
      parentRoute: typeof OfficeRouteRoute
    }
    '/office/reports/confirmed-churn': {
      id: '/office/reports/confirmed-churn'
      path: '/reports/confirmed-churn'
      fullPath: '/office/reports/confirmed-churn'
      preLoaderRoute: typeof OfficeReportsConfirmedChurnRouteImport
      parentRoute: typeof OfficeRouteRoute
    }
    '/office/reports/homecare-renewals': {
      id: '/office/reports/homecare-renewals'
      path: '/reports/homecare-renewals'
      fullPath: '/office/reports/homecare-renewals'
      preLoaderRoute: typeof OfficeReportsHomecareRenewalsRouteImport
      parentRoute: typeof OfficeRouteRoute
    }
    '/office/reports/member-activation': {
      id: '/office/reports/member-activation'
      path: '/reports/member-activation'
      fullPath: '/office/reports/member-activation'
      preLoaderRoute: typeof OfficeReportsMemberActivationRouteImport
      parentRoute: typeof OfficeRouteRoute
    }
    '/office/reports/one-off-revenue': {
      id: '/office/reports/one-off-revenue'
      path: '/reports/one-off-revenue'
      fullPath: '/office/reports/one-off-revenue'
      preLoaderRoute: typeof OfficeReportsOneOffRevenueRouteImport
      parentRoute: typeof OfficeRouteRoute
    }
    '/office/reports/order-overview': {
      id: '/office/reports/order-overview'
      path: '/reports/order-overview'
      fullPath: '/office/reports/order-overview'
      preLoaderRoute: typeof OfficeReportsOrderOverviewRouteImport
      parentRoute: typeof OfficeRouteRoute
    }
    '/office/reports/revenue': {
      id: '/office/reports/revenue'
      path: '/reports/revenue'
      fullPath: '/office/reports/revenue'
      preLoaderRoute: typeof OfficeReportsRevenueRouteImport
      parentRoute: typeof OfficeRouteRoute
    }
    '/office/reports/vendor-scorecard': {
      id: '/office/reports/vendor-scorecard'
      path: '/reports/vendor-scorecard'
      fullPath: '/office/reports/vendor-scorecard'
      preLoaderRoute: typeof OfficeReportsVendorScorecardRouteImport
      parentRoute: typeof OfficeRouteRoute
    }
    '/office/schedule/': {
      id: '/office/schedule/'
      path: '/schedule'
      fullPath: '/office/schedule/'
      preLoaderRoute: typeof OfficeScheduleIndexRouteImport
      parentRoute: typeof OfficeRouteRoute
    }
    '/office/smart-actions/': {
      id: '/office/smart-actions/'
      path: '/smart-actions'
      fullPath: '/office/smart-actions/'
      preLoaderRoute: typeof OfficeSmartActionsIndexRouteImport
      parentRoute: typeof OfficeRouteRoute
    }
    '/office/smart-actions/accuracy': {
      id: '/office/smart-actions/accuracy'
      path: '/smart-actions/accuracy'
      fullPath: '/office/smart-actions/accuracy'
      preLoaderRoute: typeof OfficeSmartActionsAccuracyRouteImport
      parentRoute: typeof OfficeRouteRoute
    }
    '/office/smart-actions/board': {
      id: '/office/smart-actions/board'
      path: '/smart-actions/board'
      fullPath: '/office/smart-actions/board'
      preLoaderRoute: typeof OfficeSmartActionsBoardRouteImport
      parentRoute: typeof OfficeRouteRoute
    }
    '/office/smart-actions/forecast': {
      id: '/office/smart-actions/forecast'
      path: '/smart-actions/forecast'
      fullPath: '/office/smart-actions/forecast'
      preLoaderRoute: typeof OfficeSmartActionsForecastRouteImport
      parentRoute: typeof OfficeRouteRoute
    }
    '/office/smart-actions/lost-costs': {
      id: '/office/smart-actions/lost-costs'
      path: '/smart-actions/lost-costs'
      fullPath: '/office/smart-actions/lost-costs'
      preLoaderRoute: typeof OfficeSmartActionsLostCostsRouteImport
      parentRoute: typeof OfficeRouteRoute
    }
    '/office/tasks/': {
      id: '/office/tasks/'
      path: '/tasks'
      fullPath: '/office/tasks/'
      preLoaderRoute: typeof OfficeTasksIndexRouteImport
      parentRoute: typeof OfficeRouteRoute
    }
    '/office/tasks/create': {
      id: '/office/tasks/create'
      path: '/tasks/create'
      fullPath: '/office/tasks/create'
      preLoaderRoute: typeof OfficeTasksCreateRouteImport
      parentRoute: typeof OfficeRouteRoute
    }
    '/office/vendors/': {
      id: '/office/vendors/'
      path: '/vendors'
      fullPath: '/office/vendors/'
      preLoaderRoute: typeof OfficeVendorsIndexRouteImport
      parentRoute: typeof OfficeRouteRoute
    }
    '/office/vendors/create': {
      id: '/office/vendors/create'
      path: '/vendors/create'
      fullPath: '/office/vendors/create'
      preLoaderRoute: typeof OfficeVendorsCreateRouteImport
      parentRoute: typeof OfficeRouteRoute
    }
    '/office/vendors/visits': {
      id: '/office/vendors/visits'
      path: '/vendors/visits'
      fullPath: '/office/vendors/visits'
      preLoaderRoute: typeof OfficeVendorsVisitsRouteImport
      parentRoute: typeof OfficeRouteRoute
    }
    '/vendors/onboarding/v1': {
      id: '/vendors/onboarding/v1'
      path: '/vendors/onboarding/v1'
      fullPath: '/vendors/onboarding/v1'
      preLoaderRoute: typeof VendorsOnboardingV1RouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(meet)/meet/join/$roomName': {
      id: '/(meet)/meet/join/$roomName'
      path: '/meet/join/$roomName'
      fullPath: '/meet/join/$roomName'
      preLoaderRoute: typeof meetMeetJoinRoomNameRouteImport
      parentRoute: typeof meetRouteRoute
    }
    '/(member)/(protected)/my/': {
      id: '/(member)/(protected)/my/'
      path: '/'
      fullPath: '/my/'
      preLoaderRoute: typeof memberprotectedMyIndexRouteImport
      parentRoute: typeof memberprotectedMyRoute
    }
    '/(member)/(protected)/my/birdie': {
      id: '/(member)/(protected)/my/birdie'
      path: '/birdie'
      fullPath: '/my/birdie'
      preLoaderRoute: typeof memberprotectedMyBirdieRouteImport
      parentRoute: typeof memberprotectedMyRoute
    }
    '/(member)/(protected)/my/cart': {
      id: '/(member)/(protected)/my/cart'
      path: '/cart'
      fullPath: '/my/cart'
      preLoaderRoute: typeof memberprotectedMyCartRouteImport
      parentRoute: typeof memberprotectedMyRoute
    }
    '/(member)/(protected)/my/chats': {
      id: '/(member)/(protected)/my/chats'
      path: '/chats'
      fullPath: '/my/chats'
      preLoaderRoute: typeof memberprotectedMyChatsRouteImport
      parentRoute: typeof memberprotectedMyRoute
    }
    '/(member)/(protected)/my/download': {
      id: '/(member)/(protected)/my/download'
      path: '/download'
      fullPath: '/my/download'
      preLoaderRoute: typeof memberprotectedMyDownloadRouteImport
      parentRoute: typeof memberprotectedMyRoute
    }
    '/(member)/(protected)/my/download-app': {
      id: '/(member)/(protected)/my/download-app'
      path: '/download-app'
      fullPath: '/my/download-app'
      preLoaderRoute: typeof memberprotectedMyDownloadAppRouteImport
      parentRoute: typeof memberprotectedMyRoute
    }
    '/(member)/(protected)/my/feedback': {
      id: '/(member)/(protected)/my/feedback'
      path: '/feedback'
      fullPath: '/my/feedback'
      preLoaderRoute: typeof memberprotectedMyFeedbackRouteImport
      parentRoute: typeof memberprotectedMyRoute
    }
    '/(member)/(protected)/my/global-search': {
      id: '/(member)/(protected)/my/global-search'
      path: '/global-search'
      fullPath: '/my/global-search'
      preLoaderRoute: typeof memberprotectedMyGlobalSearchRouteImport
      parentRoute: typeof memberprotectedMyRoute
    }
    '/(member)/(protected)/my/help': {
      id: '/(member)/(protected)/my/help'
      path: '/help'
      fullPath: '/my/help'
      preLoaderRoute: typeof memberprotectedMyHelpRouteImport
      parentRoute: typeof memberprotectedMyRoute
    }
    '/(member)/(protected)/my/home': {
      id: '/(member)/(protected)/my/home'
      path: '/home'
      fullPath: '/my/home'
      preLoaderRoute: typeof memberprotectedMyHomeRouteImport
      parentRoute: typeof memberprotectedMyRoute
    }
    '/(member)/(protected)/my/onboarding': {
      id: '/(member)/(protected)/my/onboarding'
      path: '/onboarding'
      fullPath: '/my/onboarding'
      preLoaderRoute: typeof memberprotectedMyOnboardingRouteImport
      parentRoute: typeof memberprotectedMyRoute
    }
    '/(member)/(protected)/my/records': {
      id: '/(member)/(protected)/my/records'
      path: '/records'
      fullPath: '/my/records'
      preLoaderRoute: typeof memberprotectedMyRecordsRouteImport
      parentRoute: typeof memberprotectedMyRoute
    }
    '/(member)/(protected)/my/settings': {
      id: '/(member)/(protected)/my/settings'
      path: '/settings'
      fullPath: '/my/settings'
      preLoaderRoute: typeof memberprotectedMySettingsRouteImport
      parentRoute: typeof memberprotectedMyRoute
    }
    '/(member)/(protected)/my/verify-phone': {
      id: '/(member)/(protected)/my/verify-phone'
      path: '/verify-phone'
      fullPath: '/my/verify-phone'
      preLoaderRoute: typeof memberprotectedMyVerifyPhoneRouteImport
      parentRoute: typeof memberprotectedMyRoute
    }
    '/(member)/(public)/invite/$token': {
      id: '/(member)/(public)/invite/$token'
      path: '/invite/$token'
      fullPath: '/invite/$token'
      preLoaderRoute: typeof memberpublicInviteTokenRouteImport
      parentRoute: typeof memberRouteRoute
    }
    '/(member)/(public)/join/': {
      id: '/(member)/(public)/join/'
      path: '/'
      fullPath: '/join/'
      preLoaderRoute: typeof memberpublicJoinIndexRouteImport
      parentRoute: typeof memberpublicJoinRoute
    }
    '/(member)/(public)/join/sign-up': {
      id: '/(member)/(public)/join/sign-up'
      path: '/sign-up'
      fullPath: '/join/sign-up'
      preLoaderRoute: typeof memberpublicJoinSignUpRouteImport
      parentRoute: typeof memberpublicJoinRoute
    }
    '/(member)/(public)/join/verify': {
      id: '/(member)/(public)/join/verify'
      path: '/verify'
      fullPath: '/join/verify'
      preLoaderRoute: typeof memberpublicJoinVerifyRouteImport
      parentRoute: typeof memberpublicJoinRoute
    }
    '/(member)/(public)/presale/$': {
      id: '/(member)/(public)/presale/$'
      path: '/presale/$'
      fullPath: '/presale/$'
      preLoaderRoute: typeof memberpublicPresaleSplatRouteImport
      parentRoute: typeof memberRouteRoute
    }
    '/admin/users/managers/create': {
      id: '/admin/users/managers/create'
      path: '/create'
      fullPath: '/admin/users/managers/create'
      preLoaderRoute: typeof AdminUsersManagersCreateRouteImport
      parentRoute: typeof AdminUsersManagersRoute
    }
    '/admin/users/members/create': {
      id: '/admin/users/members/create'
      path: '/create'
      fullPath: '/admin/users/members/create'
      preLoaderRoute: typeof AdminUsersMembersCreateRouteImport
      parentRoute: typeof AdminUsersMembersRoute
    }
    '/admin/users/technicians/create': {
      id: '/admin/users/technicians/create'
      path: '/create'
      fullPath: '/admin/users/technicians/create'
      preLoaderRoute: typeof AdminUsersTechniciansCreateRouteImport
      parentRoute: typeof AdminUsersTechniciansRoute
    }
    '/office/billing/invoices/': {
      id: '/office/billing/invoices/'
      path: '/billing/invoices'
      fullPath: '/office/billing/invoices/'
      preLoaderRoute: typeof OfficeBillingInvoicesIndexRouteImport
      parentRoute: typeof OfficeRouteRoute
    }
    '/office/places/onboarding/': {
      id: '/office/places/onboarding/'
      path: '/places/onboarding'
      fullPath: '/office/places/onboarding/'
      preLoaderRoute: typeof OfficePlacesOnboardingIndexRouteImport
      parentRoute: typeof OfficeRouteRoute
    }
    '/vendors/onboarding/v1/step-0-welcome': {
      id: '/vendors/onboarding/v1/step-0-welcome'
      path: '/step-0-welcome'
      fullPath: '/vendors/onboarding/v1/step-0-welcome'
      preLoaderRoute: typeof VendorsOnboardingV1Step0WelcomeRouteImport
      parentRoute: typeof VendorsOnboardingV1RouteRoute
    }
    '/vendors/onboarding/v1/step-1-business-info': {
      id: '/vendors/onboarding/v1/step-1-business-info'
      path: '/step-1-business-info'
      fullPath: '/vendors/onboarding/v1/step-1-business-info'
      preLoaderRoute: typeof VendorsOnboardingV1Step1BusinessInfoRouteImport
      parentRoute: typeof VendorsOnboardingV1RouteRoute
    }
    '/vendors/onboarding/v1/step-2-legal-compliance': {
      id: '/vendors/onboarding/v1/step-2-legal-compliance'
      path: '/step-2-legal-compliance'
      fullPath: '/vendors/onboarding/v1/step-2-legal-compliance'
      preLoaderRoute: typeof VendorsOnboardingV1Step2LegalComplianceRouteImport
      parentRoute: typeof VendorsOnboardingV1RouteRoute
    }
    '/vendors/onboarding/v1/step-3-service-term': {
      id: '/vendors/onboarding/v1/step-3-service-term'
      path: '/step-3-service-term'
      fullPath: '/vendors/onboarding/v1/step-3-service-term'
      preLoaderRoute: typeof VendorsOnboardingV1Step3ServiceTermRouteImport
      parentRoute: typeof VendorsOnboardingV1RouteRoute
    }
    '/vendors/onboarding/v1/step-4-add-technician': {
      id: '/vendors/onboarding/v1/step-4-add-technician'
      path: '/step-4-add-technician'
      fullPath: '/vendors/onboarding/v1/step-4-add-technician'
      preLoaderRoute: typeof VendorsOnboardingV1Step4AddTechnicianRouteImport
      parentRoute: typeof VendorsOnboardingV1RouteRoute
    }
    '/vendors/onboarding/v1/step-5-review-information': {
      id: '/vendors/onboarding/v1/step-5-review-information'
      path: '/step-5-review-information'
      fullPath: '/vendors/onboarding/v1/step-5-review-information'
      preLoaderRoute: typeof VendorsOnboardingV1Step5ReviewInformationRouteImport
      parentRoute: typeof VendorsOnboardingV1RouteRoute
    }
    '/vendors/onboarding/v1/step-final-submit': {
      id: '/vendors/onboarding/v1/step-final-submit'
      path: '/step-final-submit'
      fullPath: '/vendors/onboarding/v1/step-final-submit'
      preLoaderRoute: typeof VendorsOnboardingV1StepFinalSubmitRouteImport
      parentRoute: typeof VendorsOnboardingV1RouteRoute
    }
    '/(member)/(protected)/my/campaigns/$campaignSlug': {
      id: '/(member)/(protected)/my/campaigns/$campaignSlug'
      path: '/campaigns/$campaignSlug'
      fullPath: '/my/campaigns/$campaignSlug'
      preLoaderRoute: typeof memberprotectedMyCampaignsCampaignSlugRouteImport
      parentRoute: typeof memberprotectedMyRoute
    }
    '/(member)/(protected)/my/checkout/': {
      id: '/(member)/(protected)/my/checkout/'
      path: '/checkout'
      fullPath: '/my/checkout/'
      preLoaderRoute: typeof memberprotectedMyCheckoutIndexRouteImport
      parentRoute: typeof memberprotectedMyRoute
    }
    '/(member)/(protected)/my/checkout/$checkoutId': {
      id: '/(member)/(protected)/my/checkout/$checkoutId'
      path: '/checkout/$checkoutId'
      fullPath: '/my/checkout/$checkoutId'
      preLoaderRoute: typeof memberprotectedMyCheckoutCheckoutIdRouteImport
      parentRoute: typeof memberprotectedMyRoute
    }
    '/(member)/(protected)/my/checkout/success': {
      id: '/(member)/(protected)/my/checkout/success'
      path: '/checkout/success'
      fullPath: '/my/checkout/success'
      preLoaderRoute: typeof memberprotectedMyCheckoutSuccessRouteImport
      parentRoute: typeof memberprotectedMyRoute
    }
    '/(member)/(protected)/my/feedback/': {
      id: '/(member)/(protected)/my/feedback/'
      path: '/'
      fullPath: '/my/feedback/'
      preLoaderRoute: typeof memberprotectedMyFeedbackIndexRouteImport
      parentRoute: typeof memberprotectedMyFeedbackRoute
    }
    '/(member)/(protected)/my/feedback/$feedbackId': {
      id: '/(member)/(protected)/my/feedback/$feedbackId'
      path: '/$feedbackId'
      fullPath: '/my/feedback/$feedbackId'
      preLoaderRoute: typeof memberprotectedMyFeedbackFeedbackIdRouteImport
      parentRoute: typeof memberprotectedMyFeedbackRoute
    }
    '/(member)/(protected)/my/list/': {
      id: '/(member)/(protected)/my/list/'
      path: '/list'
      fullPath: '/my/list/'
      preLoaderRoute: typeof memberprotectedMyListIndexRouteImport
      parentRoute: typeof memberprotectedMyRoute
    }
    '/(member)/(protected)/my/list/archived': {
      id: '/(member)/(protected)/my/list/archived'
      path: '/list/archived'
      fullPath: '/my/list/archived'
      preLoaderRoute: typeof memberprotectedMyListArchivedRouteImport
      parentRoute: typeof memberprotectedMyRoute
    }
    '/(member)/(protected)/my/orders/$orderId': {
      id: '/(member)/(protected)/my/orders/$orderId'
      path: '/orders/$orderId'
      fullPath: '/my/orders/$orderId'
      preLoaderRoute: typeof memberprotectedMyOrdersOrderIdRouteImport
      parentRoute: typeof memberprotectedMyRoute
    }
    '/(member)/(protected)/my/orders/create': {
      id: '/(member)/(protected)/my/orders/create'
      path: '/orders/create'
      fullPath: '/my/orders/create'
      preLoaderRoute: typeof memberprotectedMyOrdersCreateRouteImport
      parentRoute: typeof memberprotectedMyRoute
    }
    '/(member)/(protected)/my/places/': {
      id: '/(member)/(protected)/my/places/'
      path: '/places'
      fullPath: '/my/places/'
      preLoaderRoute: typeof memberprotectedMyPlacesIndexRouteImport
      parentRoute: typeof memberprotectedMyRoute
    }
    '/(member)/(protected)/my/places/add': {
      id: '/(member)/(protected)/my/places/add'
      path: '/places/add'
      fullPath: '/my/places/add'
      preLoaderRoute: typeof memberprotectedMyPlacesAddRouteImport
      parentRoute: typeof memberprotectedMyRoute
    }
    '/(member)/(protected)/my/places/exist': {
      id: '/(member)/(protected)/my/places/exist'
      path: '/places/exist'
      fullPath: '/my/places/exist'
      preLoaderRoute: typeof memberprotectedMyPlacesExistRouteImport
      parentRoute: typeof memberprotectedMyRoute
    }
    '/(member)/(protected)/my/quotes/$quoteId': {
      id: '/(member)/(protected)/my/quotes/$quoteId'
      path: '/quotes/$quoteId'
      fullPath: '/my/quotes/$quoteId'
      preLoaderRoute: typeof memberprotectedMyQuotesQuoteIdRouteImport
      parentRoute: typeof memberprotectedMyRoute
    }
    '/(member)/(protected)/my/requests/submit': {
      id: '/(member)/(protected)/my/requests/submit'
      path: '/requests/submit'
      fullPath: '/my/requests/submit'
      preLoaderRoute: typeof memberprotectedMyRequestsSubmitRouteImport
      parentRoute: typeof memberprotectedMyRoute
    }
    '/(member)/(protected)/my/settings/': {
      id: '/(member)/(protected)/my/settings/'
      path: '/'
      fullPath: '/my/settings/'
      preLoaderRoute: typeof memberprotectedMySettingsIndexRouteImport
      parentRoute: typeof memberprotectedMySettingsRoute
    }
    '/(member)/(public)/invite/$token/': {
      id: '/(member)/(public)/invite/$token/'
      path: '/'
      fullPath: '/invite/$token/'
      preLoaderRoute: typeof memberpublicInviteTokenIndexRouteImport
      parentRoute: typeof memberpublicInviteTokenRoute
    }
    '/(member)/(public)/invite/$token/sign-up': {
      id: '/(member)/(public)/invite/$token/sign-up'
      path: '/sign-up'
      fullPath: '/invite/$token/sign-up'
      preLoaderRoute: typeof memberpublicInviteTokenSignUpRouteImport
      parentRoute: typeof memberpublicInviteTokenRoute
    }
    '/(member)/(public)/invite/$token/success': {
      id: '/(member)/(public)/invite/$token/success'
      path: '/success'
      fullPath: '/invite/$token/success'
      preLoaderRoute: typeof memberpublicInviteTokenSuccessRouteImport
      parentRoute: typeof memberpublicInviteTokenRoute
    }
    '/(member)/(public)/invite/$token/verify': {
      id: '/(member)/(public)/invite/$token/verify'
      path: '/verify'
      fullPath: '/invite/$token/verify'
      preLoaderRoute: typeof memberpublicInviteTokenVerifyRouteImport
      parentRoute: typeof memberpublicInviteTokenRoute
    }
    '/(member)/(public)/public/orders/$orderId': {
      id: '/(member)/(public)/public/orders/$orderId'
      path: '/public/orders/$orderId'
      fullPath: '/public/orders/$orderId'
      preLoaderRoute: typeof memberpublicPublicOrdersOrderIdRouteImport
      parentRoute: typeof memberRouteRoute
    }
    '/office/billing/accounts/$accountId/wallet': {
      id: '/office/billing/accounts/$accountId/wallet'
      path: '/billing/accounts/$accountId/wallet'
      fullPath: '/office/billing/accounts/$accountId/wallet'
      preLoaderRoute: typeof OfficeBillingAccountsAccountIdWalletRouteImport
      parentRoute: typeof OfficeRouteRoute
    }
    '/office/billing/invoices/$invoiceId/edit': {
      id: '/office/billing/invoices/$invoiceId/edit'
      path: '/billing/invoices/$invoiceId/edit'
      fullPath: '/office/billing/invoices/$invoiceId/edit'
      preLoaderRoute: typeof OfficeBillingInvoicesInvoiceIdEditRouteImport
      parentRoute: typeof OfficeRouteRoute
    }
    '/(member)/(protected)/my/settings/account/billing': {
      id: '/(member)/(protected)/my/settings/account/billing'
      path: '/account/billing'
      fullPath: '/my/settings/account/billing'
      preLoaderRoute: typeof memberprotectedMySettingsAccountBillingRouteImport
      parentRoute: typeof memberprotectedMySettingsRoute
    }
    '/(member)/(protected)/my/settings/account/notifications': {
      id: '/(member)/(protected)/my/settings/account/notifications'
      path: '/account/notifications'
      fullPath: '/my/settings/account/notifications'
      preLoaderRoute: typeof memberprotectedMySettingsAccountNotificationsRouteImport
      parentRoute: typeof memberprotectedMySettingsRoute
    }
    '/(member)/(protected)/my/settings/account/profile': {
      id: '/(member)/(protected)/my/settings/account/profile'
      path: '/account/profile'
      fullPath: '/my/settings/account/profile'
      preLoaderRoute: typeof memberprotectedMySettingsAccountProfileRouteImport
      parentRoute: typeof memberprotectedMySettingsRoute
    }
    '/(member)/(protected)/my/settings/account/security': {
      id: '/(member)/(protected)/my/settings/account/security'
      path: '/account/security'
      fullPath: '/my/settings/account/security'
      preLoaderRoute: typeof memberprotectedMySettingsAccountSecurityRouteImport
      parentRoute: typeof memberprotectedMySettingsRoute
    }
    '/(member)/(protected)/my/settings/household/members': {
      id: '/(member)/(protected)/my/settings/household/members'
      path: '/household/members'
      fullPath: '/my/settings/household/members'
      preLoaderRoute: typeof memberprotectedMySettingsHouseholdMembersRouteImport
      parentRoute: typeof memberprotectedMySettingsRoute
    }
    '/(member)/(protected)/my/settings/household/membership': {
      id: '/(member)/(protected)/my/settings/household/membership'
      path: '/household/membership'
      fullPath: '/my/settings/household/membership'
      preLoaderRoute: typeof memberprotectedMySettingsHouseholdMembershipRouteImport
      parentRoute: typeof memberprotectedMySettingsRoute
    }
    '/(member)/(protected)/my/settings/account/billing/': {
      id: '/(member)/(protected)/my/settings/account/billing/'
      path: '/'
      fullPath: '/my/settings/account/billing/'
      preLoaderRoute: typeof memberprotectedMySettingsAccountBillingIndexRouteImport
      parentRoute: typeof memberprotectedMySettingsAccountBillingRoute
    }
    '/(member)/(protected)/my/settings/account/billing/payments': {
      id: '/(member)/(protected)/my/settings/account/billing/payments'
      path: '/payments'
      fullPath: '/my/settings/account/billing/payments'
      preLoaderRoute: typeof memberprotectedMySettingsAccountBillingPaymentsRouteImport
      parentRoute: typeof memberprotectedMySettingsAccountBillingRoute
    }
    '/(member)/(protected)/my/settings/account/billing/wallet': {
      id: '/(member)/(protected)/my/settings/account/billing/wallet'
      path: '/wallet'
      fullPath: '/my/settings/account/billing/wallet'
      preLoaderRoute: typeof memberprotectedMySettingsAccountBillingWalletRouteImport
      parentRoute: typeof memberprotectedMySettingsAccountBillingRoute
    }
    '/(member)/(protected)/my/settings/account/invoices/': {
      id: '/(member)/(protected)/my/settings/account/invoices/'
      path: '/account/invoices'
      fullPath: '/my/settings/account/invoices/'
      preLoaderRoute: typeof memberprotectedMySettingsAccountInvoicesIndexRouteImport
      parentRoute: typeof memberprotectedMySettingsRoute
    }
    '/(member)/(protected)/my/settings/account/invoices/$invoiceId': {
      id: '/(member)/(protected)/my/settings/account/invoices/$invoiceId'
      path: '/account/invoices/$invoiceId'
      fullPath: '/my/settings/account/invoices/$invoiceId'
      preLoaderRoute: typeof memberprotectedMySettingsAccountInvoicesInvoiceIdRouteImport
      parentRoute: typeof memberprotectedMySettingsRoute
    }
    '/(member)/(protected)/my/settings/account/billing/payments/': {
      id: '/(member)/(protected)/my/settings/account/billing/payments/'
      path: '/'
      fullPath: '/my/settings/account/billing/payments/'
      preLoaderRoute: typeof memberprotectedMySettingsAccountBillingPaymentsIndexRouteImport
      parentRoute: typeof memberprotectedMySettingsAccountBillingPaymentsRoute
    }
    '/(member)/(protected)/my/settings/account/billing/payments/$paymentMethodId': {
      id: '/(member)/(protected)/my/settings/account/billing/payments/$paymentMethodId'
      path: '/$paymentMethodId'
      fullPath: '/my/settings/account/billing/payments/$paymentMethodId'
      preLoaderRoute: typeof memberprotectedMySettingsAccountBillingPaymentsPaymentMethodIdRouteImport
      parentRoute: typeof memberprotectedMySettingsAccountBillingPaymentsRoute
    }
    '/(member)/(protected)/my/settings/account/billing/payments/history': {
      id: '/(member)/(protected)/my/settings/account/billing/payments/history'
      path: '/history'
      fullPath: '/my/settings/account/billing/payments/history'
      preLoaderRoute: typeof memberprotectedMySettingsAccountBillingPaymentsHistoryRouteImport
      parentRoute: typeof memberprotectedMySettingsAccountBillingPaymentsRoute
    }
    '/(member)/(protected)/my/settings/account/billing/wallet/': {
      id: '/(member)/(protected)/my/settings/account/billing/wallet/'
      path: '/'
      fullPath: '/my/settings/account/billing/wallet/'
      preLoaderRoute: typeof memberprotectedMySettingsAccountBillingWalletIndexRouteImport
      parentRoute: typeof memberprotectedMySettingsAccountBillingWalletRoute
    }
    '/(member)/(protected)/my/settings/account/billing/wallet/history': {
      id: '/(member)/(protected)/my/settings/account/billing/wallet/history'
      path: '/history'
      fullPath: '/my/settings/account/billing/wallet/history'
      preLoaderRoute: typeof memberprotectedMySettingsAccountBillingWalletHistoryRouteImport
      parentRoute: typeof memberprotectedMySettingsAccountBillingWalletRoute
    }
    '/(member)/(protected)/my/settings/account/billing/payments/history_/$transactionId': {
      id: '/(member)/(protected)/my/settings/account/billing/payments/history_/$transactionId'
      path: '/history/$transactionId'
      fullPath: '/my/settings/account/billing/payments/history/$transactionId'
      preLoaderRoute: typeof memberprotectedMySettingsAccountBillingPaymentsHistoryTransactionIdRouteImport
      parentRoute: typeof memberprotectedMySettingsAccountBillingPaymentsRoute
    }
    '/(member)/(protected)/my/settings/account/billing/wallet/history_/$walletItemId': {
      id: '/(member)/(protected)/my/settings/account/billing/wallet/history_/$walletItemId'
      path: '/history/$walletItemId'
      fullPath: '/my/settings/account/billing/wallet/history/$walletItemId'
      preLoaderRoute: typeof memberprotectedMySettingsAccountBillingWalletHistoryWalletItemIdRouteImport
      parentRoute: typeof memberprotectedMySettingsAccountBillingWalletRoute
    }
  }
}

interface errorRouteRouteChildren {
  errorPageForbiddenRoute: typeof errorPageForbiddenRoute
  errorPageNotFoundRoute: typeof errorPageNotFoundRoute
}

const errorRouteRouteChildren: errorRouteRouteChildren = {
  errorPageForbiddenRoute: errorPageForbiddenRoute,
  errorPageNotFoundRoute: errorPageNotFoundRoute,
}

const errorRouteRouteWithChildren = errorRouteRoute._addFileChildren(
  errorRouteRouteChildren,
)

interface meetRouteRouteChildren {
  meetMeetRoomNameRoute: typeof meetMeetRoomNameRoute
  meetMeetJoinRoomNameRoute: typeof meetMeetJoinRoomNameRoute
}

const meetRouteRouteChildren: meetRouteRouteChildren = {
  meetMeetRoomNameRoute: meetMeetRoomNameRoute,
  meetMeetJoinRoomNameRoute: meetMeetJoinRoomNameRoute,
}

const meetRouteRouteWithChildren = meetRouteRoute._addFileChildren(
  meetRouteRouteChildren,
)

interface memberprotectedMyFeedbackRouteChildren {
  memberprotectedMyFeedbackFeedbackIdRoute: typeof memberprotectedMyFeedbackFeedbackIdRoute
  memberprotectedMyFeedbackIndexRoute: typeof memberprotectedMyFeedbackIndexRoute
}

const memberprotectedMyFeedbackRouteChildren: memberprotectedMyFeedbackRouteChildren =
  {
    memberprotectedMyFeedbackFeedbackIdRoute:
      memberprotectedMyFeedbackFeedbackIdRoute,
    memberprotectedMyFeedbackIndexRoute: memberprotectedMyFeedbackIndexRoute,
  }

const memberprotectedMyFeedbackRouteWithChildren =
  memberprotectedMyFeedbackRoute._addFileChildren(
    memberprotectedMyFeedbackRouteChildren,
  )

interface memberprotectedMySettingsAccountBillingPaymentsRouteChildren {
  memberprotectedMySettingsAccountBillingPaymentsPaymentMethodIdRoute: typeof memberprotectedMySettingsAccountBillingPaymentsPaymentMethodIdRoute
  memberprotectedMySettingsAccountBillingPaymentsHistoryRoute: typeof memberprotectedMySettingsAccountBillingPaymentsHistoryRoute
  memberprotectedMySettingsAccountBillingPaymentsIndexRoute: typeof memberprotectedMySettingsAccountBillingPaymentsIndexRoute
  memberprotectedMySettingsAccountBillingPaymentsHistoryTransactionIdRoute: typeof memberprotectedMySettingsAccountBillingPaymentsHistoryTransactionIdRoute
}

const memberprotectedMySettingsAccountBillingPaymentsRouteChildren: memberprotectedMySettingsAccountBillingPaymentsRouteChildren =
  {
    memberprotectedMySettingsAccountBillingPaymentsPaymentMethodIdRoute:
      memberprotectedMySettingsAccountBillingPaymentsPaymentMethodIdRoute,
    memberprotectedMySettingsAccountBillingPaymentsHistoryRoute:
      memberprotectedMySettingsAccountBillingPaymentsHistoryRoute,
    memberprotectedMySettingsAccountBillingPaymentsIndexRoute:
      memberprotectedMySettingsAccountBillingPaymentsIndexRoute,
    memberprotectedMySettingsAccountBillingPaymentsHistoryTransactionIdRoute:
      memberprotectedMySettingsAccountBillingPaymentsHistoryTransactionIdRoute,
  }

const memberprotectedMySettingsAccountBillingPaymentsRouteWithChildren =
  memberprotectedMySettingsAccountBillingPaymentsRoute._addFileChildren(
    memberprotectedMySettingsAccountBillingPaymentsRouteChildren,
  )

interface memberprotectedMySettingsAccountBillingWalletRouteChildren {
  memberprotectedMySettingsAccountBillingWalletHistoryRoute: typeof memberprotectedMySettingsAccountBillingWalletHistoryRoute
  memberprotectedMySettingsAccountBillingWalletIndexRoute: typeof memberprotectedMySettingsAccountBillingWalletIndexRoute
  memberprotectedMySettingsAccountBillingWalletHistoryWalletItemIdRoute: typeof memberprotectedMySettingsAccountBillingWalletHistoryWalletItemIdRoute
}

const memberprotectedMySettingsAccountBillingWalletRouteChildren: memberprotectedMySettingsAccountBillingWalletRouteChildren =
  {
    memberprotectedMySettingsAccountBillingWalletHistoryRoute:
      memberprotectedMySettingsAccountBillingWalletHistoryRoute,
    memberprotectedMySettingsAccountBillingWalletIndexRoute:
      memberprotectedMySettingsAccountBillingWalletIndexRoute,
    memberprotectedMySettingsAccountBillingWalletHistoryWalletItemIdRoute:
      memberprotectedMySettingsAccountBillingWalletHistoryWalletItemIdRoute,
  }

const memberprotectedMySettingsAccountBillingWalletRouteWithChildren =
  memberprotectedMySettingsAccountBillingWalletRoute._addFileChildren(
    memberprotectedMySettingsAccountBillingWalletRouteChildren,
  )

interface memberprotectedMySettingsAccountBillingRouteChildren {
  memberprotectedMySettingsAccountBillingPaymentsRoute: typeof memberprotectedMySettingsAccountBillingPaymentsRouteWithChildren
  memberprotectedMySettingsAccountBillingWalletRoute: typeof memberprotectedMySettingsAccountBillingWalletRouteWithChildren
  memberprotectedMySettingsAccountBillingIndexRoute: typeof memberprotectedMySettingsAccountBillingIndexRoute
}

const memberprotectedMySettingsAccountBillingRouteChildren: memberprotectedMySettingsAccountBillingRouteChildren =
  {
    memberprotectedMySettingsAccountBillingPaymentsRoute:
      memberprotectedMySettingsAccountBillingPaymentsRouteWithChildren,
    memberprotectedMySettingsAccountBillingWalletRoute:
      memberprotectedMySettingsAccountBillingWalletRouteWithChildren,
    memberprotectedMySettingsAccountBillingIndexRoute:
      memberprotectedMySettingsAccountBillingIndexRoute,
  }

const memberprotectedMySettingsAccountBillingRouteWithChildren =
  memberprotectedMySettingsAccountBillingRoute._addFileChildren(
    memberprotectedMySettingsAccountBillingRouteChildren,
  )

interface memberprotectedMySettingsRouteChildren {
  memberprotectedMySettingsIndexRoute: typeof memberprotectedMySettingsIndexRoute
  memberprotectedMySettingsAccountBillingRoute: typeof memberprotectedMySettingsAccountBillingRouteWithChildren
  memberprotectedMySettingsAccountNotificationsRoute: typeof memberprotectedMySettingsAccountNotificationsRoute
  memberprotectedMySettingsAccountProfileRoute: typeof memberprotectedMySettingsAccountProfileRoute
  memberprotectedMySettingsAccountSecurityRoute: typeof memberprotectedMySettingsAccountSecurityRoute
  memberprotectedMySettingsHouseholdMembersRoute: typeof memberprotectedMySettingsHouseholdMembersRoute
  memberprotectedMySettingsHouseholdMembershipRoute: typeof memberprotectedMySettingsHouseholdMembershipRoute
  memberprotectedMySettingsAccountInvoicesInvoiceIdRoute: typeof memberprotectedMySettingsAccountInvoicesInvoiceIdRoute
  memberprotectedMySettingsAccountInvoicesIndexRoute: typeof memberprotectedMySettingsAccountInvoicesIndexRoute
}

const memberprotectedMySettingsRouteChildren: memberprotectedMySettingsRouteChildren =
  {
    memberprotectedMySettingsIndexRoute: memberprotectedMySettingsIndexRoute,
    memberprotectedMySettingsAccountBillingRoute:
      memberprotectedMySettingsAccountBillingRouteWithChildren,
    memberprotectedMySettingsAccountNotificationsRoute:
      memberprotectedMySettingsAccountNotificationsRoute,
    memberprotectedMySettingsAccountProfileRoute:
      memberprotectedMySettingsAccountProfileRoute,
    memberprotectedMySettingsAccountSecurityRoute:
      memberprotectedMySettingsAccountSecurityRoute,
    memberprotectedMySettingsHouseholdMembersRoute:
      memberprotectedMySettingsHouseholdMembersRoute,
    memberprotectedMySettingsHouseholdMembershipRoute:
      memberprotectedMySettingsHouseholdMembershipRoute,
    memberprotectedMySettingsAccountInvoicesInvoiceIdRoute:
      memberprotectedMySettingsAccountInvoicesInvoiceIdRoute,
    memberprotectedMySettingsAccountInvoicesIndexRoute:
      memberprotectedMySettingsAccountInvoicesIndexRoute,
  }

const memberprotectedMySettingsRouteWithChildren =
  memberprotectedMySettingsRoute._addFileChildren(
    memberprotectedMySettingsRouteChildren,
  )

interface memberprotectedMyRouteChildren {
  memberprotectedMyBirdieRoute: typeof memberprotectedMyBirdieRoute
  memberprotectedMyCartRoute: typeof memberprotectedMyCartRoute
  memberprotectedMyChatsRoute: typeof memberprotectedMyChatsRoute
  memberprotectedMyDownloadRoute: typeof memberprotectedMyDownloadRoute
  memberprotectedMyDownloadAppRoute: typeof memberprotectedMyDownloadAppRoute
  memberprotectedMyFeedbackRoute: typeof memberprotectedMyFeedbackRouteWithChildren
  memberprotectedMyGlobalSearchRoute: typeof memberprotectedMyGlobalSearchRoute
  memberprotectedMyHelpRoute: typeof memberprotectedMyHelpRoute
  memberprotectedMyHomeRoute: typeof memberprotectedMyHomeRoute
  memberprotectedMyOnboardingRoute: typeof memberprotectedMyOnboardingRoute
  memberprotectedMyRecordsRoute: typeof memberprotectedMyRecordsRoute
  memberprotectedMySettingsRoute: typeof memberprotectedMySettingsRouteWithChildren
  memberprotectedMyVerifyPhoneRoute: typeof memberprotectedMyVerifyPhoneRoute
  memberprotectedMyIndexRoute: typeof memberprotectedMyIndexRoute
  memberprotectedMyCampaignsCampaignSlugRoute: typeof memberprotectedMyCampaignsCampaignSlugRoute
  memberprotectedMyCheckoutCheckoutIdRoute: typeof memberprotectedMyCheckoutCheckoutIdRoute
  memberprotectedMyCheckoutSuccessRoute: typeof memberprotectedMyCheckoutSuccessRoute
  memberprotectedMyListArchivedRoute: typeof memberprotectedMyListArchivedRoute
  memberprotectedMyOrdersOrderIdRoute: typeof memberprotectedMyOrdersOrderIdRoute
  memberprotectedMyOrdersCreateRoute: typeof memberprotectedMyOrdersCreateRoute
  memberprotectedMyPlacesAddRoute: typeof memberprotectedMyPlacesAddRoute
  memberprotectedMyPlacesExistRoute: typeof memberprotectedMyPlacesExistRoute
  memberprotectedMyQuotesQuoteIdRoute: typeof memberprotectedMyQuotesQuoteIdRoute
  memberprotectedMyRequestsSubmitRoute: typeof memberprotectedMyRequestsSubmitRoute
  memberprotectedMyCheckoutIndexRoute: typeof memberprotectedMyCheckoutIndexRoute
  memberprotectedMyListIndexRoute: typeof memberprotectedMyListIndexRoute
  memberprotectedMyPlacesIndexRoute: typeof memberprotectedMyPlacesIndexRoute
}

const memberprotectedMyRouteChildren: memberprotectedMyRouteChildren = {
  memberprotectedMyBirdieRoute: memberprotectedMyBirdieRoute,
  memberprotectedMyCartRoute: memberprotectedMyCartRoute,
  memberprotectedMyChatsRoute: memberprotectedMyChatsRoute,
  memberprotectedMyDownloadRoute: memberprotectedMyDownloadRoute,
  memberprotectedMyDownloadAppRoute: memberprotectedMyDownloadAppRoute,
  memberprotectedMyFeedbackRoute: memberprotectedMyFeedbackRouteWithChildren,
  memberprotectedMyGlobalSearchRoute: memberprotectedMyGlobalSearchRoute,
  memberprotectedMyHelpRoute: memberprotectedMyHelpRoute,
  memberprotectedMyHomeRoute: memberprotectedMyHomeRoute,
  memberprotectedMyOnboardingRoute: memberprotectedMyOnboardingRoute,
  memberprotectedMyRecordsRoute: memberprotectedMyRecordsRoute,
  memberprotectedMySettingsRoute: memberprotectedMySettingsRouteWithChildren,
  memberprotectedMyVerifyPhoneRoute: memberprotectedMyVerifyPhoneRoute,
  memberprotectedMyIndexRoute: memberprotectedMyIndexRoute,
  memberprotectedMyCampaignsCampaignSlugRoute:
    memberprotectedMyCampaignsCampaignSlugRoute,
  memberprotectedMyCheckoutCheckoutIdRoute:
    memberprotectedMyCheckoutCheckoutIdRoute,
  memberprotectedMyCheckoutSuccessRoute: memberprotectedMyCheckoutSuccessRoute,
  memberprotectedMyListArchivedRoute: memberprotectedMyListArchivedRoute,
  memberprotectedMyOrdersOrderIdRoute: memberprotectedMyOrdersOrderIdRoute,
  memberprotectedMyOrdersCreateRoute: memberprotectedMyOrdersCreateRoute,
  memberprotectedMyPlacesAddRoute: memberprotectedMyPlacesAddRoute,
  memberprotectedMyPlacesExistRoute: memberprotectedMyPlacesExistRoute,
  memberprotectedMyQuotesQuoteIdRoute: memberprotectedMyQuotesQuoteIdRoute,
  memberprotectedMyRequestsSubmitRoute: memberprotectedMyRequestsSubmitRoute,
  memberprotectedMyCheckoutIndexRoute: memberprotectedMyCheckoutIndexRoute,
  memberprotectedMyListIndexRoute: memberprotectedMyListIndexRoute,
  memberprotectedMyPlacesIndexRoute: memberprotectedMyPlacesIndexRoute,
}

const memberprotectedMyRouteWithChildren =
  memberprotectedMyRoute._addFileChildren(memberprotectedMyRouteChildren)

interface memberprotectedRouteRouteChildren {
  memberprotectedMyRoute: typeof memberprotectedMyRouteWithChildren
}

const memberprotectedRouteRouteChildren: memberprotectedRouteRouteChildren = {
  memberprotectedMyRoute: memberprotectedMyRouteWithChildren,
}

const memberprotectedRouteRouteWithChildren =
  memberprotectedRouteRoute._addFileChildren(memberprotectedRouteRouteChildren)

interface memberpublicJoinRouteChildren {
  memberpublicJoinSignUpRoute: typeof memberpublicJoinSignUpRoute
  memberpublicJoinVerifyRoute: typeof memberpublicJoinVerifyRoute
  memberpublicJoinIndexRoute: typeof memberpublicJoinIndexRoute
}

const memberpublicJoinRouteChildren: memberpublicJoinRouteChildren = {
  memberpublicJoinSignUpRoute: memberpublicJoinSignUpRoute,
  memberpublicJoinVerifyRoute: memberpublicJoinVerifyRoute,
  memberpublicJoinIndexRoute: memberpublicJoinIndexRoute,
}

const memberpublicJoinRouteWithChildren =
  memberpublicJoinRoute._addFileChildren(memberpublicJoinRouteChildren)

interface memberpublicInviteTokenRouteChildren {
  memberpublicInviteTokenSignUpRoute: typeof memberpublicInviteTokenSignUpRoute
  memberpublicInviteTokenSuccessRoute: typeof memberpublicInviteTokenSuccessRoute
  memberpublicInviteTokenVerifyRoute: typeof memberpublicInviteTokenVerifyRoute
  memberpublicInviteTokenIndexRoute: typeof memberpublicInviteTokenIndexRoute
}

const memberpublicInviteTokenRouteChildren: memberpublicInviteTokenRouteChildren =
  {
    memberpublicInviteTokenSignUpRoute: memberpublicInviteTokenSignUpRoute,
    memberpublicInviteTokenSuccessRoute: memberpublicInviteTokenSuccessRoute,
    memberpublicInviteTokenVerifyRoute: memberpublicInviteTokenVerifyRoute,
    memberpublicInviteTokenIndexRoute: memberpublicInviteTokenIndexRoute,
  }

const memberpublicInviteTokenRouteWithChildren =
  memberpublicInviteTokenRoute._addFileChildren(
    memberpublicInviteTokenRouteChildren,
  )

interface memberRouteRouteChildren {
  memberprotectedRouteRoute: typeof memberprotectedRouteRouteWithChildren
  memberpublicJoinRoute: typeof memberpublicJoinRouteWithChildren
  memberpublicInviteTokenRoute: typeof memberpublicInviteTokenRouteWithChildren
  memberpublicPresaleSplatRoute: typeof memberpublicPresaleSplatRoute
  memberpublicPublicOrdersOrderIdRoute: typeof memberpublicPublicOrdersOrderIdRoute
}

const memberRouteRouteChildren: memberRouteRouteChildren = {
  memberprotectedRouteRoute: memberprotectedRouteRouteWithChildren,
  memberpublicJoinRoute: memberpublicJoinRouteWithChildren,
  memberpublicInviteTokenRoute: memberpublicInviteTokenRouteWithChildren,
  memberpublicPresaleSplatRoute: memberpublicPresaleSplatRoute,
  memberpublicPublicOrdersOrderIdRoute: memberpublicPublicOrdersOrderIdRoute,
}

const memberRouteRouteWithChildren = memberRouteRoute._addFileChildren(
  memberRouteRouteChildren,
)

interface payRouteRouteChildren {
  payPayTokenRoute: typeof payPayTokenRoute
}

const payRouteRouteChildren: payRouteRouteChildren = {
  payPayTokenRoute: payPayTokenRoute,
}

const payRouteRouteWithChildren = payRouteRoute._addFileChildren(
  payRouteRouteChildren,
)

interface AdminLocationsRouteChildren {
  AdminLocationsCreateRoute: typeof AdminLocationsCreateRoute
}

const AdminLocationsRouteChildren: AdminLocationsRouteChildren = {
  AdminLocationsCreateRoute: AdminLocationsCreateRoute,
}

const AdminLocationsRouteWithChildren = AdminLocationsRoute._addFileChildren(
  AdminLocationsRouteChildren,
)

interface AdminUsersManagersRouteChildren {
  AdminUsersManagersCreateRoute: typeof AdminUsersManagersCreateRoute
}

const AdminUsersManagersRouteChildren: AdminUsersManagersRouteChildren = {
  AdminUsersManagersCreateRoute: AdminUsersManagersCreateRoute,
}

const AdminUsersManagersRouteWithChildren =
  AdminUsersManagersRoute._addFileChildren(AdminUsersManagersRouteChildren)

interface AdminUsersMembersRouteChildren {
  AdminUsersMembersCreateRoute: typeof AdminUsersMembersCreateRoute
}

const AdminUsersMembersRouteChildren: AdminUsersMembersRouteChildren = {
  AdminUsersMembersCreateRoute: AdminUsersMembersCreateRoute,
}

const AdminUsersMembersRouteWithChildren =
  AdminUsersMembersRoute._addFileChildren(AdminUsersMembersRouteChildren)

interface AdminUsersTechniciansRouteChildren {
  AdminUsersTechniciansCreateRoute: typeof AdminUsersTechniciansCreateRoute
}

const AdminUsersTechniciansRouteChildren: AdminUsersTechniciansRouteChildren = {
  AdminUsersTechniciansCreateRoute: AdminUsersTechniciansCreateRoute,
}

const AdminUsersTechniciansRouteWithChildren =
  AdminUsersTechniciansRoute._addFileChildren(
    AdminUsersTechniciansRouteChildren,
  )

interface AdminRouteRouteChildren {
  AdminGlobalBirdieChatRoute: typeof AdminGlobalBirdieChatRoute
  AdminLocationsRoute: typeof AdminLocationsRouteWithChildren
  AdminServiceAreasRoute: typeof AdminServiceAreasRoute
  AdminIndexRoute: typeof AdminIndexRoute
  AdminAuthorizationRoleKeyRoute: typeof AdminAuthorizationRoleKeyRoute
  AdminAuthorizationCreateRoute: typeof AdminAuthorizationCreateRoute
  AdminCampaignsCampaignIdRoute: typeof AdminCampaignsCampaignIdRoute
  AdminCampaignsCreateRoute: typeof AdminCampaignsCreateRoute
  AdminCheckoutLinksCreateRoute: typeof AdminCheckoutLinksCreateRoute
  AdminCustomersCustomerIdRoute: typeof AdminCustomersCustomerIdRoute
  AdminCustomersCreateRoute: typeof AdminCustomersCreateRoute
  AdminSubscriptionsCreateRoute: typeof AdminSubscriptionsCreateRoute
  AdminUsersCreateRoute: typeof AdminUsersCreateRoute
  AdminUsersManagersRoute: typeof AdminUsersManagersRouteWithChildren
  AdminUsersMembersRoute: typeof AdminUsersMembersRouteWithChildren
  AdminUsersTechniciansRoute: typeof AdminUsersTechniciansRouteWithChildren
  AdminVisitsAvailableTimeSlotsRoute: typeof AdminVisitsAvailableTimeSlotsRoute
  AdminAccountsIndexRoute: typeof AdminAccountsIndexRoute
  AdminAuthorizationIndexRoute: typeof AdminAuthorizationIndexRoute
  AdminCampaignsIndexRoute: typeof AdminCampaignsIndexRoute
  AdminCheckoutLinksIndexRoute: typeof AdminCheckoutLinksIndexRoute
  AdminCustomersIndexRoute: typeof AdminCustomersIndexRoute
  AdminHomecarePlanProposalsIndexRoute: typeof AdminHomecarePlanProposalsIndexRoute
  AdminPurchaseIntentsIndexRoute: typeof AdminPurchaseIntentsIndexRoute
  AdminSubscriptionsIndexRoute: typeof AdminSubscriptionsIndexRoute
  AdminTagsIndexRoute: typeof AdminTagsIndexRoute
  AdminUsersIndexRoute: typeof AdminUsersIndexRoute
  AdminVisitsIndexRoute: typeof AdminVisitsIndexRoute
}

const AdminRouteRouteChildren: AdminRouteRouteChildren = {
  AdminGlobalBirdieChatRoute: AdminGlobalBirdieChatRoute,
  AdminLocationsRoute: AdminLocationsRouteWithChildren,
  AdminServiceAreasRoute: AdminServiceAreasRoute,
  AdminIndexRoute: AdminIndexRoute,
  AdminAuthorizationRoleKeyRoute: AdminAuthorizationRoleKeyRoute,
  AdminAuthorizationCreateRoute: AdminAuthorizationCreateRoute,
  AdminCampaignsCampaignIdRoute: AdminCampaignsCampaignIdRoute,
  AdminCampaignsCreateRoute: AdminCampaignsCreateRoute,
  AdminCheckoutLinksCreateRoute: AdminCheckoutLinksCreateRoute,
  AdminCustomersCustomerIdRoute: AdminCustomersCustomerIdRoute,
  AdminCustomersCreateRoute: AdminCustomersCreateRoute,
  AdminSubscriptionsCreateRoute: AdminSubscriptionsCreateRoute,
  AdminUsersCreateRoute: AdminUsersCreateRoute,
  AdminUsersManagersRoute: AdminUsersManagersRouteWithChildren,
  AdminUsersMembersRoute: AdminUsersMembersRouteWithChildren,
  AdminUsersTechniciansRoute: AdminUsersTechniciansRouteWithChildren,
  AdminVisitsAvailableTimeSlotsRoute: AdminVisitsAvailableTimeSlotsRoute,
  AdminAccountsIndexRoute: AdminAccountsIndexRoute,
  AdminAuthorizationIndexRoute: AdminAuthorizationIndexRoute,
  AdminCampaignsIndexRoute: AdminCampaignsIndexRoute,
  AdminCheckoutLinksIndexRoute: AdminCheckoutLinksIndexRoute,
  AdminCustomersIndexRoute: AdminCustomersIndexRoute,
  AdminHomecarePlanProposalsIndexRoute: AdminHomecarePlanProposalsIndexRoute,
  AdminPurchaseIntentsIndexRoute: AdminPurchaseIntentsIndexRoute,
  AdminSubscriptionsIndexRoute: AdminSubscriptionsIndexRoute,
  AdminTagsIndexRoute: AdminTagsIndexRoute,
  AdminUsersIndexRoute: AdminUsersIndexRoute,
  AdminVisitsIndexRoute: AdminVisitsIndexRoute,
}

const AdminRouteRouteWithChildren = AdminRouteRoute._addFileChildren(
  AdminRouteRouteChildren,
)

interface BirdieRouteRouteChildren {
  BirdieIndexRoute: typeof BirdieIndexRoute
  BirdieSessionsSessionIdRoute: typeof BirdieSessionsSessionIdRoute
  BirdieSessionsIndexRoute: typeof BirdieSessionsIndexRoute
}

const BirdieRouteRouteChildren: BirdieRouteRouteChildren = {
  BirdieIndexRoute: BirdieIndexRoute,
  BirdieSessionsSessionIdRoute: BirdieSessionsSessionIdRoute,
  BirdieSessionsIndexRoute: BirdieSessionsIndexRoute,
}

const BirdieRouteRouteWithChildren = BirdieRouteRoute._addFileChildren(
  BirdieRouteRouteChildren,
)

interface DocumentRouteRouteChildren {
  DocumentSlugRoute: typeof DocumentSlugRoute
  DocumentIndexRoute: typeof DocumentIndexRoute
}

const DocumentRouteRouteChildren: DocumentRouteRouteChildren = {
  DocumentSlugRoute: DocumentSlugRoute,
  DocumentIndexRoute: DocumentIndexRoute,
}

const DocumentRouteRouteWithChildren = DocumentRouteRoute._addFileChildren(
  DocumentRouteRouteChildren,
)

interface OfficeRouteRouteChildren {
  OfficeConnectGgCalendarRoute: typeof OfficeConnectGgCalendarRoute
  OfficeGlobalBirdieChatRoute: typeof OfficeGlobalBirdieChatRoute
  OfficeGlobalSearchRoute: typeof OfficeGlobalSearchRoute
  OfficeInboxRoute: typeof OfficeInboxRoute
  OfficeManageAccountRoute: typeof OfficeManageAccountRoute
  OfficeQuotesRoute: typeof OfficeQuotesRoute
  OfficeSearchRoute: typeof OfficeSearchRoute
  OfficeIndexRoute: typeof OfficeIndexRoute
  OfficeBillingTodoRoute: typeof OfficeBillingTodoRoute
  OfficeCatalogNewCatalogItemIdRoute: typeof OfficeCatalogNewCatalogItemIdRoute
  OfficeOrdersOrderIdRoute: typeof OfficeOrdersOrderIdRoute
  OfficeOrdersActiveRoute: typeof OfficeOrdersActiveRoute
  OfficeOrdersAllRoute: typeof OfficeOrdersAllRoute
  OfficeOrdersCreateRoute: typeof OfficeOrdersCreateRoute
  OfficeOrdersFutureRoute: typeof OfficeOrdersFutureRoute
  OfficeOrdersWorkflowRoute: typeof OfficeOrdersWorkflowRoute
  OfficePlacesPlaceIdRoute: typeof OfficePlacesPlaceIdRoute
  OfficePlacesActiveRoute: typeof OfficePlacesActiveRoute
  OfficePlacesAllRoute: typeof OfficePlacesAllRoute
  OfficePlacesCreateRoute: typeof OfficePlacesCreateRoute
  OfficeReportsAiFeedbackRoute: typeof OfficeReportsAiFeedbackRoute
  OfficeReportsConfirmedChurnRoute: typeof OfficeReportsConfirmedChurnRoute
  OfficeReportsHomecareRenewalsRoute: typeof OfficeReportsHomecareRenewalsRoute
  OfficeReportsMemberActivationRoute: typeof OfficeReportsMemberActivationRoute
  OfficeReportsOneOffRevenueRoute: typeof OfficeReportsOneOffRevenueRoute
  OfficeReportsOrderOverviewRoute: typeof OfficeReportsOrderOverviewRoute
  OfficeReportsRevenueRoute: typeof OfficeReportsRevenueRoute
  OfficeReportsVendorScorecardRoute: typeof OfficeReportsVendorScorecardRoute
  OfficeSmartActionsAccuracyRoute: typeof OfficeSmartActionsAccuracyRoute
  OfficeSmartActionsBoardRoute: typeof OfficeSmartActionsBoardRoute
  OfficeSmartActionsForecastRoute: typeof OfficeSmartActionsForecastRoute
  OfficeSmartActionsLostCostsRoute: typeof OfficeSmartActionsLostCostsRoute
  OfficeTasksCreateRoute: typeof OfficeTasksCreateRoute
  OfficeVendorsCreateRoute: typeof OfficeVendorsCreateRoute
  OfficeVendorsVisitsRoute: typeof OfficeVendorsVisitsRoute
  OfficeCatalogNewIndexRoute: typeof OfficeCatalogNewIndexRoute
  OfficeNotificationsIndexRoute: typeof OfficeNotificationsIndexRoute
  OfficeOrdersIndexRoute: typeof OfficeOrdersIndexRoute
  OfficePlacesIndexRoute: typeof OfficePlacesIndexRoute
  OfficeReportsIndexRoute: typeof OfficeReportsIndexRoute
  OfficeScheduleIndexRoute: typeof OfficeScheduleIndexRoute
  OfficeSmartActionsIndexRoute: typeof OfficeSmartActionsIndexRoute
  OfficeTasksIndexRoute: typeof OfficeTasksIndexRoute
  OfficeVendorsIndexRoute: typeof OfficeVendorsIndexRoute
  OfficeBillingInvoicesIndexRoute: typeof OfficeBillingInvoicesIndexRoute
  OfficePlacesOnboardingIndexRoute: typeof OfficePlacesOnboardingIndexRoute
  OfficeBillingAccountsAccountIdWalletRoute: typeof OfficeBillingAccountsAccountIdWalletRoute
  OfficeBillingInvoicesInvoiceIdEditRoute: typeof OfficeBillingInvoicesInvoiceIdEditRoute
}

const OfficeRouteRouteChildren: OfficeRouteRouteChildren = {
  OfficeConnectGgCalendarRoute: OfficeConnectGgCalendarRoute,
  OfficeGlobalBirdieChatRoute: OfficeGlobalBirdieChatRoute,
  OfficeGlobalSearchRoute: OfficeGlobalSearchRoute,
  OfficeInboxRoute: OfficeInboxRoute,
  OfficeManageAccountRoute: OfficeManageAccountRoute,
  OfficeQuotesRoute: OfficeQuotesRoute,
  OfficeSearchRoute: OfficeSearchRoute,
  OfficeIndexRoute: OfficeIndexRoute,
  OfficeBillingTodoRoute: OfficeBillingTodoRoute,
  OfficeCatalogNewCatalogItemIdRoute: OfficeCatalogNewCatalogItemIdRoute,
  OfficeOrdersOrderIdRoute: OfficeOrdersOrderIdRoute,
  OfficeOrdersActiveRoute: OfficeOrdersActiveRoute,
  OfficeOrdersAllRoute: OfficeOrdersAllRoute,
  OfficeOrdersCreateRoute: OfficeOrdersCreateRoute,
  OfficeOrdersFutureRoute: OfficeOrdersFutureRoute,
  OfficeOrdersWorkflowRoute: OfficeOrdersWorkflowRoute,
  OfficePlacesPlaceIdRoute: OfficePlacesPlaceIdRoute,
  OfficePlacesActiveRoute: OfficePlacesActiveRoute,
  OfficePlacesAllRoute: OfficePlacesAllRoute,
  OfficePlacesCreateRoute: OfficePlacesCreateRoute,
  OfficeReportsAiFeedbackRoute: OfficeReportsAiFeedbackRoute,
  OfficeReportsConfirmedChurnRoute: OfficeReportsConfirmedChurnRoute,
  OfficeReportsHomecareRenewalsRoute: OfficeReportsHomecareRenewalsRoute,
  OfficeReportsMemberActivationRoute: OfficeReportsMemberActivationRoute,
  OfficeReportsOneOffRevenueRoute: OfficeReportsOneOffRevenueRoute,
  OfficeReportsOrderOverviewRoute: OfficeReportsOrderOverviewRoute,
  OfficeReportsRevenueRoute: OfficeReportsRevenueRoute,
  OfficeReportsVendorScorecardRoute: OfficeReportsVendorScorecardRoute,
  OfficeSmartActionsAccuracyRoute: OfficeSmartActionsAccuracyRoute,
  OfficeSmartActionsBoardRoute: OfficeSmartActionsBoardRoute,
  OfficeSmartActionsForecastRoute: OfficeSmartActionsForecastRoute,
  OfficeSmartActionsLostCostsRoute: OfficeSmartActionsLostCostsRoute,
  OfficeTasksCreateRoute: OfficeTasksCreateRoute,
  OfficeVendorsCreateRoute: OfficeVendorsCreateRoute,
  OfficeVendorsVisitsRoute: OfficeVendorsVisitsRoute,
  OfficeCatalogNewIndexRoute: OfficeCatalogNewIndexRoute,
  OfficeNotificationsIndexRoute: OfficeNotificationsIndexRoute,
  OfficeOrdersIndexRoute: OfficeOrdersIndexRoute,
  OfficePlacesIndexRoute: OfficePlacesIndexRoute,
  OfficeReportsIndexRoute: OfficeReportsIndexRoute,
  OfficeScheduleIndexRoute: OfficeScheduleIndexRoute,
  OfficeSmartActionsIndexRoute: OfficeSmartActionsIndexRoute,
  OfficeTasksIndexRoute: OfficeTasksIndexRoute,
  OfficeVendorsIndexRoute: OfficeVendorsIndexRoute,
  OfficeBillingInvoicesIndexRoute: OfficeBillingInvoicesIndexRoute,
  OfficePlacesOnboardingIndexRoute: OfficePlacesOnboardingIndexRoute,
  OfficeBillingAccountsAccountIdWalletRoute:
    OfficeBillingAccountsAccountIdWalletRoute,
  OfficeBillingInvoicesInvoiceIdEditRoute:
    OfficeBillingInvoicesInvoiceIdEditRoute,
}

const OfficeRouteRouteWithChildren = OfficeRouteRoute._addFileChildren(
  OfficeRouteRouteChildren,
)

interface VendorsOnboardingV1RouteRouteChildren {
  VendorsOnboardingV1Step0WelcomeRoute: typeof VendorsOnboardingV1Step0WelcomeRoute
  VendorsOnboardingV1Step1BusinessInfoRoute: typeof VendorsOnboardingV1Step1BusinessInfoRoute
  VendorsOnboardingV1Step2LegalComplianceRoute: typeof VendorsOnboardingV1Step2LegalComplianceRoute
  VendorsOnboardingV1Step3ServiceTermRoute: typeof VendorsOnboardingV1Step3ServiceTermRoute
  VendorsOnboardingV1Step4AddTechnicianRoute: typeof VendorsOnboardingV1Step4AddTechnicianRoute
  VendorsOnboardingV1Step5ReviewInformationRoute: typeof VendorsOnboardingV1Step5ReviewInformationRoute
  VendorsOnboardingV1StepFinalSubmitRoute: typeof VendorsOnboardingV1StepFinalSubmitRoute
}

const VendorsOnboardingV1RouteRouteChildren: VendorsOnboardingV1RouteRouteChildren =
  {
    VendorsOnboardingV1Step0WelcomeRoute: VendorsOnboardingV1Step0WelcomeRoute,
    VendorsOnboardingV1Step1BusinessInfoRoute:
      VendorsOnboardingV1Step1BusinessInfoRoute,
    VendorsOnboardingV1Step2LegalComplianceRoute:
      VendorsOnboardingV1Step2LegalComplianceRoute,
    VendorsOnboardingV1Step3ServiceTermRoute:
      VendorsOnboardingV1Step3ServiceTermRoute,
    VendorsOnboardingV1Step4AddTechnicianRoute:
      VendorsOnboardingV1Step4AddTechnicianRoute,
    VendorsOnboardingV1Step5ReviewInformationRoute:
      VendorsOnboardingV1Step5ReviewInformationRoute,
    VendorsOnboardingV1StepFinalSubmitRoute:
      VendorsOnboardingV1StepFinalSubmitRoute,
  }

const VendorsOnboardingV1RouteRouteWithChildren =
  VendorsOnboardingV1RouteRoute._addFileChildren(
    VendorsOnboardingV1RouteRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  errorRouteRoute: errorRouteRouteWithChildren,
  meetRouteRoute: meetRouteRouteWithChildren,
  memberRouteRoute: memberRouteRouteWithChildren,
  payRouteRoute: payRouteRouteWithChildren,
  AdminRouteRoute: AdminRouteRouteWithChildren,
  BirdieRouteRoute: BirdieRouteRouteWithChildren,
  DocumentRouteRoute: DocumentRouteRouteWithChildren,
  OfficeRouteRoute: OfficeRouteRouteWithChildren,
  authActivateRoute: authActivateRoute,
  authAutoSignInRoute: authAutoSignInRoute,
  authForgotPasswordRoute: authForgotPasswordRoute,
  authForgotPasswordOtpRoute: authForgotPasswordOtpRoute,
  authResetPasswordRoute: authResetPasswordRoute,
  authResetPasswordInvalidRoute: authResetPasswordInvalidRoute,
  authResetPasswordSuccessRoute: authResetPasswordSuccessRoute,
  authSignInRoute: authSignInRoute,
  authSignInImRoute: authSignInImRoute,
  authSignInOtpRoute: authSignInOtpRoute,
  authSignInPasswordRoute: authSignInPasswordRoute,
  devMediaV3UploadRoute: devMediaV3UploadRoute,
  CustomAppMigateToQuoteRoute: CustomAppMigateToQuoteRoute,
  CustomAppMigrateToQuoteRoute: CustomAppMigrateToQuoteRoute,
  HomecareProposalProposalIdRoute: HomecareProposalProposalIdRoute,
  VLinkCodeRoute: VLinkCodeRoute,
  VendorsOnboardingV1RouteRoute: VendorsOnboardingV1RouteRouteWithChildren,
  devThemesIndexRoute: devThemesIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
